export default {
    "Project-Id-Version": "",
    "POT-Creation-Date": "2026-02-25T21:26:27.749Z",
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Poedit 3.5",
    "PO-Revision-Date": "2026-02-25 22:31+0100",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "hu-HU",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        " - klient http z następującymi metodami:": "",
        " - powoduje wywołanie akcji jako użytkownik systemowy": "",
        " - pozwala na wyciąganie wszystkich serwisów": "",
        " - tablica ze wszystkimi akcjami procesu": "",
        " - tablica ze wszystkimi akcjami procesu (tylko dla skryptów timerowych)": "",
        " - ustawia ciało zapytania jako przekazany obiekt": "",
        " - ustawia endpointa na określony url z wybraną metodą HTTP": "",
        " - wysyła zapytanie i zwraca odpowiedź": "",
        " - zawiera dane dokumentu sprzed zapisu formularza w takim samym formacie jak document": "",
        " - zawiera pole BaseUrl z nazwą licencji w postaci, w jakiej trafia do url": "",
        " - zawiera pole PublicId oraz DbData, które jest słownikiem zawierającym wszystkie indeksowane pola dokumentu": "",
        " - zawiera pole PublicId oraz DbDataDynamic, które jest słownikiem zawierającym wszystkie indeksowane pola dokumentu": "",
        " - zawiera pole value z id aktualnego procesu": "",
        "...": "...",
        "' + file.filename + '": "",
        "' + func.name + '": "",
        "“Po potwierdzeniu wybrani użytkownicy całkowicie utracą dostęp do dokumentu. Czy chcesz kontynuować?": "",
        "(Przekroczyłeś limit aktywnych kont użytkowników, skontaktuj się z dostawcą systemu w celu zmiany warunków licencji)": "(Túllépte az aktív felhasználói fiókok számának korlátját. Vegye fel a kapcsolatot a rendszer szolgáltatójával a licencfeltételek módosítása érdekében.)",
        "%0": "%0",
        "%0 wyniki": "",
        "%0 wyników": "",
        "%0 z %1": "%0 / %1",
        "%0 znaków": "%0 karakter",
        "+3 dni": "+3 nap",
        "<Brak nazwy>": "<Nincs név>",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "${copied ? 'Másolva' : 'Másolás'}",
        "${el.text}": "${el.text}",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "${form.variants > 1 ? 'Képek generálása' : 'Kép generálása'}",
        "${getCurrentScope().label}": "${getCurrentScope().label}",
        "${item.entityName}": "${item.entityName}",
        "${item.text}": "${item.text}",
        "${item.value}": "${item.value}",
        "${loading ? 'Ładowanie elementów...' : 'Nie znaleziono żadnych elementów.'}": "${loading ? 'Elemek betöltése...' : 'Nem található elem.'}",
        "${props.inputPlaceholder}": "${props.inputPlaceholder}",
        "${str}": "${str}",
        "${text}": "${text}",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "${tokenVisibility ? 'Elrejtés' : 'Megjelenítés'} token",
        "1 godzina": "1 óra",
        "1 wynik": "",
        "1:1": "1:1",
        "10 minut": "10 perc",
        "12 godzin": "12 óra",
        "15 minut": "15 perc",
        "2 dni": "2 nap",
        "2 miesiące": "2 hónap",
        "2 tygodnie": "2 hét",
        "24 godziny": "24 óra",
        "3 dni": "3 nap",
        "3 godziny": "3 óra",
        "3 miesiące": "3 hónap",
        "30 minut": "30 perc",
        "4 dni": "4 nap",
        "4:7": "4:7",
        "5 dni": "5 nap",
        "5 minut": "5 perc",
        "6 dni": "6 nap",
        "6 godzin": "6 óra",
        "7:4": "7:4",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "A csapat tagok hozzáadásához először el kell mentenie az űrlapot.",
        "Aby dodawać linie do szablonu musisz najpierw zapisać formularz.": "",
        "Aby edytować tylko bieżącą wersję roboczą utwórz nową wersję procesu": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Aby podpisać dokument zaloguj się do usługi mSzafir klikając przycisk poniżej.": "",
        "Aby podpisać dokument zaloguj się do usługi SimplySign klikając przycisk poniżej.": "",
        "Aby sprawdzić strukturę danych, które powinny zostać przekazane do importu, pobierz przykładowy plik przyciskiem \"Pobierz szablon\"": "",
        "Aby system przyjął zapytanie akcji systemowej, należy wysłać klucz systemowy w nagłówku Authorization": "",
        "Aby system przyjął zapytanie do webhooka, należy wysłać klucz systemowy w nagłówku Authorization": "",
        "Aby uzyskać klucz systemowy, skontaktuj się z administratorem systemu.": "",
        "Aby zawężyć wybór terminów dostępnych na liście możesz wyfiltrować wpisy na podstawie pól formularza zdefiniowanych w definicji słownika.": "",
        "Aby zobaczyć aktualny podgląd szablonu musisz go zapisać": "",
        "Adaptive sampling": "",
        "Administracja": "Adminisztráció",
        "Administracja - Kraje": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Zespoły": "",
        "Administratorzy": "Adminisztrátorok",
        "Adres": "Cím",
        "Adres do eDoręczeń: ": "",
        "Adres domenowy": "Domain cím",
        "Adres e-mail": "E-mail cím",
        "Adres e-mail potwierdzony": "E-mail cím megerősítve",
        "Adres email": "E-mail cím",
        "Adres email nadawcy": "Feladó e-mail címe",
        "Adres IP": "IP cím",
        "Adres IP: %0": "IP cím: %0",
        "Adres korespądencyjny: ": "",
        "Adres serwera": "Szerver címe",
        "Adres siedziby: ": "",
        "Adres URL": "URL cím",
        "Akcent": "",
        "Akceptacja": "Elfogadás",
        "Akceptacja dokumentów": "",
        "Akceptacja dokumentu": "",
        "Akceptacja własnych dokumentów": "",
        "Akceptacja wszystkich dokumentów": "",
        "Akceptant do zastąpienia": "",
        "Akceptowany format danych": "",
        "Akceptuj": "Elfogad",
        "Akcja": "Akció",
        "Akcja systemowa": "",
        "Akcja wykonana pomyślnie": "A művelet sikeresen végrehajtva",
        "Akcje": "Akciók",
        "Akcje administracyjne": "Adminisztrációs műveletek",
        "Akcje zostały zapisane": "A műveletek elmentve",
        "Aktualizacja: {0}": "Frissítés: {0}",
        "Aktualizuj": "Frissítés",
        "Aktualna sesja": "Jelenlegi munkamenet",
        "Aktualne hasło": "Jelenlegi jelszó",
        "Aktualne urządzenie": "Jelenlegi eszköz",
        "Aktywna": "Aktív",
        "Aktywna do": "Aktív eddig",
        "Aktywne": "Aktív",
        "Aktywne kanały komunikacji": "Aktív kommunikációs csatornák",
        "Aktywne sesje": "Aktív munkamenetek",
        "Aktywne źródła": "Aktív források",
        "Aktywni": "Aktívak",
        "Aktywność": "Aktivitás",
        "Aktywny": "Aktív",
        "Aktywny filtr:": "Aktív szűrő:",
        "Aktywnych kont": "Aktív fiókok",
        "Aktywuj OCR": "OCR aktiválása",
        "Aktywuj tłumaczenia": "Fordítások aktiválása",
        "Aktywuj zestaw inteligentnych narzędzi": "Intelligens eszközkészlet aktiválása",
        "Alert": "Figyelmeztetés",
        "Alias": "Álnév",
        "Alias może zawierać tylko znaki alfanumeryczne oraz znak podkreślenia": "Az álnév csak alfanumerikus karaktereket és aláhúzást tartalmazhat",
        "Alias został przepięty.": "Az álnév átirányítva.",
        "Analizuję typ i kategorię dokumentu...": "Elemzem a dokumentum típusát és kategóriáját...",
        "aneks": "",
        "Angielski": "Angol",
        "Ankieta": "Kérdőív",
        "Anonimizacja kontrahenta rozpoczęta. W zależności od ilości dokumentów proces ten może potrwać do kilkunastu minut.": "A partner anonimizálása elindult. A dokumentumok számától függően a folyamat akár több percig is eltarthat.",
        "Anonimizuj": "Anonimizálás",
        "Anonimizuj dane osobowe": "Személyes adatok anonimizálása",
        "Anonimowy": "Névtelen",
        "Anuluj": "Mégse",
        "Aplikacja": "Alkalmazás",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "Az alkalmazás legfeljebb 60 másodpercen belül újraindul.",
        "App ID": "App azonosító",
        "App Secret": "App titok",
        "application/json": "application/json",
        "application/x-www-form-urlencoded": "application/x-www-form-urlencoded",
        "Archiwizuj przez maksymalnie (dni)": "Archiválás maximum (nap)",
        "Argument": "Argumentum",
        "Asystent": "Asszisztens",
        "Asystent AI": "AI asszisztens",
        "Asystent został dodany.": "Az asszisztens hozzáadva.",
        "Asystent został zaktualizowany.": "Az asszisztens frissítve.",
        "Asystenta AI": "AI asszisztens",
        "Autentykacja SimplySign": "",
        "Automatyzacja": "Automatizálás",
        "Autor": "Szerző",
        "Autor dokumentu": "A dokumentum szerzője",
        "Azure AI": "Azure AI",
        "Azure AI Vision": "Azure AI Vision",
        "Azure Application Insights": "Azure Application Insights",
        "Azure OpenAI": "Azure OpenAI",
        "Basic Auth": "Alapvető hitelesítés",
        "Baza danych": "Adatbázis",
        "Baza danych tego klienta jest nieaktualna.": "Ennek az ügyfélnek az adatbázisa elavult.",
        "Bazy danych": "Adatbázisok",
        "Bez formularza": "Űrlap nélkül",
        "Bezpieczeństwo": "Biztonság",
        "Bezpieczne połączenie SSL": "Biztonságos SSL kapcsolat",
        "Bezpośrednio do członków wybranej grupy (np. działu)": "",
        "Bierz pod uwagę dokumenty powiązane po polu:": "",
        "Bieżący dokument": "Aktuális dokumentum",
        "Biuro": "Iroda",
        "Blokada konta": "Fiók zárolása",
        "Blokowanie kont": "Fiókok zárolása",
        "Blokuj akcje na wybranym dokumencie podczas wykonania akcji grupowych": "",
        "Blokująca": "Blokkoló",
        "Błąd": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "404-es hiba. A kért erőforrás nem található.",
        "Błąd podczas eksportowania": "Hiba exportálás közben",
        "Błąd podczas generowania dokumentu": "Hiba a dokumentum generálása közben",
        "Błąd podczas oznaczania jako nieodczytany": "Hiba a megjelölésnél, mint olvasatlan",
        "Błąd podczas pobierania": "Hiba a letöltés közben",
        "Błąd podczas pobierania danych": "Hiba az adatok letöltése közben",
        "Błąd podczas pobierania listy": "Hiba a lista letöltése közben",
        "Błąd podczas pobierania schematu": "Hiba a séma letöltése közben",
        "Błąd podczas pobierania szczegółów": "Hiba a részletek letöltése közben",
        "Błąd podczas pobierania udostępnionych dokumentów": "Hiba a megosztott dokumentumok letöltése közben",
        "Błąd podczas pobierania użytkownika": "Hiba a felhasználó letöltése közben",
        "Błąd podczas renderowania PDF": "Hiba a PDF renderelése közben",
        "Błąd podczas rezerwacji": "Hiba a foglalás közben",
        "Błąd podczas wykonywania akcji": "Hiba a művelet végrehajtása közben",
        "Błąd podczas zatrzymywania udostępniania": "Hiba a megosztás leállítása közben",
        "Błąd walidacji": "Érvényesítési hiba",
        "Błędne": "Hibás",
        "Błędny": "Hibás",
        "Błędy": "Hibák",
        "Błędy podczas wykonywania akcji": "Hibák a művelet végrehajtása közben",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "",
        "Brak": "Nincs",
        "Brak akcji": "Nincs művelet",
        "Brak aktualności do wyświetlenia": "Nincs megjeleníthető hír",
        "Brak aktywnego filtru": "Nincs aktív szűrő",
        "Brak błędów do wyświetlenia": "Nincs megjeleníthető hiba",
        "Brak cennika dla wybranego dostawcy.": "Nincs árlista a kiválasztott szolgáltatóhoz.",
        "Brak danych": "Nincs adat",
        "Brak danych dla wykresu": "Nincs adat a diagramhoz",
        "Brak danych do wyświetlenia": "Nincs megjeleníthető adat",
        "Brak danych do wyświetlenia wykresu": "Nincs megjeleníthető adat a diagramhoz",
        "Brak dodanych kolumn": "Nincsenek hozzáadott oszlopok",
        "Brak dostępnych akcji": "Nincs elérhető művelet",
        "Brak działu nadrzędnego": "Nincs felsőbb osztály",
        "Brak elementów": "Nincs elem",
        "Brak informacji o pochodzeniu uprawnienia": "Nincs információ a jogosultság eredetéről",
        "Brak kluczy": "Nincs kulcs",
        "Brak kolekcji": "Nincs gyűjtemény",
        "Brak kolumn": "Nincsenek oszlopok",
        "Brak kolumn numerycznych": "",
        "Brak limitu": "Nincs korlát",
        "Brak logów do wyświetlenia": "Nincs megjeleníthető napló",
        "Brak nazwy": "Nincs név",
        "Brak nowych powiadomień.": "Nincs új értesítés.",
        "Brak odpowiedzi": "Nincs válasz",
        "Brak opcji": "Nincs lehetőség",
        "Brak pracowników w danym dziale": "Nincs munkavállaló ebben az osztályban",
        "Brak przesyłki": "Nincs küldemény",
        "Brak wartości wyświetlanej": "Nincs megjeleníthető érték",
        "Brak wersji": "Nincs elérhető verzió",
        "Brak wpisów": "Nincs bejegyzés",
        "Brak wyboru": "Nincs választás",
        "Brak wymaganych danych": "Nincsenek szükséges adatok",
        "Brak wyników": "Nincs találat",
        "Brak wyników wyszukiwania": "Nincs találat",
        "Brak wyników!": "Nincs találat!",
        "Brak załączników": "Nincs melléklet",
        "Brak zdefiniowanych ról.": "Nincsenek definiált szerepkörök.",
        "Brak zdefiniowanych zespołów.": "Nincsenek definiált csapatok.",
        "Bramka SMS": "SMS kapu",
        "Budżet": "Költségvetés",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "A gyorsítótár a Redis szerveren lesz tárolva.",
        "Cache po stronie serwera": "Szerver oldali gyorsítótár",
        "Cache-Control": "Cache-Control",
        "Całkowita ilość do importu:": "Teljes import mennyiség:",
        "Cel aktywny": "Aktív cél",
        "Cel został dodany.": "A cél hozzáadva.",
        "cel został usunięty.": "A cél törölve.",
        "Cel został zaktualizowany.": "A cél frissítve.",
        "Cele": "Célok",
        "Cena": "Ár",
        "Cena w dolarach sumy tokenów wejściowych i wyjściowych.": "Az ár a be- és kimenő tokenek összegének dollárban.",
        "Cennik Azure OpenAI": "Azure OpenAI árlista",
        "Cennik AzureAI": "AzureAI árlista",
        "Cennik OpenAI": "OpenAI árlista",
        "Centrum powiadomień": "Értesítési központ",
        "Checkbox": "Jelölőnégyzet",
        "Ciemny": "Sötét",
        "Client ID": "Ügyfél azonosító",
        "Client Secret": "Ügyfél titok",
        "co": "minden",
        "Co 10 dni": "10 naponta",
        "Co 10 minut": "10 percenként",
        "Co 12 godzin": "12 óránként",
        "Co 15 minut": "15 percenként",
        "Co 2 godziny": "2 óránként",
        "Co 2 minuty": "2 percenként",
        "Co 2 tygodnie": "Két hetente",
        "Co 20 minut": "20 percenként",
        "Co 3 godziny": "3 óránként",
        "co 3 miesiące": "3 havonta",
        "Co 3 miesiące": "3 havonta",
        "co 30 dni": "30 naponta",
        "Co 30 minut": "30 percenként",
        "Co 4 miesiące": "4 havonta",
        "Co 5 dni": "5 naponta",
        "Co 5 minut": "5 percenként",
        "Co 6 godzin": "6 óránként",
        "co 6 miesięcy": "6 havonta",
        "Co chcesz wygenerować?": "Mit szeretne generálni?",
        "Co drugi dzień": "Minden második nap",
        "Co drugi miesiąc": "Két havonta",
        "Co godzinę": "Minden órában",
        "Co miesiąc": "Minden hónapban",
        "Co minutę": "Minden percben",
        "Co pół roku": "Hat havonta",
        "co rok": "Minden évben",
        "Co tydzień": "Minden héten",
        "Codziennie": "Minden nap",
        "Cofnięto prywatność dokumentu": "A dokumentum privát státusza visszavonva",
        "Cofnij ostatnią operację": "",
        "Connection String": "Kapcsolati karakterlánc",
        "Coś poszło nie tak": "Valami hiba történt",
        "Cron": "Cron",
        "Cyfry": "Számjegyek",
        "Czas": "Idő",
        "Czas dodania": "Hozzáadás ideje",
        "Czas pomiędzy": "Időköz",
        "Czas rozpoczęcia": "Kezdés ideje",
        "Czas trwania (minuty)": "Időtartam (perc)",
        "Czas trwania blokady": "A zárlat időtartama",
        "Czas uruchomienia": "Indítás ideje",
        "Czas zakończenia": "Befejezés ideje",
        "Czat z asystentem": "Csevegés az asszisztenssel",
        "Czerwiec": "Június",
        "Częstotliwość wykonywania (Cron)": "Végrehajtás gyakorisága (Cron)",
        "Członkowie zespołu": "Csapat tagok",
        "Cztery kolumny": "Négy oszlop",
        "Czwartek": "Csütörtök",
        "Czy aby na pewno chesz przywrócić ustawienia domyślne?": "Biztosan visszaállítja az alapértelmezett beállításokat?",
        "Czy aby na pewno chesz zrestartować aplikacje?": "Biztosan újraindítja az alkalmazást?",
        "Czy chcesz ograniczyć dostęp do dokumentu w zastępstwie?": "Szeretné korlátozni a dokumentumhoz való hozzáférést helyettesítés esetén?",
        "Czy chcesz usunąć ograniczenie dostępu do dokumentu w zastępstwie?": "Szeretné eltávolítani a dokumentumhoz való hozzáférés korlátozását helyettesítés esetén?",
        "Czy na pewno chcesz dezaktywować spółkę?": "Biztosan deaktiválja a céget?",
        "Czy na pewno chcesz rozgrupować te pola?": "Biztosan szétválasztja ezeket a mezőket?",
        "Czy na pewno chcesz usunąć filtr": "Biztosan törli a szűrőt?",
        "Czy na pewno chcesz usunąć szablon?": "Biztosan törli a sablont?",
        "Czy na pewno chcesz usunąć tego kontrahenta?": "Biztosan törli ezt a partnert?",
        "Czy na pewno chcesz usunąć ten dokument?": "Biztosan törli ezt a dokumentumot?",
        "Czy na pewno chcesz usunąć ten obiekt?": "Biztosan törli ezt az objektumot?",
        "Czy na pewno chcesz usunąć ten rekord?": "Biztosan törli ezt a rekordot?",
        "Czy na pewno chcesz usunąć ten widget?": "Biztosan törli ezt a widgetet?",
        "Czy na pewno chcesz usunąć to pole wspólne?": "Biztosan törli ezt a közös mezőt?",
        "Czy na pewno chcesz usunąć widget?": "Biztosan törli a widgetet?",
        "Czy na pewno chcesz zanonimizować dane osobowe tego kontrahenta?": "Biztosan anonimizálja ennek a partnernek a személyes adatait?",
        "Czy na pewno chcesz zmienić moduł, wszystkie dane formularza zostaną utracone.": "Biztosan módosítja a modult? Minden űrlapadat elvész.",
        "Czy napewno chcesz usunąć tą zmienną środowiskową?": "Biztosan törli ezt a környezeti változót?",
        "Czy napewno chcesz usunąć ten szablon": "Biztosan törli ezt a sablont?",
        "Czynności": "Műveletek",
        "czynność": "művelet",
        "Czynność": "Művelet",
        "Czynność zostanie wpisana w historii po wznowieniu obiegu": "A művelet a folyamat újraindítása után kerül a naplóba",
        "Dalej": "Tovább",
        "DALL-E 3": "DALL-E 3",
        "Dane": "Adatok",
        "Dane do zapisania": "Mentendő adatok",
        "Dane formularza są przechowywane w obiekcie Entry.": "Az űrlap adatai az Entry objektumban vannak tárolva.",
        "Dane osobowe": "Személyes adatok",
        "Dane podstawowe": "Alapadatok",
        "Dane tabeli przechowywane są w obiekcie table": "A táblázat adatai a table objektumban vannak tárolva.",
        "Dane w tabeli": "Adatok a táblázatban",
        "Dane wejściowe": "Bemeneti adatok",
        "Dane wektorowe": "Vektoriális adatok",
        "Dane wyjściowe": "Kimeneti adatok",
        "Dane z tego pola są przechowywane w bazie w szyfrowanej formie": "Az ebből a mezőből származó adatok titkosított formában vannak tárolva az adatbázisban.",
        "Dane, które zwraca skrypt są dopisywane do właściwości dostępnych w zmiennej <b>@Model</b> w szablonie. Z tego względu skrypt musi zwracać słownik typu <b>Dictionary&amp;lt;string, object&amp;gt;</b>": "",
        "danger": "veszély",
        "dark": "",
        "Darmowe środowisko OpenJDK można pobrać i zainstalować ze strony": "",
        "Data": "Dátum",
        "Data aktywacji": "Aktiválás dátuma",
        "Data anonimizacji": "Anonimizálás dátuma",
        "Data dezaktywacji": "Deaktiválás dátuma",
        "Data do": "Dátumig",
        "Data dodania": "Hozzáadás dátuma",
        "Data dokumentu": "Dokumentum dátuma",
        "Data i czas": "Dátum és idő",
        "Data końcowa": "Befejezés dátuma",
        "Data Kursu": "Árfolyam dátuma",
        "Data modyfikacji": "Módosítás dátuma",
        "Data od": "Dátumtól",
        "Data opuszczenia zespołu": "Csapat elhagyásának dátuma",
        "Data otrzymania": "Beérkezés dátuma",
        "Data powiadomienia": "Értesítés dátuma",
        "Data rejestracji": "Regisztráció dátuma",
        "Data rozpoczęcia": "Kezdés dátuma",
        "Data udostępnienia": "Megosztás dátuma",
        "Data uruchomienia": "Indítás dátuma",
        "Data uruchomienia (UTC)": "Indítás dátuma (UTC)",
        "Data usunięcia": "Törlés dátuma",
        "Data utworzenia": "Létrehozás dátuma",
        "Data utworzenia wersji": "Verzió létrehozásának dátuma",
        "Data utworzenia: ": "Létrehozás dátuma: ",
        "Data użycia": "Felhasználás dátuma",
        "Data wygaśnięcia": "Lejárat dátuma",
        "Data wykonania": "Végrehajtás dátuma",
        "Data wylogowania": "Kijelentkezés dátuma",
        "Data wysyłki": "Küldés dátuma",
        "Data wywołania": "Hívás dátuma",
        "Data zakończenia": "Befejezés dátuma",
        "Data zakończenia blokady konta": "Fiók zárolásának befejezési dátuma",
        "Data zalogowania": "Bejelentkezés dátuma",
        "Data zapoznania": "Megismerés dátuma",
        "Data zapytania": "Lekérdezés dátuma",
        "Data zatrudnienia": "Felvétel dátuma",
        "Data zatrzymania udostępniania": "Megosztás leállításának dátuma",
        "Data zdarzenia": "Esemény dátuma",
        "Data zwolnienia": "Elbocsátás dátuma",
        "Data: %0 | Status: %1": "Dátum: %0 | Állapot: %1",
        "Debug": "Debug",
        "DEBUG OFF": "DEBUG KI",
        "DEBUG ON": "DEBUG BE",
        "Debugger": "Debugger",
        "Dedykowane": "Dedikált",
        "DeepL": "DeepL",
        "Definicja": "Definíció",
        "Definicja (JSON)": "Definíció (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "Az űrlap definíciója a Form objektumban található.",
        "Definicja pól JSON": "Mezők JSON definíciója",
        "Definicję pól zapisujemy jako obiekt JSON, którego klucze to klucze pól formularza, a wartości to obiekty z właściwościami konfigurującymi dane pole.": "",
        "DELETE: Usunięcie wpisu": "DELETE: Bejegyzés törlése",
        "Design Studio": "Design Stúdió",
        "Devexpress": "Devexpress",
        "Dezaktywacja spółki spowoduje trwałe usunięcie powiązania z pracownikami. ": "A cég deaktiválása véglegesen eltávolítja a kapcsolatot a munkavállalókkal.",
        "Dezaktywuj": "Deaktiválás",
        "Diagram": "Diagram",
        "Dla kogo": "Kinek",
        "Dla takiej konfiguracji musimy zwrócić obiekt <b>List&amp;lt;Dictionary&amp;lt;string, object&amp;gt;&amp;gt;</b> dzięki czemu nadpiszemy cały obiekt <b>@Model</b> i skrypt wykona się tylko raz": "",
        "Dla uzyskania najlepszego wyniku w to pole wstaw tylko i wyłącznie informacje co wybieramy, np \"Rodzaj dokumentu\" - dostępne opcje kontrolki są dostarczane Asystentowi automatycznie przez system": "",
        "Dla uzyskania najlepszego wyniku w to pole wstaw tylko i wyłącznie informacje czym jest słownik, np \"Forma płatności\" - opcje dostępne w słowniku są dostarczane automatycznie wraz z wartością domyślną Asystentowi przez system": "",
        "Dla uzyskania najlepszego wyniku w to pole wstaw tylko i wyłącznie kim jest kontrahent na dokumencie np. \"Wystawca faktury\" lub \"Nadawca\"": "",
        "Dla wybranych dokumentów nie znaleziono wspólnych akcji do wykonania": "A kiválasztott dokumentumokhoz nincs közös végrehajtható művelet",
        "Długość czasu przechowywania": "Tárolási idő hossza",
        "Długość trwania sesji [min": "Munkamenet időtartama [perc]",
        "dni": "nap",
        "Dni": "Napok",
        "Dni wolne": "Szabadnapok",
        "Dni wolne zostały zaimportowane.": "A szabadnapok importálva lettek.",
        "do": "ig",
        "Do": "Ig",
        "Do akceptacji": "Elfogadásra vár",
        "do czasu ręcznego odblokowania": "Kézi feloldásig",
        "Do działu": "Osztályhoz",
        "Do grupy użytkowników": "Felhasználói csoporthoz",
        "Do kierowników działu autora dokumentu": "A dokumentum szerzőjének osztályvezetőihez",
        "Do opiekuna powiązanej umowy": "",
        "Do osoby wykonującej akcję oraz do osoby wybranej na formularzu": "A műveletet végrehajtó személyhez és az űrlapon kiválasztott személyhez",
        "Do osoby wykonującej bieżącą akcję": "A jelenlegi műveletet végrehajtó személyhez",
        "Do pola tytuł można wprowadzić pola dokumentu jak do treści": "A cím mezőbe a dokumentum mezőit is be lehet illeszteni, mint a tartalomba",
        "Do przełożonego użytkownika wykonującego wskazany krok": "A kijelölt lépést végrehajtó felhasználó feletteséhez",
        "Do rezygnacji": "Lemondásra vár",
        "Do użytkownika": "Felhasználóhoz",
        "Do użytkownika wykonującego wskazany krok": "A kijelölt lépést végrehajtó felhasználóhoz",
        "Do użytkownika z najmniejszą ilością zadań w grupie (np. zespole)": "A csoportban (pl. csapatban) a legkevesebb feladattal rendelkező felhasználóhoz",
        "Do użytkownika z pola dokumentu": "A dokumentum mezőjében szereplő felhasználóhoz",
        "Do użytkownika/grupy użytkowników wskazanej w polach dokumentu": "A dokumentum mezőiben megadott felhasználóhoz/csoporthoz",
        "Do użytkownika/grupy użytkowników wskazanej w wybranym kroku na wskazanym formularzu": "A kiválasztott lépésben az űrlapon megadott felhasználóhoz/csoporthoz",
        "Do użytkownika/grupy użytkowników/kontrahenta/maila wskazanego w polach dokumentu": "A dokumentum mezőiben megadott felhasználóhoz/csoporthoz/partnerhez/e-mailhez",
        "Do użytkowników wykonujących obecny krok z wyjątkiem osoby wykonującej akcję": "A jelenlegi lépést végrehajtó felhasználókhoz, kivéve a műveletet végrehajtó személyt",
        "Do użytkowników z wybranego działu": "A kiválasztott osztály felhasználóihoz",
        "Do wprowadzenia": "Bevezetésre vár",
        "do wszystkich zaproszonych": "minden meghívotthoz",
        "Do wybranego użytkownika": "A kiválasztott felhasználóhoz",
        "Do wybranego użytkownika i działu": "A kiválasztott felhasználóhoz és osztályhoz",
        "Do zespołu": "Csapathoz",
        "Do zespołu/działu wybranego w polu dokumentu": "A dokumentum mezőjében kiválasztott csapathoz/osztályhoz",
        "doc['Nazwa pola'": "",
        "Docs": "Dokumentumok",
        "Dodaj": "Hozzáadás",
        "Dodaj / Edytuj": "Hozzáadás / Szerkesztés",
        "Dodaj akceptantów": "Kereskedők hozzáadása",
        "Dodaj akcję": "Cselekvés hozzáadása",
        "Dodaj asystenta": "Asszisztens hozzáadása",
        "Dodaj automatyzacje": "Automatizálás hozzáadása",
        "Dodaj cel": "Cél hozzáadása",
        "Dodaj czynność": "Művelet hozzáadása",
        "Dodaj danę wektorową": "Vektoriális adat hozzáadása",
        "Dodaj dni": "Napok hozzáadása",
        "Dodaj do ulubionych": "",
        "Dodaj do zespołu": "Hozzáadás a csapathoz",
        "Dodaj dokument": "Dokumentum hozzáadása",
        "Dodaj dział": "Szakasz hozzáadása",
        "Dodaj endpoint": "Végpont hozzáadása",
        "Dodaj formularz": "Űrlap hozzáadása",
        "Dodaj funkcję": "Funkció hozzáadása",
        "Dodaj grupę": "Csoport hozzáadása",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "Adjon hozzá egy vagy több widgetet, hogy betekintést nyerjen csapata előrehaladásába.",
        "Dodaj kategorię": "Kategória hozzáadása",
        "Dodaj klienta": "Ügyfél hozzáadása",
        "Dodaj komentarz": "Megjegyzés hozzáadása",
        "Dodaj komponent": "Komponens hozzáadása",
        "Dodaj kontrahenta": "Partner hozzáadása",
        "Dodaj licznik": "Számláló hozzáadása",
        "Dodaj logo": "Logó hozzáadása",
        "Dodaj moduł": "Modul hozzáadása",
        "Dodaj nową linię": "Új sor hozzáadása",
        "Dodaj nowego kontrahenta": "Új partner hozzáadása",
        "Dodaj nowy folder": "Új mappa hozzáadása",
        "Dodaj nowy wątek": "Új szál hozzáadása",
        "Dodaj plik": "Fájl hozzáadása",
        "Dodaj plik dokumentu, a Asystent AI automatycznie go skategoryzuje i wprowadzi.": "Adjon hozzá egy dokumentumfájlt, az AI asszisztens automatikusan kategorizálja és rögzíti.",
        "Dodaj pliki": "Fájlok hozzáadása",
        "Dodaj pliki asystenta": "Asszisztens fájlok hozzáadása",
        "Dodaj podsumowanie": "Összefoglalás hozzáadása",
        "Dodaj pole": "Mező hozzáadása",
        "Dodaj powiadomienie weryfikacyjne": "Ellenőrző értesítés hozzáadása",
        "Dodaj pozycję": "Pozíció hozzáadása",
        "Dodaj przycisk z przekierowaniem do dokumentu": "Gomb hozzáadása dokumentumra irányítással",
        "Dodaj regułe": "Szabály hozzáadása",
        "Dodaj rolę": "Szerepkör hozzáadása",
        "Dodaj scenariusz": "Forgatókönyv hozzáadása",
        "Dodaj sekcję": "Szekció hozzáadása",
        "Dodaj serwer": "Szerver hozzáadása",
        "Dodaj shortcode": "Shortcode hozzáadása",
        "Dodaj skan": "Szkennelés hozzáadása",
        "Dodaj słownik": "Szótár hozzáadása",
        "Dodaj słowo": "Szó hozzáadása",
        "Dodaj status": "Státusz hozzáadása",
        "Dodaj stronę": "Oldal hozzáadása",
        "Dodaj synonimy": "Szinonimák hozzáadása",
        "Dodaj szablon": "Sablon hozzáadása",
        "Dodaj tabelę wektorową": "Vektortábla hozzáadása",
        "Dodaj termin": "Kifejezés hozzáadása",
        "Dodaj token": "Token hozzáadása",
        "Dodaj użytkownika": "Felhasználó hozzáadása",
        "Dodaj webhooka": "Webhook hozzáadása",
        "Dodaj wersję": "Verzió hozzáadása",
        "Dodaj widget": "Widget hozzáadása",
        "Dodaj wiersz": "Sor hozzáadása",
        "Dodaj wpis": "Bejegyzés hozzáadása",
        "Dodaj z AI": "AI-val hozzáadva",
        "Dodaj załączniki": "Mellékletek hozzáadása",
        "Dodaj zastępstwo": "Helyettesítő hozzáadása",
        "Dodaj zespół": "Sáv hozzáadása",
        "Dodaj źródło": "Forrás hozzáadása",
        "Dodaj źródło danych": "Adatforrás hozzáadása",
        "Dodają kierownicy wybranego działu": "A kiválasztott részleg vezetői adják hozzá",
        "Dodaje  każda osoba która ma uprawnienie (widzi moduł)": "Minden jogosultsággal rendelkező személy hozzáadhatja (látja a modult)",
        "Dodaje członek grupy użytkowników": "Felhasználói csoport tagja adja hozzá",
        "Dodaje członek zespołu": "Csapat tagja adja hozzá",
        "Dodaje wybrany użytkownik": "Kiválasztott felhasználó adja hozzá",
        "dodał": "hozzáadta",
        "dodane i edytowane przeze mnie": "általam hozzáadott és szerkesztett",
        "Dodanie": "Hozzáadás",
        "Dodanie celu": "Cél hozzáadása",
        "Dodanie dokumentu": "Dokumentum hozzáadása",
        "Dodanie działu": "Szakasz hozzáadása",
        "Dodanie endpointu": "Végpont hozzáadása",
        "Dodanie formularza": "Űrlap hozzáadása",
        "Dodanie klienta": "Ügyfél hozzáadása",
        "Dodanie komponentu": "Komponens hozzáadása",
        "Dodanie modułu": "Modul hozzáadása",
        "Dodanie roli": "Szerepkör hozzáadása",
        "Dodanie scenariusza": "Forgatókönyv hozzáadása",
        "Dodanie serwera": "Szerver hozzáadása",
        "Dodanie skryptu": "Szkript hozzáadása",
        "Dodanie spółki": "Cég hozzáadása",
        "Dodanie szablonu": "Sablon hozzáadása",
        "Dodanie użytkownika": "Felhasználó hozzáadása",
        "Dodanie webhooka": "Webhook hozzáadása",
        "Dodanie wpisu": "Bejegyzés hozzáadása",
        "Dodanie zastępstwa": "Helyettesítő hozzáadása",
        "Dodanie zespołu": "Sáv hozzáadása",
        "Dodanie źródła": "Forrás hozzáadása",
        "Dodanie źródła danych": "Adatforrás hozzáadása",
        "Dodano do ulubionych": "",
        "Dodano nową wersję": "Új verzió hozzáadva",
        "dodany": "hozzáadott",
        "Dodanych plików %0 (limit wynosi %1).": "%0 fájl hozzáadva (a limit %1).",
        "Dodatkowa weryfikacja": "További ellenőrzés",
        "Dodatkowe informacje": "További információk",
        "Dodatkowe opcje": "További lehetőségek",
        "Dodatkowe pola do zgrupowania": "További csoportosítható mezők",
        "Dodatkowe pole tekstowe z dokumentu powiązanego": "További szövegmező a kapcsolódó dokumentumból",
        "Dodatkowo dostępny jest obiekt document zawierający dane dokumentu oraz obiekt data z polami ProcessId, ModuleId i ModuleVersionId.": "Továbbá elérhető a document objektum, amely tartalmazza a dokumentum adatait, valamint a data objektum a ProcessId, ModuleId és ModuleVersionId mezőkkel.",
        "Dodatkowo po uzupełnieniu właściwości options można usatwić właściwość 'multiple', aby w polu można było wskazać wiele opcji": "Továbbá az options tulajdonság kitöltése után beállítható a 'multiple' tulajdonság, hogy a mezőben több lehetőség is kiválasztható legyen.",
        "Dodatkowo skrypt zwraca kontrolki dla nowego formularza, dlatego wymagane jest, aby zwracał obiekt typu:": "Továbbá a szkript visszaadja az új űrlap vezérlőit, ezért szükséges, hogy ilyen típusú objektumot adjon vissza:",
        "Dodawanie": "Hozzáadás",
        "Dodawanie dokumentów": "Dokumentumok hozzáadása",
        "Dodawanie i edycja własnych dokumentów": "Saját dokumentumok hozzáadása és szerkesztése",
        "Dodawanie modułu": "Modul hozzáadása",
        "Dodawanie wartości dwóch kolumn": "Két oszlop értékének hozzáadása",
        "Dokument": "Dokumentum",
        "Dokument %0": "Dokumentum %0",
        "Dokument jest niepoprawnie opisany": "A dokumentum helytelenül van leírva",
        "Dokument już jest udostępniony": "A dokumentum már meg van osztva",
        "Dokument PDF": "PDF dokumentum",
        "Dokument powiązany": "Kapcsolódó dokumentum",
        "Dokument tekstowy": "Szöveges dokumentum",
        "Dokument z pola": "Mezőből származó dokumentum",
        "Dokument został pobrany": "A dokumentum letöltve",
        "Dokument został podpisany": "A dokumentum aláírva",
        "Dokument został pomyślnie przetworzony przez AI.": "A dokumentumot sikeresen feldolgozta az AI.",
        "Dokument został powiązany.": "A dokumentum összekapcsolva.",
        "Dokument został udostępniony dla wybranych użytkowników.": "A dokumentum megosztva a kiválasztott felhasználókkal.",
        "Dokument został usunięty.": "A dokumentum törölve.",
        "Dokument został wyeksportowany": "A dokumentum exportálva",
        "Dokument.Obecny target.Operator.-.System.Osoba wykonująca akcję": "Dokumentum.Aktuális cél.Operátor.-.Rendszer.A műveletet végrehajtó személy",
        "Dokument.Pola dokumentu powiązanego.Dokument.Dokumenty powiązane.Umowa.Opiekun": "",
        "Dokument.Pola dokumentu powiązanego.Dokument.Dokumenty powiązane.Zamówienie.Kwota.Operator.>.Process.Zmienne (liczby).1000": "",
        "Dokument.Pola dokumentu.{Nazwa pola}": "Dokumentum.Mezők.{Mező neve}",
        "Dokument.Pola dokumentu.{Nazwa pola}.Operator.ma wartość": "Dokumentum.Mezők.{Mező neve}.Operátor.értéke van",
        "Dokument.Pola dokumentu.{Pole grupa użytkowników}": "Dokumentum.Mezők.{Felhasználói csoport mező}",
        "Dokument.Pola dokumentu.{Pole z użytkownikiem}": "Dokumentum.Mezők.{Felhasználó mező}",
        "Dokument.Pola dokumentu.Autor.System.Dział użytkownika.System.Kierownicy działu.": "Dokumentum.Mezők.Szerző.Rendszer.Felhasználó részlege.Rendszer.Részlegvezetők.",
        "Dokumentacja": "Dokumentáció",
        "dokumentów przetworzonych": "",
        "Dokumenty": "Dokumentumok",
        "Dokumenty kontrahenta": "Partner dokumentumai",
        "Dokumenty powiązane": "Kapcsolódó dokumentumok",
        "Dokumenty przekazane do wglądu na zasadzie powyższej nie będą dostępne z poziomu Zestawienia dokumentów i wyszukiwarki globalnej, a jedynie dostępne przez szczegóły dokumentu głównego.": "A fenti elv alapján betekintésre átadott dokumentumok nem lesznek elérhetők a dokumentumok listájából és a globális keresőből, csak a fő dokumentum részletein keresztül.",
        "Dołącz stack trace": "Stack trace csatolása",
        "Domena": "Domain",
        "Domyślna": "Alapértelmezett",
        "Domyślna skala czasu": "Alapértelmezett időskála",
        "Domyślna wartość": "Alapértelmezett érték",
        "Domyślne": "Alapértelmezett",
        "Domyślne filtry": "Alapértelmezett szűrők",
        "Domyślnie skrypt jest wykonywany na każdym dokumencie": "Alapértelmezés szerint a szkript minden dokumentumon fut",
        "Domyślnie ukryte": "Alapértelmezés szerint rejtett",
        "Domyślnie widoczne": "Alapértelmezés szerint látható",
        "Domyślny": "Alapértelmezett",
        "Domyślny pager": "Alapértelmezett lapozó",
        "Domyślny zakres": "Alapértelmezett tartomány",
        "Dopasowano do modułu:": "Modulhoz igazítva:",
        "Dopasowuję do modułu": "Modulhoz igazítom",
        "Dopuść brak odpowiedzi": "Válasz hiányának engedélyezése",
        "Dostawca": "Szolgáltató",
        "Dostawca podpisu": "Aláírás szolgáltató",
        "Dostęp do modułu": "Modulhoz való hozzáférés",
        "Dostęp do systemu": "Rendszerhez való hozzáférés",
        "Dostęp do zmiennych terminu słownika (np. stawka VAT)": "Szótár kifejezés változóihoz való hozzáférés (pl. ÁFA kulcs)",
        "Dostęp niezdefiniowany": "Nem definiált hozzáférés",
        "Dostęp przyznany": "Hozzáférés engedélyezve",
        "Dostęp zabroniony": "Hozzáférés tiltva",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "Új frissítés érhető el. Kérjük, mentse a munkáját, majd kattintson a \"Frissítés\" gombra. A frissítést az ablak frissítésével is elfogadhatja. A frissítés hiánya hibákat okozhat.",
        "Dostępne": "Elérhető",
        "Dostępne operatory": "Elérhető operátorok",
        "Dostępne są propki Form i Entry zawierające odpowiednio strukturę formularza oraz dane z wypełnionego formularza": "Elérhetők a Form és Entry propok, amelyek tartalmazzák az űrlap szerkezetét és a kitöltött űrlap adatait.",
        "Dostępne skróty klawiszowe": "",
        "Dostępność": "Elérhetőség",
        "Dostępny dla modułu": "Modul számára elérhető",
        "Dostępny limit": "Elérhető limit",
        "Dostosuj wysokość do wysokości zawartości": "Igazítsa a magasságot a tartalom magasságához",
        "Dotyczy tylko dokumentów z modułów do których użytkownik ma dostęp": "Csak azokhoz a modulokhoz tartozó dokumentumokra vonatkozik, amelyekhez a felhasználó hozzáfér",
        "Dotyczy wznawiania obiegu": "Az ügy újraindítására vonatkozik",
        "dowolnej wybranej wersji": "bármely kiválasztott verzió",
        "Dowolny": "Bármelyik",
        "Dozwolone rozszerzenia": "Engedélyezett kiterjesztések",
        "Dozwolone rozszerzenia: %0.": "Engedélyezett kiterjesztések: %0.",
        "Dozwolone są tylko małe i duże litery": "Csak kis- és nagybetűk engedélyezettek",
        "Dozwolone są tylko małe litery i znak -": "Csak kisbetűk és kötőjel engedélyezett",
        "Dozwolone typy plików: %0.": "Engedélyezett fájltípusok: %0.",
        "Drugie imię": "Második keresztnév",
        "Drugorzędny": "Másodlagos",
        "Dsn": "Dsn",
        "Duplikuj": "Duplikálás",
        "Duża": "Nagy",
        "Duży": "Nagy",
        "Duży układ siatki": "Nagy rácselrendezés",
        "Dwie kolumny": "Két oszlop",
        "Dynamicznie": "Dinamikusan",
        "Dynamiczny modal": "Dinamikus modal",
        "Dyrektor": "Igazgató",
        "Dyrektorzy": "Igazgatók",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "A max-age=N direktíva azt jelzi, hogy a válasz N másodpercig marad friss a válasz generálása után.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "A no-store direktíva azt jelzi, hogy semmilyen gyorsítótár nem tárolhatja ezt a választ.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "A PRIVATE direktíva azt jelzi, hogy a válasz csak privát gyorsítótárban tárolható (pl. böngésző helyi tára).",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "A PUBLIC direktíva azt jelzi, hogy a válasz megosztott gyorsítótárban tárolható (pl. proxy).",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "Az s-maxage direktívát a privát gyorsítótárak figyelmen kívül hagyják, és felülírja a max-age értékét a megosztott gyorsítótárakban.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "Az s-maxage direktíva azt jelzi, hogy a válasz mennyi ideig marad érvényes a megosztott gyorsítótárban (pl. proxy).",
        "Dyrektywy zakresu": "Tartomány direktívák",
        "Dział": "Osztály",
        "Dział aktywny": "Aktív osztály",
        "Dział nadrzędny": "Felsőbb osztály",
        "Dział został dodany.": "Az osztály hozzáadva.",
        "Dział został zaktualizowany.": "Az osztály frissítve.",
        "Działania masowe": "Tömeges műveletek",
        "Działy": "Osztályok",
        "Dzielenie": "Osztás",
        "Dziennik korespondencji": "Levelezési napló",
        "Dzienny": "Napi",
        "dzień": "nap",
        "Dzień": "Nap",
        "dzień (dni)": "nap (napok)",
        "Dzień miesiąca": "Hónap napja",
        "Dzień wolny został dodany.": "A szabadnap hozzáadva.",
        "Dzień wolny został zaktualizowany.": "A szabadnap frissítve.",
        "Dziękujemy za wypełnienie formularza": "Köszönjük az űrlap kitöltését",
        "Dziś minus": "Ma mínusz",
        "Dziś plus": "Ma plusz",
        "E-Doręczenia Ade": "E-Doręczenia Ade",
        "E-mail": "E-mail",
        "Edycja": "Szerkesztés",
        "Edycja celu": "Cél szerkesztése",
        "Edycja dokumentów": "Dokumentumok szerkesztése",
        "Edycja dokumentu": "Dokumentum szerkesztése",
        "Edycja działu": "Osztály szerkesztése",
        "Edycja elementu": "",
        "Edycja endpointu": "Végpont szerkesztése",
        "Edycja formularza": "Űrlap szerkesztése",
        "Edycja klienta": "Ügyfél szerkesztése",
        "Edycja komponentu": "Komponens szerkesztése",
        "Edycja modułu": "Modul szerkesztése",
        "Edycja pól dokumentu": "Dokumentum mezőinek szerkesztése",
        "Edycja roli": "Szerepkör szerkesztése",
        "Edycja scenariusza": "Forgatókönyv szerkesztése",
        "Edycja serwera": "Szerver szerkesztése",
        "Edycja skryptu": "Szkript szerkesztése",
        "Edycja słownika": "Szótár szerkesztése",
        "Edycja szablonu": "Sablon szerkesztése",
        "Edycja terminu": "Kifejezés szerkesztése",
        "Edycja użytkownika": "Felhasználó szerkesztése",
        "Edycja w popupie": "Szerkesztés felugró ablakban",
        "Edycja webhooka": "Webhook szerkesztése",
        "Edycja wpisu": "Bejegyzés szerkesztése",
        "Edycja wszystkich dokumentów": "Összes dokumentum szerkesztése",
        "Edycja zastępstwa": "Helyettesítés szerkesztése",
        "Edycja zespołu": "Csoport szerkesztése",
        "Edycja źródła": "Forrás szerkesztése",
        "Edycja źródła danych": "Adatforrás szerkesztése",
        "Edytor": "Szerkesztő",
        "Edytowana wersja": "Szerkesztett verzió",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Csak az engedélyezett és támogatott csatornák sablonjai szerkeszthetők.",
        "Edytuj": "Szerkesztés",
        "Edytuj akcję": "Művelet szerkesztése",
        "Edytuj członka grupy": "Csoporttag szerkesztése",
        "Edytuj danę wektorową": "Vektoriális adat szerkesztése",
        "Edytuj dashboard": "Vezérlőpult szerkesztése",
        "Edytuj dokument": "Dokumentum szerkesztése",
        "Edytuj filtr": "Szűrő szerkesztése",
        "Edytuj kategorię": "Kategória szerkesztése",
        "Edytuj kontrahenta": "Partner szerkesztése",
        "Edytuj pole": "Mező szerkesztése",
        "Edytuj szablon": "Sablon szerkesztése",
        "Edytuj tabelę wektorową": "Vektortábla szerkesztése",
        "Edytuj uprawnienia": "Jogosultságok szerkesztése",
        "Edytuj wersję": "Verzió szerkesztése",
        "Edytuj wpis": "Bejegyzés szerkesztése",
        "Edytuj źródło danych": "Adatforrás szerkesztése",
        "Eksport": "Export",
        "Eksport danych został dodany.": "Az exportált adat hozzáadva.",
        "Eksport danych został zaktualizowany.": "Az exportált adat frissítve.",
        "Eksport do arkusza Excel": "Exportálás Excel táblázatba",
        "Eksport do Excela": "Exportálás Excelbe",
        "Eksport dokumentów": "Dokumentumok exportálása",
        "Eksport użytkowników": "Felhasználók exportálása",
        "Eksport wykonany pomyślnie": "Export sikeresen végrehajtva",
        "Eksportuj": "Exportálás",
        "Eksportuj diagram do XML": "",
        "Eksportuj do Excel": "Exportálás Excelbe",
        "Eksportuj wersję modułu do pliku": "Modul verzió exportálása fájlba",
        "Elastic": "Elastic",
        "Element sitemap": "Sitemap elem",
        "Element został przywrócony.": "Az elem visszaállítva.",
        "Element został usunięty.": "Az elem törölve.",
        "Elementu układu": "Elrendezés elem",
        "Eliminuj duplikaty z różnych serii danych": "Duplikátumok eltávolítása különböző adatsorokból",
        "Email": "E-mail",
        "Email potwierdzony": "E-mail megerősítve",
        "Endpoint": "Végpont",
        "Endpoint API": "API végpont",
        "Endpoint został dodany.": "A végpont hozzáadva.",
        "Endpoint został zaktualizowany.": "A végpont frissítve.",
        "Error - błedy wewnętrze SDK": "Hiba - belső SDK hibák",
        "Eskportuj": "Exportálás",
        "Etykieta": "Címke",
        "Etykiety": "Címkék",
        "Export XML": "XML exportálása",
        "Exportuj do Excela": "Exportálás Excelbe",
        "fakturę": "számla",
        "Fatal - błedy krytyczne": "Végzetes - kritikus hibák",
        "Filtr dla synchronizacji działów": "Osztályok szinkronizálásának szűrője",
        "Filtr dla synchronizacji użytkowników": "Felhasználók szinkronizálásának szűrője",
        "Filtr domyślny": "Alapértelmezett szűrő",
        "Filtr globalny": "Globális szűrő",
        "Filtr po grupie": "Csoport szerinti szűrő",
        "Filtr prywatny": "Privát szűrő",
        "Filtr został usunięty": "A szűrő törölve",
        "Filtr został zapisany": "A szűrő elmentve",
        "Filtrowanie": "Szűrés",
        "Filtrowanie listy dokumentów": "Dokumentumlista szűrése",
        "Filtruj": "Szűrés",
        "Filtruj po roli": "Szerepkör szerinti szűrés",
        "filtry": "szűrők",
        "Filtry": "Szűrők",
        "Filtry globalne": "Globális szűrők",
        "Filtry systemowe": "Rendszerszűrők",
        "Filtry wartościami pól formularza": "Űrlapmező értékek szerinti szűrők",
        "Finalizuję": "Befejezem",
        "Folder OneDrive": "OneDrive mappa",
        "Folder plików": "Fájlmappa",
        "Foldery": "Mappák",
        "Format dokumentu": "Dokumentum formátuma",
        "Formatowanie": "Formázás",
        "Formularz": "Űrlap",
        "Formularz bazuje na nieaktualnej wersji definicji.": "Az űrlap elavult definíció verzióra épül.",
        "Formularz dynamiczny": "Dinamikus űrlap",
        "Formularz zarchiwizowany": "Űrlap archiválva",
        "Formularz zawiera błędy": "Az űrlap hibákat tartalmaz",
        "Formularz został dodany.": "Űrlap hozzáadva.",
        "Formularz został skopiowany.": "Űrlap másolva.",
        "Formularz został wysłany pomyślnie": "Űrlap sikeresen elküldve",
        "Formularz został zaktualizowany.": "Űrlap frissítve.",
        "Formularz został zapisany": "Űrlap elmentve",
        "Formularze": "Űrlapok",
        "Formularze i pola formularzy": "Űrlapok és űrlapmezők",
        "Formuła jest nieprawidłowa": "A képlet érvénytelen",
        "Funkcja": "Funkció",
        "Funkcja OCR nie jest włączona w konfiguracji systemu": "Az OCR funkció nincs engedélyezve a rendszer konfigurációjában",
        "Funkcja została dodana.": "Funkció hozzáadva.",
        "Funkcja została usunięta.": "Funkció törölve.",
        "Funkcja została zaktualizowana.": "Funkció frissítve.",
        "Funkcje": "Funkciók",
        "Funkcje Asystent": "Asszisztens funkciók",
        "Funkcje asystenta": "Asszisztens funkciók",
        "Funkcje Asystenta": "Asszisztens funkciók",
        "Funkcje asystenta AI": "AI asszisztens funkciók",
        "Funkcjonalności": "Funkcionalitások",
        "Galeria zdjęć": "Képgaléria",
        "Gdzie zapisywać": "Hová mentse",
        "Generator obrazów AI": "AI képgenerátor",
        "Generowanie obrazów": "Képek generálása",
        "Generowanie obrazów zakończone.": "Képgenerálás befejezve.",
        "Generuj dokument z szablonu": "Dokumentum generálása sablonból",
        "Generuj licznik sygnatury w skali miesiąca": "Aláírás számláló generálása havi szinten",
        "Generuj metadane": "Metaadatok generálása",
        "Generuj metadane (AI)": "Metaadatok generálása (AI)",
        "Generuj nowy obraz": "Új kép generálása",
        "Generuj obraz": "Kép generálása",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Bejegyzések listája (rendezés és lapozás)",
        "GET: Pobranie danych": "GET: Adatok lekérése",
        "GET: Pobranie wpisu": "GET: Bejegyzés lekérése",
        "GET: Schemat (definicja formularza)": "GET: Séma (űrlap definíció)",
        "Godzina rozpoczęcia": "Kezdési idő",
        "Godzina zakończenia": "Befejezési idő",
        "Godziny": "Órák",
        "Godziny robocze": "Munkaórák",
        "Google Translate V2": "Google Translate V2",
        "GPT-4 Vision": "GPT-4 Vision",
        "Graf statusów": "Státusz grafikon",
        "Grafika": "Grafika",
        "Grudzień": "December",
        "Grupa": "Csoport",
        "Grupa użytkowników": "Felhasználói csoport",
        "grupę": "csoportot",
        "Grupuj po": "Csoportosítás",
        "Grupuj po okresie": "Csoportosítás időszak szerint",
        "Grupuj pola": "Mezők csoportosítása",
        "Grupuj zadania po": "Feladatok csoportosítása",
        "Grupy": "Csoportok",
        "Grupy użytkowników": "Felhasználói csoportok",
        "Grupy użytkowników zostały zapisane": "Felhasználói csoportok elmentve",
        "Harmonogram zadań": "Feladat ütemezés",
        "Harmonogram został zmieniony": "Az ütemezés megváltozott",
        "Hasło": "Jelszó",
        "Hasło (Klucz ukryty)": "Jelszó (rejtett kulcs)",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "A jelszónak legalább egy speciális karaktert kell tartalmaznia, pl.: ~ @ # $ % ^ & *",
        "Hasło użytkownika serwisowego": "Szolgáltatói felhasználó jelszava",
        "Hasło zostało zmienione. Zaloguj się ponownie": "A jelszó megváltozott. Kérjük, jelentkezzen be újra.",
        "Health": "Állapot",
        "Heatmapa dla wersji": "Verzió hőtérkép",
        "Hierarchia": "Hierarchia",
        "Historia": "Előzmények",
        "Historia logowania": "Bejelentkezési előzmények",
        "Historia zadania": "Feladat előzmények",
        "Historia zapytań AI": "AI lekérdezések előzményei",
        "Host": "Házigazda",
        "Host dodatkowy": "További házigazda",
        "Host główny": "Fő házigazda",
        "i": "és",
        "Id": "Id",
        "ID": "ID",
        "ID lub typ zadania": "ID vagy feladattípus",
        "Id modelu: %0": "Modell ID: %0",
        "Id obiektu": "Objektum ID",
        "Id sesji": "Munkamenet ID",
        "Id wpisu": "Bejegyzés ID",
        "ID zadania": "Feladat ID",
        "Id zapytania": "Lekérdezés ID",
        "Id zdarzenia": "Esemény ID",
        "Identyfikator": "Azonosító",
        "Identyfikator przestrzeni (WorkspaceId)": "Munkaterület azonosító (WorkspaceId)",
        "Identyfikator wdrożenia": "Telepítési azonosító",
        "Identyfikator zadania": "Feladat azonosító",
        "Ideo": "Ideo",
        "Ikona": "Ikon",
        "Ikona nagłówka": "Fejléc ikon",
        "Ikonka": "Ikon",
        "Ilość cyfr w polu numer": "Szám mező számjegyeinek száma",
        "Ilość kont": "Fiókok száma",
        "Ilość modułów": "Modulok száma",
        "Ilość wierszy": "Sorok száma",
        "Ilość wyników do odrzucenia": "Elutasítandó eredmények száma",
        "Ilość wyników do pobrania": "Letöltendő eredmények száma",
        "Ilość znaków": "Karakterek száma",
        "Ilość znaków odpowiedzi": "Válasz karakterek száma",
        "Imię": "Keresztnév",
        "Imię i Nazwisko": "Keresztnév és vezetéknév",
        "Implementacja": "Implementáció",
        "Implementacja metod/zmiennych/stałych, których chcemy używać w skrypcie": "A szkriptben használni kívánt metódusok/változók/konstansok implementációja",
        "Import": "Importálás",
        "Import danych": "Adatok importálása",
        "Import dni wolnych": "Szabadnapok importálása",
        "Import modułu": "Modul importálása",
        "Import tabeli": "Tábla importálása",
        "Import użytkowników": "Felhasználók importálása",
        "Import w trakcie przetwarzania...": "Importálás folyamatban...",
        "Import wykonany pomyślnie": "Importálás sikeresen végrehajtva",
        "Import zakończony pomyślnie.": "Importálás sikeresen befejezve.",
        "Import został dodany.": "Import hozzáadva.",
        "Importer wprowadzi do systemu wszystkie wiersze, które przejdą walidację.": "Az importáló minden érvényes sort hozzáad a rendszerhez.",
        "Importuj": "Importálás",
        "Importuj definicję formularza": "Űrlap definíció importálása",
        "Importuj moduł z pliku": "Modul importálása fájlból",
        "Importuj proces z pliku": "Folyamat importálása fájlból",
        "Importuj wersję z pliku": "Verzió importálása fájlból",
        "Indeks": "Index",
        "Indeks został usunięty.": "Az index törölve.",
        "info": "információ",
        "Info - informacje": "Info - információk",
        "Informacja": "Információ",
        "Informacyjna": "Információs",
        "Inside": "Belül",
        "Inspekcja": "Ellenőrzés",
        "Inspekcja pochodzenia uprawnienia": "Jogosultság eredetének ellenőrzése",
        "Instalacja": "Telepítés",
        "Instalacja rozszerzenia z Web Store": "Bővítmény telepítése Web Store-ból",
        "Instrukcja": "Utasítás",
        "Instrukcja (PDF)": "Útmutató (PDF)",
        "Instrukcja dla AI dotycząca tego pola": "AI utasítás ehhez a mezőhöz",
        "Instrukcja modelu (prompt).": "Modell utasítás (prompt).",
        "Instrukcje dla pól": "Mezők utasításai",
        "Interpreter kodu": "Kódértelmező",
        "Interpreter kodu umożliwia asystentowi pisanie i uruchamianie kodu. To narzędzie może przetwarzać pliki z różnymi danymi i formatowaniem oraz generować pliki.": "A kódértelmező lehetővé teszi az asszisztens számára a kód írását és futtatását. Ez az eszköz különböző adatokat és formátumokat tartalmazó fájlokat tud feldolgozni, valamint fájlokat generálni.",
        "Istniejące firmy": "Meglévő cégek",
        "Jaki zakres danych": "Milyen adatkör",
        "Jakość": "Minőség",
        "Jakość HD 1024x1024": "HD minőség 1024x1024",
        "Jakość HD 1024x1792 i 1792x1024": "HD minőség 1024x1792 és 1792x1024",
        "Jakość rozpoznawania zależy od czytelności dokumentu. Najlepsze rezultaty uzyskasz z dokumentami w wysokiej rozdzielczości.": "A felismerés minősége a dokumentum olvashatóságától függ. A legjobb eredményt nagy felbontású dokumentumokkal érheted el.",
        "Jakość standardowa 1024x1024": "Standard minőség 1024x1024",
        "Jakość standardowa 1024x1792 i 1792x1024": "Standard minőség 1024x1792 és 1792x1024",
        "Jakość wygnerowanego obrazu.": "A generált kép minősége.",
        "Jasny": "Világos",
        "Jedna kolumna": "Egy oszlop",
        "Jest autorem": "Szerző",
        "Jeśli kolumna z tabeli nie jest uwzględniona w obiekcie to domyślnie jest ona widoczna.": "Ha a tábla oszlopa nincs az objektumban, akkor alapértelmezés szerint látható.",
        "Jeśli kwota przekracza 2000": "Ha az összeg meghaladja a 2000-et",
        "Jeśli lista silników jest pusta, sprawdź czy został wybrany typ skryptu": "Ha a motorok listája üres, ellenőrizze, hogy kiválasztotta-e a szkript típusát",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "Ha a mező üres, az alapértelmezett érték kerül felhasználásra. Ellenkező esetben az alapértelmezett érték felülíródik.",
        "Jeśli użytkownik należy do grupy użytkowników modułu o id 456": "Ha a felhasználó a 456-os modul felhasználói csoportjához tartozik",
        "Jeśli użytkownik należy do zespołu o id 456": "Ha a felhasználó a 456-os csapathoz tartozik",
        "Jeśli w polu wyboru wybrano opcję 1": "Ha a választómezőben az 1-es opció van kiválasztva",
        "Jeżeli": "Ha",
        "Jeżeli aplikacja została prawidłowo zainstalowana i mimo tego nadal pojawia się niniejszy komunikat, należy sprawdzić czy na komputerze zainstalowane jest środowisko uruchomieniowe Java.": "Ha az alkalmazás megfelelően telepítve van, de még mindig megjelenik ez az üzenet, ellenőrizze, hogy a Java futtatókörnyezet telepítve van-e a számítógépen.",
        "Język": "Nyelv",
        "Kafelki": "Csempék",
        "Kalendarz": "Naptár",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "A csatorna alapértelmezés szerint kötelező. Nem lehet kikapcsolni az értesítések küldését ezen a csatornán. Csak a cím és az üzenet tartalma módosítható.",
        "kanał wymagany": "kötelező csatorna",
        "Kanały": "Csatornák",
        "Kanały komunikacji": "Kommunikációs csatornák",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "A kiválasztott értesítéstípus által támogatott csatornák",
        "Kanały włączone w ustawieniach aplikacji": "Az alkalmazás beállításaiban engedélyezett csatornák",
        "Karta": "Kártya",
        "Katalog": "Katalógus",
        "Katalog główny": "Fő katalógus",
        "Katalog został utworzony": "A katalógus létrehozva",
        "Katalog został utworzony.": "A katalógus létrehozva.",
        "Kategoria": "Kategória",
        "Kategoria archiwalna w innych komórkach": "Archív kategória más egységekben",
        "Kategoria archiwalna w komórce macierzystej": "Archív kategória fő egységben",
        "Kategoria została dodana.": "Kategória hozzáadva.",
        "Kategoria została usunięta.": "Kategória törölve.",
        "Kategoria została zaktualizowana.": "Kategória frissítve.",
        "Kategorie": "Kategóriák",
        "Kierownicy": "Vezetők",
        "Kierownik": "Menedzser",
        "Kierunek sortowania": "Rendezés iránya",
        "Klasyfikuję dokument": "Dokumentumot osztályozom",
        "Klienci": "Ügyfelek",
        "Klient aktywny": "Aktív ügyfél",
        "Klient został dodany.": "Ügyfél hozzáadva.",
        "Klient został usunięty.": "Ügyfél törölve.",
        "Klient został zaktualizowany.": "Ügyfél frissítve.",
        "Kliknij aby usunąć": "Kattintson a törléshez",
        "Klucz": "Kulcs",
        "Klucz API": "API kulcs",
        "Klucz główny (PrimaryKey)": "Fő kulcs (PrimaryKey)",
        "Klucz pola": "Mező kulcs",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucze": "Kulcsok",
        "Klucze są nie prawidłowe.": "A kulcsok érvénytelenek.",
        "Klucze są prawidłowe.": "A kulcsok érvényesek.",
        "Klucze unikalne": "Egyedi kulcsok",
        "Kod musi kończyć się wyrażeniem, które zwraca wartość typu boolean": "A kódnak egy olyan kifejezéssel kell végződnie, amely logikai értéket ad vissza",
        "Kod musi kończyć się wyrażeniem, które zwraca wartość typu boolean lub string": "A kódnak egy olyan kifejezéssel kell végződnie, amely logikai vagy szöveges értéket ad vissza",
        "Kod musi zwracać kończyć się wyrażeniem, które zwraca wartość wybranego typu": "A kódnak egy olyan kifejezéssel kell végződnie, amely a kiválasztott típusú értéket ad vissza",
        "Kod pocztowy": "Irányítószám",
        "Kod walidacji": "Validációs kód",
        "Kod wertfikacyjny": "Ellenőrző kód",
        "Kod weryfikacyjny jest nieprawidłowy.": "Az ellenőrző kód érvénytelen.",
        "Kod został skopiowany do schowka.": "A kód a vágólapra másolva.",
        "Kod źródłowy": "Forráskód",
        "Kolejka": "Várólista",
        "Kolejne osoby w procesie": "Következő személyek a folyamatban",
        "Kolekcja": "Gyűjtemény",
        "Kolekcja bazy wektorowej": "Vektoralapú adatbázis gyűjteménye",
        "Kolor": "Szín",
        "Kolor drugorzędny: %0": "Másodlagos szín: %0",
        "Kolor etykiety": "Címke színe",
        "Kolor icon na panelu z aplikacjami: %0": "Ikon színe az alkalmazáspanelen: %0",
        "Kolor ikony": "Ikon színe",
        "Kolor liczby": "Szám színe",
        "Kolor podstawowy: %0": "Elsődleges szín: %0",
        "Kolor przewodni obrazu": "Kép fő színe",
        "Kolor tekstu aktywnej pozycji menu: %0": "Menü aktív elemének szövegszíne: %0",
        "Kolor tła panelu z aplikacjami: %0": "Alkalmazáspanel háttérszíne: %0",
        "Kolor wartości": "Érték színe",
        "Kolorowana konsola": "Színes konzol",
        "Kolory": "Színek",
        "Kolory zostały przywrócone.": "A színek visszaálltak.",
        "Kolory zostały zapisane.": "A színek elmentve.",
        "Kolumna": "Oszlop",
        "Kolumna do zsumowania": "Összegzendő oszlop",
        "Kolumny": "Oszlopok",
        "Kom": "Kom.",
        "Kom.": "Kom.",
        "Komentarz": "Megjegyzés",
        "Komentarz został dodany.": "Megjegyzés hozzáadva.",
        "Komentarze": "Megjegyzések",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "Olyan komponens, amelynek értéke a szülőelem neveként lesz használva. Csak \"Szöveg\" típusú komponensek érhetők el.",
        "Komponent został dodany.": "Komponens hozzáadva.",
        "Komponent został usunięty.": "Komponens törölve.",
        "Komponent został zaktualizowany.": "Komponens frissítve.",
        "Komponent źródłowy": "Forrás komponens",
        "Komponenty": "Komponensek",
        "Komunikat": "Üzenet",
        "Komunikat błędu": "Hibaüzenet",
        "Komunikat walidacji": "Validációs üzenet",
        "Konfiguracja": "Konfiguráció",
        "Konfiguracja asystenta ai": "AI asszisztens konfiguráció",
        "Konfiguracja dla stałych wartości, których chcemy używać w skrypcie": "A szkriptben használni kívánt állandó értékek konfigurációja",
        "Konfiguracja domyślna": "Alapértelmezett konfiguráció",
        "Konfiguracja harmonogramu": "Ütemezés konfigurációja",
        "Konfiguracja harmonogramu (czas UTC)": "Ütemezés konfigurációja (UTC idő)",
        "Konfiguracja kolumn tabeli": "Táblázat oszlopainak konfigurációja",
        "Konfiguracja list": "Lista konfiguráció",
        "Konfiguracja logów": "Napló konfiguráció",
        "Konfiguracja nie została ustawiona.": "A konfiguráció nincs beállítva.",
        "Konfiguracja skryptu": "Szkript konfiguráció",
        "Konfiguracja strony": "Weboldal konfiguráció",
        "Konfiguracja umożliwa wykorzystanie pól dokumentu do wygenrowania nazwy pliku. Przykład: Dokument @Model._1_Text1": "A konfiguráció lehetővé teszi a dokumentum mezőinek felhasználását a fájlnév generálásához. Példa: Dokumentum @Model._1_Text1",
        "Konfiguracja zaawansowana": "Speciális konfiguráció",
        "Konfiguracja zapytania": "Lekérdezés konfigurációja",
        "Konfiguracja została przywrócona dla reguł i celów": "A konfiguráció visszaállítva a szabályokhoz és célokhoz",
        "Konfiguracja została zapisana.": "A konfiguráció elmentve.",
        "Koniec": "Vége",
        "Koniec po": "Vége után",
        "Konta bez logowania": "Bejelentkezés nélküli fiókok",
        "Konta użytkowników": "Felhasználói fiókok",
        "Konta użytkowników zostały odblokowane": "Felhasználói fiókok feloldva",
        "Konta użytkowników zostały przypisane do zespołu": "Felhasználói fiókok csapathoz rendelve",
        "Konta użytkowników zostały usunięte z systemu": "Felhasználói fiókok törölve a rendszerből",
        "Konta użytkowników zostały zablokowane": "Felhasználói fiókok zárolva",
        "Kontakt": "Kapcsolat",
        "Kontener plików": "Fájltároló",
        "Konto aktywne": "Aktív fiók",
        "Konto bankowe": "Bankszámla",
        "Konto bez logowania": "Bejelentkezés nélküli fiók",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "A fiók inaktív marad, amíg az e-mail cím nincs megerősítve",
        "Kontrahenci": "Vállalkozók",
        "Kontrahent": "Ügyfél",
        "Kontrahent został nadpisany.": "Az ügyfél felülírva.",
        "Kontrahent został usunięty.": "Az ügyfél törölve.",
        "Kontrahent został zapisany.": "Az ügyfél elmentve.",
        "Kontrolka": "Vezérlőelem",
        "Kontrolka wyboru": "Választó vezérlő",
        "Kontrolki no-code": "No-code vezérlők",
        "Kontrolki podstawowe": "Alap vezérlők",
        "Kontrolki specjalizowane": "Speciális vezérlők",
        "Konwertuj obrazy do formatu WebP": "Képek konvertálása WebP formátumba",
        "Końcowa": "Végső",
        "Kopiuj": "Másolás",
        "Kopiuj adres": "Cím másolása",
        "Kopiuj definicję": "Definíció másolása",
        "Kopiuj do schowka": "Másolás vágólapra",
        "Kopiuj filtr": "Szűrő másolása",
        "Kopiuj JSON": "JSON másolása",
        "Kopiuj JSON do schowka": "JSON másolása vágólapra",
        "Kopiuj pole": "Mező másolása",
        "Kopiuj sygnaturę": "Aláírás másolása",
        "Kopiuj z": "Másolás innen",
        "Kopiuj zaznaczony element": "",
        "Korzystaj ze zmiennych środowiskowych": "Környezeti változók használata",
        "Kosz": "Kuka",
        "Kraj": "Ország",
        "Krajowej Izby Rozliczeniowej S.A. ": "Krajowej Izby Rozliczeniowej S.A.",
        "Krok": "Lépés",
        "Krok minut": "Perc lépésköz",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "A perc lépésköznek 1 és 60 közötti számnak kell lennie.",
        "Krok procesu": "Folyamat lépése",
        "Kroki": "Lépések",
        "Krótki opis": "Rövid leírás",
        "KRS: ": "KRS: ",
        "Kto dodaje": "Ki adja hozzá",
        "Kto może udostępniać dokumenty": "Ki oszthatja meg a dokumentumokat",
        "Kto może wiązać dokumenty": "Ki kapcsolhatja össze a dokumentumokat",
        "Kurs": "Árfolyam",
        "Kursy walut": "Valutaárfolyamok",
        "Kwiecień": "Április",
        "Kwota brutto": "Bruttó összeg",
        "Kwota netto": "Nettó összeg",
        "Lasso – zaznaczanie elementów": "",
        "Layout": "Elrendezés",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP SSL-en keresztül)",
        "Lewy panel": "Bal panel",
        "Licencja": "Engedély",
        "Licencja Logito": "Logito engedély",
        "Licencjobiorca": "Engedélyes",
        "Liczba": "Szám",
        "Liczba całkowita": "Egész szám",
        "Liczba danych wejściowych podana w tokenach.": "A bemeneti adatok száma tokenekben megadva.",
        "Liczba danych wyjściowych podana w tokenach.": "A kimeneti adatok száma tokenekben megadva.",
        "Liczba dni": "Napok száma",
        "Liczba dni na wykonanie kroku": "Lépés végrehajtásának napjai",
        "Liczba dziesiętna": "Tizedes szám",
        "Liczba miesięcy": "Hónapok száma",
        "Liczba wariantów": "Változatok száma",
        "Liczba wyników na stronie": "Eredmények száma oldalanként",
        "Licznik zależny od": "Számláló függ ettől",
        "Liczniki": "Számlálók",
        "Lider": "Vezető",
        "light": "világos",
        "Limit": "Limit",
        "Limit API": "API limit",
        "Linia": "Sor",
        "linie": "sorok",
        "linię": "sort",
        "Link do użycia": "Használható link",
        "Link skopiowany": "Link másolva",
        "Lipiec": "Július",
        "lista": "lista",
        "Lista": "Lista",
        "Lista dozwolonych / wykluczonych żądań HTTP": "Engedélyezett / kizárt HTTP kérések listája",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "A felhasználó tényleges jogosultságainak listája, amely az egyéni jogosultságokból és szerepkörökből származik.",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "Az elemek listája csak azokra szűkül, amelyek a kiválasztott komponensek értékeihez kapcsolódnak.",
        "Lista ID": "ID lista",
        "Lista indeksów": "Indexek listája",
        "Lista jest pusta": "A lista üres",
        "Lista kontahentów": "Ügyfelek listája",
        "Lista kontrahentów": "Ügyfelek listája",
        "Lista plików": "Fájlok listája",
        "Lista powiadomień": "Értesítések listája",
        "Lista pracowników": "Munkavállalók listája",
        "Lista rozwijana": "Legördülő lista",
        "Listopad": "November",
        "Listy": "Listák",
        "Litery": "Betűk",
        "Litery i cyfry": "Betűk és számok",
        "Log Analytics": "Log Analytics",
        "Logi": "Naplók",
        "Logi błędów": "Hibanaplók",
        "Logi wydajnościowe": "Teljesítménynaplók",
        "Login": "Bejelentkezés",
        "Logito": "Logito",
        "Logito Asystent AI": "Logito AI Asszisztens",
        "Logo": "Logó",
        "Logowanie": "Bejelentkezés",
        "Logowanie zakończyło się niepowodzeniem.": "A bejelentkezés sikertelen volt.",
        "Logowanie zależności / żądań typu HTTP": "HTTP kérések / függőségek naplózása",
        "Loguj wybrane": "Kiválasztottak naplózása",
        "Lokalne": "Helyi",
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit.": "Lorem ipsum dolor sit, amet consectetur adipisicing elit.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.": "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.",
        "Lp.": "Sorszám",
        "lub": "vagy",
        "Luty": "Február",
        "Ładowanie błędów...": "Hibák betöltése...",
        "Ładowanie danych...": "Adatok betöltése...",
        "Ładowanie logów...": "Naplók betöltése...",
        "Ładowanie szczegółów...": "Részletek betöltése...",
        "Ładowanie task listy": "Feladatlista betöltése",
        "Ładowanie...": "Betöltés...",
        "Łączenie treści": "Tartalom összekapcsolása",
        "Łączny czas": "Összes idő",
        "Ma dostęp do dokumentu": "Hozzáfér a dokumentumhoz",
        "Maj": "Május",
        "Maksimum": "Maximum",
        "Maksymalna ilość plików": "Maximális fájlok száma",
        "Maksymalna rozdzielość %0x%1px": "Maximális felbontás %0x%1px",
        "Maksymalna szerokość kolumny (px)": "Oszlop maximális szélessége (px)",
        "Maksymalnie można wprowadzić 500 znaków": "Legfeljebb 500 karaktert adhat meg.",
        "Maksymalny rozmiar pliku w MB": "Maximális fájlméret MB-ban",
        "Maksymalny rozmiar pliku: %0MB.": "Maximális fájlméret: %0MB.",
        "Mała": "Kicsi",
        "Małe znaki": "Kisbetűk",
        "Mały": "Kicsi",
        "Mały układ siatki": "Kis rácselrendezés",
        "Mapowanie": "Leképezés",
        "Mappingi": "Leképezések",
        "Mapuję dane na odpowiednie pola...": "Adatok leképezése a megfelelő mezőkre...",
        "Marzec": "Március",
        "Mediana": "Medián",
        "Metadane": "Metaadatok",
        "Metoda": "Módszer",
        "Metoda autentykacji": "Ellenőrzési módszer",
        "Metoda musi zwracać obiekt \"entry.errors\".": "A módszernek vissza kell adnia az \"entry.errors\" objektumot.",
        "Metody": "Módszerek",
        "Miara podobieństwa (Wrtość od 1 do 5, gdzie 1 to największa dokładność)": "Hasonlósági mérőszám (1-től 5-ig, ahol 1 a legnagyobb pontosság)",
        "Miasto": "Város",
        "Miejsca po przecinku": "Tizedesjegyek száma",
        "Miejsce pracy": "Munkahely",
        "Miejscowość": "Település",
        "mies.": "hó.",
        "miesiąc": "Hónap",
        "Miesiąc": "Hónap",
        "Miesiące": "Hónapok",
        "Miesięczny": "Havi",
        "Migracje": "Migrációk",
        "Min. ilość elementów podobnych wymagana do automatyzacji": "Automatizáláshoz szükséges minimális hasonló elemek száma",
        "Miniaturki": "Bélyegképek",
        "Minimalna długość hasła": "Minimális jelszóhossz",
        "Minimalna szerokość kolumny (px)": "Oszlop minimális szélessége (px)",
        "Minimum": "Minimum",
        "Minuty": "Perc",
        "Mnożenie": "Szorzás",
        "Model": "Modell",
        "Model danych": "Adatmodell",
        "Moderacja danych wejściowych": "Bemeneti adatok moderálása",
        "Moduł": "Modul",
        "Moduł domyślny dla wsparcia AI": "Alapértelmezett modul AI támogatáshoz",
        "Moduł dynamiczny": "Dinamikus modul",
        "Moduł jest wymagany": "A modul kötelező",
        "Moduł statyczny": "Statikus modul",
        "Moduł został dodany.": "A modul hozzáadva.",
        "Moduł został usunięty.": "A modul törölve.",
        "Moduł został wyeksportowany.": "A modul exportálva.",
        "Moduł został zaktualizowany.": "A modul frissítve.",
        "Moduł został zapisany.": "A modul elmentve.",
        "Moduł został zmieniony pomyślnie.": "A modul sikeresen megváltozott.",
        "Moduły": "Modulok",
        "Modyfikacja": "Módosítás",
        "Modyfikacja dokumentów": "Dokumentumok módosítása",
        "Modyfikuj aktywny filtr": "Aktív szűrő módosítása",
        "Modyfikuj istniejący wątek": "Létező szál módosítása",
        "Moje aplikacje": "Saját alkalmazásaim",
        "Moje dokumenty": "Saját dokumentumaim",
        "Moje filtry": "A szűrőim",
        "Moje konto": "A fiókom",
        "Moje pliki": "Saját fájljaim",
        "Moje zadania": "Feladatköröm",
        "Monitor kolejek": "Sorfigyelő",
        "Monitoring": "Monitoring",
        "Monitoruj statystyki .NET": ".NET statisztikák figyelése",
        "Monitoruj żądania HTTP": "HTTP kérések figyelése",
        "Może zarządzać dokumentami w rejestrze.": "Kezelheti a dokumentumokat a nyilvántartásban.",
        "Może zarządzać fakturami w rejestrze. Powiązane z uprawnieniami \"Może dodawać\", \"Koordynator\", \"Księgowa\".": "Kezelheti a számlákat a nyilvántartásban. Kapcsolódó jogosultságok: \"Hozzáadhat\", \"Koordinátor\", \"Könyvelő\".",
        "Może zarządzać pismami w rejestrze. Powiązane z opcjami dodawania, przypisywania po przyjęciu, edycji.": "Kezelheti a leveleket a nyilvántartásban. Kapcsolódik a hozzáadás, hozzárendelés és szerkesztés lehetőségeihez.",
        "Może zarządzać pismami w rejestrze. Powiązane z opcją dodawania pism. Edycja dostępna jest tylko dla autora. Wysyłanie i dodawanie zwrotek.": "Kezelheti a leveleket a nyilvántartásban. Csak a szerző szerkesztheti. Küldés és visszajelzés hozzáadása.",
        "Może zarządzać rejestrem": "Kezelheti a nyilvántartást",
        "Może zarządzać reklamacjami w rejestrze. Powiązane z uprawnieniami \"Może dodawać\", \"Koordynator\", \"Specialista przepływu statusów\".": "Kezelheti a reklamációkat a nyilvántartásban. Kapcsolódó jogosultságok: \"Hozzáadhat\", \"Koordinátor\", \"Státuszfolyamat szakértő\".",
        "Może zarządzać umowami w rejestrze. Powiązane z opcją dodawania umów.": "Kezelheti a szerződéseket a nyilvántartásban. Kapcsolódik a szerződés hozzáadásához.",
        "Możesz podać nową nazwę pliku.": "Megadhat új fájlnevet.",
        "Możesz wybrać maksymalnie 10 elementów": "Legfeljebb 10 elemet választhatsz ki",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Ennek az osztálynak a módosítása korlátozott. A nem aktív mezők szinkronizálva vannak a külső adatbázissal: %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Ennek a fióknak a módosítása korlátozott. A nem aktív mezők szinkronizálva vannak a külső adatbázissal: %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "Ennek a fióknak a módosítása korlátozott. A nem aktív mezők szinkronizálva vannak a külső adatbázissal: %0.",
        "Możliwość wielokrotnego wyboru": "Többszörös választás lehetősége",
        "Mój tytuł": "Saját címem",
        "MPK": "MPK",
        "Musisz wybrać przynajmniej jedną grupę.": "Legalább egy csoportot ki kell választanod.",
        "Na diagramie procesu występują błędy. Sprawdź zakładkę \"Błędy\"": "A folyamatábrán hibák találhatók. Ellenőrizd a \"Hibák\" fület.",
        "Na pewno usunąć wybrane elementy?": "Biztosan törölni szeretné a kiválasztott elemeket?",
        "Na widoku nie będą dostępne akcje dokumentów łącznie z linkiem do szczegółów": "A nézetben nem lesznek elérhetők a dokumentum műveletek, beleértve a részletekhez vezető linket is.",
        "Nadaj dostęp do dokumentów powiązanych osobom, które mają dostęp do dokumentu głównego": "Adj hozzáférést a kapcsolódó dokumentumokhoz azoknak, akik hozzáférnek a fő dokumentumhoz.",
        "Nadawanie uprawnień do dokumentów": "Jogosultságok kiosztása dokumentumokhoz",
        "Nadawanie uprawnień do własnych dokumentów": "Jogosultságok kiosztása saját dokumentumokhoz",
        "Nadawanie uprawnień do wszystkich dokumentów": "Jogosultságok kiosztása minden dokumentumhoz",
        "Nadawca": "Feladó",
        "Nadpisz": "Felülír",
        "Nadpisz konfigurację": "Konfiguráció felülírása",
        "Nadpisz skrypt": "Szkript felülírása",
        "Nadpisz skrypt po przetworzeniu dokumentu": "Szkript felülírása a dokumentum feldolgozása után",
        "Nadpisz skrypt współdzielony": "Megosztott szkript felülírása",
        "Nagłówek": "Fejléc",
        "Nagłówek dokumentu": "Dokumentum fejléc",
        "Najstarsza wiadomość": "Legrégebbi üzenet",
        "Należy wybrać moduł": "Modult kell választani",
        "Należy wybrać silnik skryptowy": "Szkriptmotort kell választani",
        "Nałóż warstwę tekstową dla plików PDF": "Szövegréteg hozzáadása PDF fájlokhoz",
        "Narzędzia": "Eszközök",
        "Narzędzie integruje się z platformą SMSAPI.pl": "Az eszköz integrálva van az SMSAPI.pl platformmal",
        "Następna": "Következő",
        "Następna strona": "Következő oldal",
        "Nazwa": "Név",
        "Nazwa (wymagane)": "Név (kötelező)",
        "Nazwa aliasu": "Aliasz neve",
        "Nazwa asystenta": "Asszisztens neve",
        "Nazwa bazy danych": "Adatbázis neve",
        "Nazwa działu": "Osztály neve",
        "Nazwa filtra": "Szűrő neve",
        "Nazwa formularza": "Űrlap neve",
        "Nazwa funkcji": "Függvény neve",
        "Nazwa indeksu": "Index neve",
        "Nazwa jest wymagana": "A név kötelező",
        "Nazwa katalogu": "Mappa neve",
        "Nazwa katalogu została zmieniona.": "A mappa neve megváltozott.",
        "Nazwa klienta": "Ügyfél neve",
        "Nazwa kolumny": "Oszlop neve",
        "Nazwa kolumny jest wymagana.": "Az oszlop neve kötelező.",
        "Nazwa kolumny z opisem": "Leírás oszlop neve",
        "Nazwa kolumny z wartością": "Érték oszlop neve",
        "Nazwa komponentu": "Komponens neve",
        "Nazwa konta (Klucz dostępu)": "Fiók neve (hozzáférési kulcs)",
        "Nazwa kontrahenta": "Partner neve",
        "Nazwa modelu": "Modell neve",
        "Nazwa modułu": "Modul neve",
        "Nazwa musi mieć co najmniej 3 znaki": "A névnek legalább 3 karakterből kell állnia",
        "Nazwa musi mieć co najmniej 5 znaków": "A névnek legalább 5 karakterből kell állnia",
        "Nazwa na grafie": "Név a grafikonon",
        "Nazwa nadawcy": "Feladó neve",
        "Nazwa narzędzia": "Eszköz neve",
        "Nazwa nie może być dłuższa niż 30 znaków": "A név nem lehet hosszabb 30 karakternél",
        "Nazwa nie może być dłuższy niż 50 znaków": "A név nem lehet hosszabb 50 karakternél",
        "Nazwa pliku": "Fájl neve",
        "Nazwa pliku została zmieniona.": "A fájl neve megváltozott.",
        "Nazwa pola": "Mező neve",
        "Nazwa pola na formularzu": "Mező neve az űrlapon",
        "Nazwa pola z różnicą": "Különbség mező neve",
        "Nazwa pola z sumą": "Összeg mező neve",
        "Nazwa powiadomienia": "Értesítés neve",
        "Nazwa przycisku": "Gomb neve",
        "Nazwa przycisku ``Dalej``": "``Tovább`` gomb neve",
        "Nazwa przycisku ``Wstecz``": "``Vissza`` gomb neve",
        "Nazwa przycisku ``Wyślij``": "``Küldés`` gomb neve",
        "Nazwa przycisku na formularzu": "Gomb neve az űrlapon",
        "Nazwa roli": "Szerep neve",
        "Nazwa sekcji w menu": "Menü szekció neve",
        "Nazwa sekcji...": "Szekció neve...",
        "Nazwa serii": "Sorozat neve",
        "Nazwa serwera": "Szerver neve",
        "Nazwa skrócona": "Rövidített név",
        "Nazwa spółki": "Vállalat neve",
        "Nazwa szablonu": "Sablon neve",
        "Nazwa typu": "Típus neve",
        "Nazwa urządzenia": "Eszköz neve",
        "Nazwa użytkownika": "Felhasználónév",
        "Nazwa użytkownika serwisowego": "Szerviz felhasználónév",
        "Nazwa w indeksie": "Név az indexben",
        "Nazwa wątku": "Szál neve",
        "Nazwa webhooka": "Webhook neve",
        "Nazwa wersji": "Verzió neve",
        "Nazwa zadania": "Feladat neve",
        "Nazwa zakładki": "Fül neve",
        "Nazwa zasobu": "Erőforrás neve",
        "Nazwa zespołu": "A zenekar neve",
        "Nazwa źródła": "Forrás neve",
        "Nazwa źródła danych": "Adatforrás neve",
        "Nazwisko": "Vezetéknév",
        "Nazwy wartości": "Értékek nevei",
        "Nicość - nie zapisuj": "Semmi - ne mentsd el",
        "Nie": "Nem",
        "Nie loguj wybranych": "Ne naplózd a kiválasztottakat",
        "Nie ma użytkowników, którym można odebrać uprawnienia do dokumentu": "Nincsenek felhasználók, akiktől el lehetne venni a dokumentum jogosultságát",
        "Nie masz uprawnień do panelu administracyjnego.": "Nincs jogosultságod az adminisztrációs panelhez.",
        "Nie masz uprawnień do tego dokumentu": "Nincs jogosultságod ehhez a dokumentumhoz",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "Nincs jogosultságod ehhez a nézethez. A nézet állapota megváltozhatott, frissítsd és ellenőrizd, vagy próbáld újra később.",
        "Nie możesz dodać tego samego widgetu dwa razy": "Ugyanazt a widgetet nem lehet kétszer hozzáadni",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "Nem módosíthatod a helyettesített felhasználó profilját.",
        "Nie możesz modyfikować uprawnień": "Nem módosíthatod a jogosultságokat",
        "Nie można usunąć swojego konta.": "Nem törölheted a saját fiókodat.",
        "Nie odnaleziono kontrahenta o podanym numerze NIP w bazie GUS.": "Nem található partner a megadott NIP számmal a GUS adatbázisban.",
        "Nie podano ID procesu, którego dotyczy formularz": "Nem adták meg a folyamat azonosítóját, amelyhez az űrlap tartozik",
        "Nie podano wymaganej ilości znaków: %0.": "A szükséges karakterek száma nincs megadva: %0.",
        "Nie stosuj pogrubienia do nieodczytanych dokumentów.": "",
        "Nie udało się dopasować do modułu. Dokument trafił do modułu domyślnego:": "Nem sikerült modulhoz rendelni. A dokumentum az alapértelmezett modulba került:",
        "Nie udało się pobrać akcji": "Nem sikerült lekérni az akciókat",
        "Nie udało się pobrać historii": "Nem sikerült lekérni az előzményeket",
        "Nie udało się pobrać listy celów": "Nem sikerült lekérni a célok listáját",
        "Nie udało się pobrać listy działów": "Nem sikerült lekérni az osztályok listáját",
        "Nie udało się pobrać listy filtrów": "Nem sikerült lekérni a szűrők listáját",
        "Nie udało się pobrać listy kanałów": "Nem sikerült lekérni a csatornák listáját",
        "Nie udało się pobrać listy kolejek": "Nem sikerült lekérni a várólisták listáját",
        "Nie udało się pobrać listy powiadomień": "Nem sikerült lekérni az értesítések listáját",
        "Nie udało się pobrać listy ról": "Nem sikerült lekérni a szerepek listáját",
        "Nie udało się pobrać listy serwerów baz danych": "Nem sikerült lekérni az adatbázis szerverek listáját",
        "Nie udało się pobrać listy serwerów plików": "Nem sikerült lekérni a fájlszerverek listáját",
        "Nie udało się pobrać listy spółek": "Nem sikerült lekérni a vállalatok listáját",
        "Nie udało się pobrać listy typów danych.": "Nem sikerült lekérni az adattípusok listáját.",
        "Nie udało się pobrać listy typów modeli": "Nem sikerült lekérni a modell típusok listáját",
        "Nie udało się pobrać listy wpisów.": "Nem sikerült lekérni a bejegyzések listáját.",
        "Nie udało się pobrać listy wydziałów": "Nem sikerült lekérni a tanszékek listáját",
        "Nie udało się pobrać listy zespołów": "Nem sikerült lekérni a csapatok listáját",
        "Nie udało się pobrać logów": "Nem sikerült lekérni a naplókat",
        "Nie udało się pobrać logów procesu": "Nem sikerült lekérni a folyamat naplóit",
        "Nie udało się pobrać obrazu.": "Nem sikerült lekérni a képet.",
        "Nie udało się pobrać powiadomień.": "Nem sikerült lekérni az értesítéseket.",
        "Nie udało się pobrać szczegółów": "Nem sikerült lekérni a részleteket",
        "Nie udało się pobrać szczegółów logu": "Nem sikerült lekérni a napló részleteit",
        "Nie udało się pobrać url do podpisu dokumentu": "Nem sikerült lekérni a dokumentum aláírási URL-jét",
        "Nie udało się pobrać ustawień kont użytkowników": "Nem sikerült lekérni a felhasználói fiókok beállításait",
        "Nie udało się pobrać widgetu/ów": "Nem sikerült lekérni a widget(ek)et",
        "Nie udało się skopiować do schowka": "Nem sikerült a vágólapra másolni",
        "Nie udało się usunąć szablonu": "Nem sikerült törölni a sablont",
        "Nie udało się utworzyć nowej wersji": "Nem sikerült új verziót létrehozni",
        "Nie udało się wyeksportować pliku XML.": "Nem sikerült exportálni az XML fájlt.",
        "Nie udało się wykonać akcji": "Nem sikerült végrehajtani a műveletet",
        "Nie udało się wysłać pliku": "Nem sikerült elküldeni a fájlt",
        "Nie udało się załadować diagramu procesu.": "Nem sikerült betölteni a folyamatábrát.",
        "Nie udało się załadować Szafir Host. Zamknij aplikację do podpisów, jeśli jest otwarta, odśweiż stronę i wykonaj akcję ponownie.": "Nem sikerült betölteni a Szafir Hostot. Zárd be az aláíró alkalmazást, ha nyitva van, frissítsd az oldalt és próbáld újra.",
        "Nie udało się załadować widgetu AI.": "Nem sikerült betölteni az AI widgetet.",
        "Nie udało się zapisać filtra": "Nem sikerült elmenteni a szűrőt",
        "Nie udało się zapisać formularza": "Nem sikerült elmenteni az űrlapot",
        "Nie udało się zapisać szablonu": "Nem sikerült elmenteni a sablont",
        "Nie wszystkie pola zostały wypelnione prawidłowo.": "Nem minden mező lett helyesen kitöltve.",
        "Nie wszystkie pola zostały wypełnione prawidłowo": "Nem minden mező lett helyesen kitöltve",
        "Nie wszystkie pola zostały wypełnione prawidłowo.": "Nem minden mező lett helyesen kitöltve.",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Nem minden kiválasztott elem lett áthelyezve. Nincs megfelelő jogosultságod, vagy a célmappa az eredeti mappa almappája. Azokat a mappákat és fájlokat, amelyeket nem sikerült áthelyezni, továbbra is a Kiválasztottak fülön találod.",
        "Nie wszystkie wymagane pola zostały wypełnione": "Nem minden kötelező mező lett kitöltve",
        "Nie wybrano żadnego użytkownika.": "Nem választottál ki felhasználót.",
        "Nie wybrano żadnych filtrów": "Nem választottál ki szűrőt",
        "Nie wygenerowano żadnej task listy.": "Nem generáltak feladatlistát.",
        "Nie wymaga uwierzytelniania": "Nem igényel hitelesítést",
        "nie wymuszaj zmiany hasła": "Ne kényszerítsen jelszóváltoztatást",
        "Nie zdefiniowano żadnych ról.": "Nincsenek szerepek definiálva.",
        "Nie zdefiniowano żadnych spółek.": "Nincsenek vállalatok definiálva.",
        "Nie znaleziono dostępnych widgetów": "Nem található elérhető widget",
        "Nie znaleziono filtrów.": "Nem található szűrő.",
        "Nie znaleziono formularza.": "Nem található űrlap.",
        "Nie znaleziono kolumn.": "Nem található oszlop.",
        "Nie znaleziono pasującego widgetu": "Nem található megfelelő widget",
        "Nie znaleziono pasujących elementów.": "Nem található megfelelő elem.",
        "Nie znaleziono szczegółów logu": "Nem található napló részlet",
        "Nie znaleziono żadnego pola.": "Nem található mező.",
        "Nie znaleziono żadnych akcji": "Nem található művelet",
        "Nie znaleziono żadnych plików": "Nem található fájl",
        "Nie znaleziono żadnych użytkowników.": "Nem található felhasználó.",
        "Nie znaleziono żadnych wyników.": "Nem található eredmény.",
        "Nieaktywne": "Inaktív",
        "Nieaktywni": "Inaktívak",
        "Nieaktywny": "Inaktív",
        "niedozwolone rozszerzenie pliku (%0)": "Nem engedélyezett fájlkiterjesztés (%0)",
        "niedozwolony typ pliku (%0)": "Nem engedélyezett fájltípus (%0)",
        "Niedziela": "Vasárnap",
        "Nieopublikowany": "Nem publikált",
        "Niepoprawna nazwa kolumny.": "Hibás oszlopnév.",
        "Niepoprawne wyrażenie regularne": "Hibás reguláris kifejezés",
        "Niepotwierdzeni": "Nem megerősítettek",
        "Nieprawidłowa definicja": "Hibás definíció",
        "Nieprawidłowy adres email": "Hibás e-mail cím",
        "Nieprawidłowy adres URL": "Hibás URL cím",
        "Nieprawidłowy format dokumentu. Aby podpisać dokument przekonwertuj go na format PDF": "Hibás dokumentumformátum. Az aláíráshoz konvertáld PDF formátumba.",
        "Nieprawidłowy lub wygasły token dostępu": "Hibás vagy lejárt hozzáférési token",
        "Nieprzeczytane": "Olvasatlan",
        "Niestandardowy błąd": "Egyedi hiba",
        "Nieudane": "Sikertelen",
        "Nieudane próby logowania": "Sikertelen bejelentkezési próbálkozások",
        "Niewidoczne": "Láthatatlan",
        "Nieznane narzędzie": "Ismeretlen eszköz",
        "Nieznany model": "Ismeretlen modell",
        "Nieznany typ pliku": "Ismeretlen fájltípus",
        "Nigdy": "Soha",
        "Nikomu nie przydzielono uprawnień": "Senki sem kapott jogosultságot",
        "Niniejsza strona wykorzystuje komponenty podpisu elektronicznego ": "Ez az oldal elektronikus aláírási komponenseket használ ",
        "NIP": "NIP",
        "NIP: ": "NIP: ",
        "no-store (wyłącza cache)": "no-store (cache kikapcsolva)",
        "Nowa data": "Új dátum",
        "Nowe hasło": "Új jelszó",
        "Nowi akceptanci": "Új jóváhagyók",
        "np. (&(objectClass=organizationalUnit))": "pl. (&(objectClass=organizationalUnit))",
        "np. (&(objectClass=user)": "pl. (&(objectClass=user)",
        "Nr budynku": "Épület száma",
        "Nr konta bankowego": "Bankszámlaszám",
        "Nr lokalu": "Lakás száma",
        "Nr telefonu": "Telefonszám",
        "Numer budynku": "Épület száma",
        "Numer dokumentu będzie uzupełniany zerami wiodącymi": "A dokumentum száma vezető nullákkal lesz kiegészítve",
        "Numer domu": "Házszám",
        "Numer kolejny": "Sorszám",
        "Numer KRS": "KRS szám",
        "Numer lokalu": "Lakás száma",
        "Numer mieszkania": "Lakás száma",
        "Numer osobowy HCM": "HCM személyi szám",
        "Numer pokoju": "Szobaszám",
        "Numer REGON": "REGON szám",
        "Numer sesji": "Munkamenet száma",
        "Numer telefonu": "Telefonszám",
        "Numeruj używając licznika wg daty": "Számozás dátum szerinti számlálóval",
        "OAuth2 dla Exchange Online": "OAuth2 mert Exchange Online",
        "Obecnie edytowana wersja procesu jest używana w wersjach modułu": "A jelenleg szerkesztett folyamatverziót a modul verzióiban használják",
        "Obiekt": "Objektum",
        "Obiekt %0 został %1": "Az objektum %0 lett %1",
        "Obiekt ma strukturę Dictionary<string, object>[] z C#": "Az objektum szerkezete: Dictionary<string, object>[] C#-ban",
        "Obliczenie godzin między datami z pierwszego i ostatniego wiersza": "Órák kiszámítása az első és utolsó sor dátumai között",
        "Obok siebie": "Egymás mellett",
        "Obraz został pomyślnie opisany": "A kép sikeresen leírásra került",
        "Obraz został wycięty.": "A kép kivágva.",
        "Obraz został wygenerowany.": "A kép generálva lett.",
        "Obsługiwane formaty plików: txt, md, pdf, docx.": "Támogatott fájlformátumok: txt, md, pdf, docx.",
        "OCR": "OCR",
        "Oczekuje na akceptacje": "Jóváhagyásra vár",
        "Oczekuje na wysłanie": "Küldésre vár",
        "od": "tól",
        "Od": "Tól",
        "od %0": "tól %0",
        "Odbierz uprawnienia do dokumentu": "Vond vissza a dokumentum jogosultságát",
        "Odbierz uprawnienie": "Jogosultság visszavonása",
        "Odbiorca": "Címzett",
        "Odblokuj": "Feloldás",
        "Odczytuję informacje z dokumentu...": "Információk olvasása a dokumentumból...",
        "Oddalenie diagramu": "",
        "Odejmowanie": "Kivonás",
        "Odpowiedzi": "Válaszok",
        "Odpowiedzi: %0 na %1": "Válaszok: %0 / %1",
        "Odpowiedź": "Válasz",
        "Odpowiedź dowolna": "Tetszőleges válasz",
        "Odrzucone": "Elutasított",
        "Odrzucono:": "Elutasítva:",
        "Odrzucony": "Elutasított",
        "Odrzuć": "Elutasít",
        "Odstęp": "Távolság",
        "Odśwież": "Frissítés",
        "Odtwórz indeks": "Index újragenerálása",
        "Odtwórz wszystkie indeksy": "Minden index újragenerálása",
        "Odwołanie do klucza pierwszego wybranego terminu słownika w polu Słownik Logito": "Hivatkozás az első kiválasztott szótári kulcsra a Logito szótár mezőben",
        "Odwołanie do pól terminu słownika (np. stawka VAT)": "Hivatkozás a szótári kifejezés mezőire (pl. ÁFA kulcs)",
        "Odwołanie do wartości pola numerycznego": "Hivatkozás a numerikus mező értékére",
        "Odznacz": "Kijelölés törlése",
        "Odznacz wszystkie": "Minden kijelölés törlése",
        "Ogólne": "Általános",
        "Ok": "Ok",
        "Omnitool": "Omnitool",
        "OneDrive": "OneDrive",
        "Opcje": "Opciók",
        "OpenAI": "OpenAI",
        "Operacje": "Műveletek",
        "Operator.!.(Dokument.Pola dokumentu.{Nazwa pola})": "Operátor.!.(Dokumentum.DokumentumMezők.{MezőNév})",
        "Opiekun": "Gondviselő",
        "Opis": "Leírás",
        "Opis błędu": "Hiba leírása",
        "Opis faktury": "Számla leírása",
        "Opis funkcji": "Függvény leírása",
        "Opis kodami kontrolingowymi": "Leírás controlling kódokkal",
        "Opis obrazu": "Kép leírása",
        "Opis pola (drobny tekst pod polem na formularzu)": "Mező leírása (kis szöveg a mező alatt az űrlapon)",
        "Opis skrócony": "Rövid leírás",
        "Opis zespołu": "A csapat leírása",
        "Opis źródła": "Forrás leírása",
        "Opisy": "Leírások",
        "Optymalizuj rozdzielczość obrazów": "Optimalizáld a képek felbontását",
        "Opublikowano wersję": "Verzió publikálva",
        "Opublikowany": "Publikált",
        "oraz": "valamint",
        "oraz aplikacji udostępniającej funkcje podpisu elektronicznego.": "valamint az elektronikus aláírási funkciókat biztosító alkalmazás.",
        "Oraz hasło": "És jelszó",
        "Oraz nowe hasło": "És új jelszó",
        "Organizacja": "Szervezet",
        "Organizacja została usunięta.": "A szervezet törölve lett.",
        "Orientacja wydruku": "Nyomtatás tájolása",
        "OriginId": "OriginId",
        "Osoba": "Személy",
        "Osoba zastępowana": "A helyettesített személy",
        "Osoba zastępująca": "Helyettesítő",
        "Osoby które mają dostęp do dokumentu": "Azok a személyek, akik hozzáférnek a dokumentumhoz",
        "Osoby które realizują obecnie zadanie w obiegu dokumentu": "Azok a személyek, akik jelenleg feladatot végeznek a dokumentum körforgásában",
        "Osoby zaproszone": "Meghívott személyek",
        "Ostatnia aktywność": "Utolsó aktivitás",
        "Ostatnia strona": "Utolsó oldal",
        "ostatnie sprawdzenie": "utolsó ellenőrzés",
        "Ostatnio dodane": "Legutóbb hozzáadva",
        "Ostrzeżenia": "Figyelmeztetések",
        "Ostrzeżenie": "Figyelmeztetés",
        "Otwórz": "Megnyitás",
        "Otwórz heatmapę": "",
        "Otwórz licznik na kolejny miesiąc": "Számláló megnyitása a következő hónapra",
        "Otwórz licznik na kolejny rok": "Számláló megnyitása a következő évre",
        "Otwórz modal po wykonaniu akcji": "Modális ablak megnyitása művelet után",
        "Otwórz wyszukiwarkę": "Kereső megnyitása",
        "Oznacz": "Jelölés",
        "Oznacz jako nieodczytany": "Jelöld olvasatlanként",
        "Oznacz jako nieprzeczytane": "Jelöld olvasatlanként",
        "Oznacz jako przeczytane": "Jelöld olvasottként",
        "Oznacz powiadomienia": "Jelölje meg az értesítéseket",
        "Oznacz wszystkie jako przeczytane": "Jelöld mindet olvasottként",
        "Oznacz wybrane jako nieprzeczytane": "Jelöld a kiválasztottakat olvasatlanként",
        "Oznacz wybrane jako przeczytane": "Jelöld a kiválasztottakat olvasottként",
        "Paleta kolorów": "Színpaletta",
        "Parametry funkcji": "Függvény paraméterei",
        "Parametry, wymagane do wykonania zapytania:": "A lekérdezéshez szükséges paraméterek:",
        "Pasek": "Sáv",
        "Pasek postępu": "Folyamatjelző sáv",
        "Październik": "Október",
        "Pełne dane": "Teljes adatok",
        "Pełny": "Teljes",
        "PESEL": "PESEL",
        "PESEL: ": "PESEL: ",
        "PH": "PH",
        "Piątek": "Péntek",
        "Pierwiastkowanie wartości kolumny": "Oszlopérték gyökvonása",
        "Pierwsza strona": "Első oldal",
        "Pigułki": "Tabletták",
        "Piktogram": "Piktogram",
        "pismo przychodzące": "Bejövő levél",
        "Plik audio": "Hangfájl",
        "Plik binarny": "Bináris fájl",
        "Plik CSS": "CSS fájl",
        "Plik CSV": "CSV fájl",
        "Plik DOC": "DOC fájl",
        "Plik DOCX": "DOCX fájl",
        "Plik GIF": "GIF fájl",
        "Plik HTML": "HTML fájl",
        "Plik importowy": "Import fájl",
        "Plik jest wysyłany": "A fájl küldés alatt van",
        "Plik JPEG": "JPEG fájl",
        "Plik JPG": "JPG fájl",
        "Plik MP4": "MP4 fájl",
        "Plik PNG": "PNG fájl",
        "Plik skompresowany": "Tömörített fájl",
        "Plik tekstowy json": "JSON szövegfájl",
        "Plik tekstowy txt": "TXT szövegfájl",
        "Plik zawiera niepoprawne dane w komórkach": "A fájl hibás adatokat tartalmaz a cellákban",
        "Plik ZIP": "ZIP fájl",
        "Plik został dodany.": "A fájl hozzáadva.",
        "Plik został usunięty.": "A fájl törölve.",
        "Plik został wysłany": "A fájl elküldve",
        "Pliki": "Fájlok",
        "Pliki Asystent": "Asszisztens fájlok",
        "Pliki Asystenta": "Asszisztens fájlok",
        "Pliki asystenta AI": "AI asszisztens fájlok",
        "Pliki do wysłania: %0": "Küldendő fájlok: %0",
        "Pliki prywatne": "Privát fájlok",
        "Pliki publiczne": "Nyilvános fájlok",
        "Pliki współdzielone": "Megosztott fájlok",
        "Pliki: %0": "Fájlok: %0",
        "po %0 nieudanych próbach logowania": "%0 sikertelen bejelentkezési kísérletek után",
        "Po jednym synonimie w wierszu": "Egy szinonima soronként",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "Ha ezt az opciót választod, a felhasználói fiókok törlésre kerülnek a rendszerből. Folytatni szeretnéd?",
        "Po zainstalowaniu aplikacji Szafir Host przeładuj bieżącą stronę!": "A Szafir Host alkalmazás telepítése után frissítsd az oldalt!",
        "Po zainstalowaniu rozszerzenia należy przeładować bieżącą stronę!": "A bővítmény telepítése után frissítsd az oldalt!",
        "Po zakończonym imporcie wyświetli się podsumowanie o ilości zaimportowanych/odrzuconych rekordów oraz lista błędów dla wierszy odrzuconych": "Az import befejezése után megjelenik az összesítés az importált/elutasított rekordokról és a hibák listája az elutasított sorokhoz.",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "Ha ezt az opciót választod, az egyéni és szerephez tartozó jogosultságok nem lesznek figyelembe véve.",
        "Pobierz": "Letöltés",
        "Pobierz dane z GUS": "Adatok letöltése a GUS-ból",
        "Pobierz i zainstaluj aplikację": "Töltsd le és telepítsd az alkalmazást",
        "Pobierz raport błędów": "Hibalista letöltése",
        "Pobierz szablon": "Sablon letöltése",
        "Początkowa ilość wierszy": "Kezdeti sorok száma",
        "Poczta": "Posta",
        "Pod zmienną Entry dostępne są także dane formularza": "Az Entry változóban az űrlap adatai is elérhetők",
        "Podaj NIP": "Add meg a NIP-et",
        "Podaj nową nazwę": "Adj meg új nevet",
        "Podaj swój adres email": "Add meg az e-mail címed",
        "Podana nazwa jest zajęta.": "A megadott név már foglalt.",
        "Podana wartość jest nieprawidłowa.": "A megadott érték érvénytelen.",
        "Podanie nazwy jest wymagane.": "A név megadása kötelező.",
        "Podano adres": "Cím megadva",
        "Podano nieprawidłowe dane": "Hibás adatokat adtál meg",
        "Podano nieprawidłowe dane.": "Hibás adatokat adtál meg.",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "Az első indításkor létre kell hozni a fő adminisztrátor fiókját.",
        "Podczas wykonywania skryptu lub service taska na tej akcji wystąpił błąd.": "A szkript vagy service task futtatása közben hiba történt ezen a műveleten.",
        "Podgląd": "Előnézet",
        "Podgląd dokumentu": "Dokumentum előnézete",
        "Podgląd formularza": "Űrlap előnézete",
        "Podgląd jest dostępny jedynie po zapisaniu szablonu": "Az előnézet csak a sablon mentése után érhető el",
        "Podgląd niedostępny w trybie projektowania": "Előnézet nem elérhető tervezési módban",
        "Podgląd przycisku": "Gomb előnézete",
        "Podgląd tabeli": "Táblázat előnézete",
        "Podkreślenie": "Aláhúzás",
        "Podpis": "Aláírás",
        "Podpis dokumentu": "Dokumentum aláírása",
        "Podpis elektroniczny Szafir SDK": "Szafir SDK elektronikus aláírás",
        "Podpisz dokument": "Dokumentum aláírása",
        "Podstawowe": "Alapvető",
        "Podstawowe operacje na datach": "Alapvető dátumműveletek",
        "Podstawowe operacje na liczbach": "Alapvető számítási műveletek",
        "Podstawowe operacje tekstowe": "Alapvető szövegműveletek",
        "Podstawowe operacje warunkowe": "Alapvető feltételes műveletek",
        "Podstawowy": "Alap",
        "Podsumowanie dla całego zestawu danych": "",
        "Podsumowanie dla strony": "",
        "Podsumowanie kolumn": "",
        "Podwładni": "Beosztottak",
        "Podział na pliki": "Felosztás fájlokra",
        "Podziedziałek - Piątek": "Hétfő - Péntek",
        "Podziel widok terminarza wg": "Naptárnézet felosztása szerint",
        "Pogrubienie etykiety": "Címke félkövér",
        "Pogrubienie wartości": "Érték félkövér",
        "Pojedynczy dokument": "Egyetlen dokumentum",
        "Pojedynczy wybór": "Egyszeres választás",
        "Pokazuj wszystkie": "Mutasd mindet",
        "Pokazuj wybrane": "Mutasd a kiválasztottakat",
        "Pokazywane są tylko rekordy, gdzie różnica jest różna od 0": "Csak azok a rekordok jelennek meg, ahol a különbség nem nulla",
        "Pokaż": "Mutasd",
        "Pokaż etykietę": "Címke megjelenítése",
        "Pokaż etykietę nad wartością": "Címke megjelenítése az érték felett",
        "Pokaż etykiety bez wartości": "Címkék érték nélkül megjelenítése",
        "Pokaż filtry": "Szűrők megjelenítése",
        "Pokaż filtry na liście": "Szűrők megjelenítése a listán",
        "Pokaż fukncję dowiązania dokumentów wg uprawnień": "Dokumentumok összekapcsolása jogosultság szerint",
        "Pokaż godziny robocze": "Munkaidő megjelenítése",
        "Pokaż heatmapę": "Hőtérkép megjelenítése",
        "Pokaż historię": "Előzmények megjelenítése",
        "Pokaż ikonę": "Ikon megjelenítése",
        "Pokaż kolumnę z liczbą porządkową": "Sorszám oszlop megjelenítése",
        "Pokaż numer tygodnia na kalendarzu": "Hét számának megjelenítése a naptárban",
        "Pokaż numery stron": "Oldalszámok megjelenítése",
        "Pokaż pager": "Lapozó megjelenítése",
        "Pokaż pełne godziny": "Teljes órák megjelenítése",
        "Pokaż pochodzenie uprawnienia": "Jogosultság eredetének megjelenítése",
        "Pokaż przycisk ``Wyślij``": "``Küldés`` gomb megjelenítése",
        "Pokaż przycisk akcji": "Művelet gomb megjelenítése",
        "Pokaż przycisk dla akcji": "Művelet gomb megjelenítése",
        "Pokaż przycisk operacji grupowych": "Csoportos művelet gomb megjelenítése",
        "Pokaż tylko moje dokumenty": "Csak a saját dokumentumok megjelenítése",
        "Pokaż tytuł": "Cím megjelenítése",
        "Pokaż tytuł formularza": "Űrlap címének megjelenítése",
        "Pokaż tytuł sekcji": "Szekció címének megjelenítése",
        "Pokaż tytuł strony": "Oldal címének megjelenítése",
        "Pokaż tytuły stron": "Oldalcímek megjelenítése",
        "Pokaż w koncie użytkownika": "Megjelenítés a felhasználói fiókban",
        "Pokaż wartości na wykresie": "Értékek megjelenítése a diagramon",
        "Pokaż więcej": "Mutass többet",
        "Pokaż więcej komentarzy": "További hozzászólások megjelenítése",
        "pokaż więcej...": "több megjelenítése...",
        "Pokaż Wykres pod tabelą": "Diagram megjelenítése a táblázat alatt",
        "Pokaż załączniki dokumentów powiązanych": "Kapcsolódó dokumentumok mellékleteinek megjelenítése",
        "Pokaż załączniki dokumentu": "Dokumentum mellékleteinek megjelenítése",
        "Pokój": "Szoba",
        "Pola": "Mezők",
        "Pola do wyświetlania": "Megjelenítendő mezők",
        "Pola do wyświetlenia": "Megjelenítendő mezők",
        "Pola do zgrupowania": "Csoportosítandó mezők",
        "Pola dokumentu": "Dokumentum mezői",
        "Pola formularzy": "Űrlap mezői",
        "Pola mapowane": "Leképezett mezők",
        "Pola mapowane (excel)": "Leképezett mezők (Excel)",
        "Pola należące do grupy": "Csoporthoz tartozó mezők",
        "Pola opisujące wiadomość": "Üzenetet leíró mezők",
        "Pola systemowe": "Rendszermezők",
        "Pola tekstowe": "Szövegmezők",
        "Pola wspólne": "Közös mezők",
        "Pola wyliczane": "Számított mezők",
        "Pola wyświetlane": "Megjelenített mezők",
        "Pola z formularza: ": "Űrlap mezői: ",
        "Pola zgrupowane": "Csoportosított mezők",
        "Pola zostały zgrupowane.": "A mezők csoportosítva lettek.",
        "Pola źródłowe": "Forrásmezők",
        "Pole": "Mező",
        "Pole \"%0\" jest wymagane.": "A(z) \"%0\" mező kötelező.",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "A(z) \"%0\" mező nem tartalmaz érvényes e-mail címet.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "A(z) \"%0\" mező nem tartalmaz érvényes URL-t.",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "A(z) \"%0\" mező tiltott értéket tartalmaz.",
        "Pole \"Drugie imię\" jest wymagane.": "A \"Második keresztnév\" mező kötelező.",
        "Pole \"Imię\" jest wymagane.": "A \"Keresztnév\" mező kötelező.",
        "Pole \"Nazwisko\" jest wymagane.": "A \"Vezetéknév\" mező kötelező.",
        "Pole \"Tytuł\" jest wymagane.": "A \"Cím\" mező kötelező.",
        "Pole do mapowania importu Excel": "Excel import leképezési mező",
        "Pole do wyliczenia": "Számítandó mező",
        "Pole dotyczy tabeli VAT, prompt jest dodawany automatycznie przez system": "A mező az ÁFA táblázatra vonatkozik, a promptot a rendszer automatikusan hozzáadja",
        "Pole formularza": "Űrlap mező",
        "Pole jest wymagane": "A mező kötelező",
        "Pole kwoty docelowej": "Célösszeg mező",
        "Pole kwoty źródłowej": "Forrásösszeg mező",
        "Pole może zawierać jedynie cyfry.": "A mező csak számokat tartalmazhat.",
        "Pole może zawierać jedynie litery i cyfry.": "A mező csak betűket és számokat tartalmazhat.",
        "Pole może zawierać jedynie litery.": "A mező csak betűket tartalmazhat.",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "A mező csak natív JavaScript kódot tartalmazó adatellenőrző metódust tartalmazhat.",
        "Pole na zapis wydruku": "Nyomtatás mentési mező",
        "Pole nie może zawierać spacji": "A mező nem tartalmazhat szóközt",
        "Pole powiązane": "Kapcsolódó mező",
        "Pole powiązania dokumentu": "Dokumentumkapcsolat mező",
        "Pole priorytetowe": "Prioritás mező",
        "Pole skopiowane": "Mező másolva",
        "Pole tekstowe": "Szövegmező",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "A(z) \"%0\" típusú mező nem engedélyezett ebben az űrlapban.",
        "Pole wspólne zostało dodane.": "A közös mező hozzáadva.",
        "Pole wspólne zostało usunięte": "A közös mező törölve lett.",
        "Pole wspólne zostało zaktualizowane.": "A közös mező frissítve lett.",
        "Pole wymagane": "Kötelező mező",
        "Pole z argumentem": "Mező argumentummal",
        "Pole z datą": "Dátum mező",
        "Pole z datą wg której liczymy kurs": "Az árfolyam számításához használt dátum mező",
        "Pole z dokumentem": "Dokumentum mező",
        "Pole z rozwiązaniem": "Megoldás mező",
        "Pole z wartością do walidacjij": "Érték mező validációhoz",
        "Pole z załącznikami": "Csatolmány mező",
        "Pole zawiera": "A mező tartalmazza",
        "Pole ze zdjęciami": "Képek mező",
        "Pole ze zdjęciem głównym": "Fő kép mező",
        "Pole zostało rozgrupowane.": "A mező csoportbontva lett.",
        "Pole zostało zaktualizowane.": "A mező frissítve lett.",
        "Polityka prywatności": "Adatvédelmi irányelvek",
        "Polski": "Lengyel",
        "Połącz – szybkie łączenie bloków": "",
        "Pomiędzy": "Között",
        "Pomijanie kolejkowania": "Sorba állítás kihagyása",
        "Pomiń pierwszy wiersz excela": "Az Excel első sorának kihagyása",
        "Pomiń wysłanie powiadomienia w przypadku braku dokumentów": "Ha nincs dokumentum, ne küldjön értesítést.",
        "Pomoc": "Segítség",
        "Pomyślnie przywrócono konfigurację domyślną": "Az alapértelmezett konfiguráció sikeresen visszaállítva.",
        "Pomyślnie uruchomiono proces reindeksacji": "A reindexálási folyamat sikeresen elindítva.",
        "Pomyślnie usunięto rekord": "A rekord sikeresen törölve.",
        "Pomyślnie usunięto wersje": "A verziók sikeresen törölve.",
        "Pomyślnie zapisano konfigurację filtrów": "A szűrő konfiguráció sikeresen mentve.",
        "Pomyślnie zapisano konfigurację kolumn": "Az oszlop konfiguráció sikeresen mentve.",
        "Pomyślnie zmieniono akceptantów w %0 dokumentach": "Az elfogadók sikeresen módosítva %0 dokumentumban.",
        "Poniedziałek": "Hétfő",
        "Ponów cofniętą operację": "",
        "Poprawne": "Helyes",
        "Poprawny": "Helyes",
        "Poprzednia": "Előző",
        "Poprzednia strona": "Előző oldal",
        "Porównaj %0": "Hasonlítsa össze: %0",
        "Porównaj z edytowaną wersją": "Hasonlítsa össze a szerkesztett verzióval",
        "Porównania": "Összehasonlítások",
        "Porównanie": "Összehasonlítás",
        "Porównywana wersja": "Összehasonlított verzió",
        "Port": "Kikötő",
        "Portal Pracowniczy (SSO)": "Munkavállalói portál (SSO)",
        "Posiada załączniki": "Van csatolmány",
        "Posiadasz nieaktualną wersję aplikacji": "Elavult alkalmazás verzióval rendelkezik",
        "POST: Lista wpisów (dowolne wyszukiwanie)": "POST: Bejegyzések listája (bármilyen keresés)",
        "POST: Upload załączników": "POST: Mellékletek feltöltése",
        "POST: Utworzenie wpisu": "POST: Bejegyzés létrehozása",
        "POST: Zapisanie zmian": "POST: Változások mentése",
        "Potwierdzenia": "Megerősítések",
        "Potwierdzenie przywrócenia": "Visszaállítás megerősítése",
        "Potwierdzenie usunięcia": "Törlés megerősítése",
        "Potwierdzenie wylogowania użytkownika": "Felhasználó kijelentkezésének megerősítése",
        "Potwierdzenie zmiany statusu": "Állapotváltozás megerősítése",
        "Potwierdź": "Megerősít",
        "Potwierdź akceptację": "Elfogadás megerősítése",
        "Powiadomienia": "Értesítések",
        "Powiadomienia weryfikacyjne": "Ellenőrző értesítések",
        "Powiadomienia zbiorcze": "Tömeges értesítések",
        "Powiadomienia zostały skonfigurowane.": "Az értesítések konfigurálva lettek.",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Az értesítés alapértelmezetten kötelező. Nem lehet kikapcsolni ennek az értesítésnek a küldését.",
        "Powiadomienie testowe zostało wysłane.": "Teszt értesítés elküldve.",
        "Powiadomienie weryfikacyjne": "Ellenőrző értesítés",
        "Powiadomienie zostało usunięte": "Az értesítés törölve lett.",
        "Powiązane dokumenty": "Kapcsolódó dokumentumok",
        "Powiąż": "Kapcsol",
        "Powiąż dokument": "Dokumentum kapcsolása",
        "Powiąż z polem typu grupa użytkowników": "Kapcsolja felhasználói csoport mezőhöz",
        "Powiąż ze spółką": "Kapcsolja vállalathoz",
        "Powiększ": "Nagyítás",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "A PRIVATE direktívát hozzá kell adni a felhasználóhoz személyre szabott tartalmakhoz, különösen a bejelentkezés utáni és jogosultságokat figyelembe vevő válaszokhoz.",
        "powrót": "Visszatérés",
        "Powrót": "Visszatérés",
        "Powtarzaj co": "Ismételje minden",
        "Powtórz hasło": "Ismételje meg a jelszót",
        "Powtórzone": "Ismételt",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "A fenti objektumok csak tulajdonságokat tartalmaznak, minden metódustól mentesek.",
        "Poziom dostępu do webhooka": "Webhook hozzáférési szint",
        "Poziom dostępu użytkownika": "Felhasználói hozzáférési szint",
        "Poziom logowania błedów": "Hibák naplózási szintje",
        "Poziomy logowania": "Naplózási szintek",
        "Pozostałe": "Egyéb",
        "Pozostało %0 znaków.": "Még %0 karakter maradt.",
        "Pozostawienie pola pustego spowoduje, że przyjmowane będą wszystkie rozszerzenia": "Ha a mező üres, minden kiterjesztés elfogadott lesz.",
        "Pozwalaj na grupowe wykonanie akcji": "Csoportos művelet engedélyezése",
        "Pozwalaj na równoległe wykonanie grupowej akcji": "",
        "Pozwalaj wiązać tylko niezakończone dokumenty": "Csak befejezetlen dokumentumok kapcsolása engedélyezett",
        "Pozwól dodawać terminy użytkownikom": "Engedélyezze a felhasználóknak a kifejezések hozzáadását",
        "Pozwól na dodawanie wierszy": "Sorok hozzáadásának engedélyezése",
        "Pozwól na kopiowanie": "Másolás engedélyezése",
        "Pozwól na kopiowanie pól numerycznych w tabeli": "Numerikus mezők másolásának engedélyezése a táblázatban",
        "Pozwól na uzupełnianie danych z pliku excel": "Excel fájlból történő adatfeltöltés engedélyezése",
        "pół roku": "fél év",
        "Półroczny": "Féléves",
        "Pracownicy": "Munkavállalók",
        "Pracownik": "Munkavállaló",
        "Prawy panel": "Jobb oldali panel",
        "Predefiniowane tła panelu z aplikacjami": "Előre definiált háttérképek az alkalmazások panelen",
        "Predefiniowane zestawy kolorów": "Előre definiált színkészletek",
        "Preferowany język": "Preferált nyelv",
        "Prezentacja": "Prezentáció",
        "primary": "elsődleges",
        "Priorytet": "Prioritás",
        "private (tylko cache przeglądarki)": "privát (csak böngésző cache)",
        "Procent": "Százalék",
        "Procent całości": "Teljes százalék",
        "Procent kolumny": "Oszlop százaléka",
        "Proces": "Folyamat",
        "Proces i elementy podstawowe (statusy, czynności, akcje, grupy użytkowników)": "Folyamat és alapvető elemek (állapotok, műveletek, akciók, felhasználói csoportok)",
        "Proces został dodany.": "A folyamat hozzáadva.",
        "Proces został edytowany.": "A folyamat szerkesztve lett.",
        "Proces został zapisany.": "A folyamat mentve lett.",
        "Proces.Grupa użytkowników.{Nazwa grupy}": "Folyamat.Felhasználói csoport.{Csoport neve}",
        "Proces.Krok.{Nazwa akcji}.Proces.Pola formularza.{Nazwa pola}": "Folyamat.Lépés.{Akció neve}.Folyamat.Űrlap mezők.{Mező neve}",
        "Proces.Osoba wykonująca krok.{Nazwa akcji}": "Folyamat.Lépést végrehajtó személy.{Akció neve}",
        "Proces.Zmienne(typ).{operator}.Dokument.Pole dokumentu.{Nazwa pola}": "Folyamat.Változók(típus).{operátor}.Dokumentum.Dokumentum mező.{Mező neve}",
        "Proces.Zmienne(typ).{operator}.Proces.Pola formularza.{Nazwa pola}": "Folyamat.Változók(típus).{operátor}.Folyamat.Űrlap mezők.{Mező neve}",
        "Profil użytkownika": "Felhasználói profil",
        "Profil został zaktualizowany.": "A profil frissítve lett.",
        "Projekt": "Projekt",
        "Prometheus": "Prometheus",
        "Prompt informacyjny": "Információs prompt",
        "Prompt klasyfikacyjny": "Osztályozó prompt",
        "Prompt systemowy": "Rendszer prompt",
        "Prompt z instrukcją": "Utasítás prompt",
        "Propka": "Propka",
        "Propki": "Propki",
        "Proporcje obrazu": "Képarány",
        "Proste uprawnienia": "Egyszerű jogosultságok",
        "Próbkowanie": "Mintavételezés",
        "Prywatne": "Privát",
        "Przebudowanie indeksów": "Indexek újraépítése",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Az indexek újraépítése néhány másodperctől több óráig is tarthat az indexek méretétől függően. Csak akkor használja, ha szinonima vagy kizárt szavak szótárában történt változásokat kell alkalmazni.",
        "Przeciągnij i upuść aby posortować pliki": "Húzza és ejtse a fájlok rendezéséhez",
        "Przeczytane": "Olvasás",
        "przed": "előtt",
        "Przedrostek": "Előtag",
        "Przeglądarka wymaga zainstalowania dedykowanej aplikacji": "A böngésző dedikált alkalmazás telepítését igényli",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "Az Ön böngészője nem támogatja a PUSH értesítéseket",
        "Przeindeksowanie danych": "Adatok újraindexálása",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Az adatok újraindexálása néhány másodperctől több óráig is tarthat az adatbázisban lévő adatok mennyiségétől függően. Csak akkor használja, ha hiányzó adatokat észlel az indexekben.",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Lépjen a beállításokhoz az eszközök engedélyezéséhez",
        "Przekaż do właściciela": "Tulajdonoshoz továbbítás",
        "Przekierowanie": "Átirányítás",
        "Przekieruj do dokumentu": "Dokumentumhoz irányítás",
        "Przekieruj po kliknięciu w widget": "Widgetre kattintás után irányítás",
        "Przekieruj przycisk więcej do": "Tovább gomb irányítása ide",
        "Przekroczono dozwoloną ilość znaków: %0.": "A megengedett karakterek száma túllépve: %0.",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "A megengedett fájlméret túllépve (%0 MB)",
        "Przełącznik": "Kapcsoló",
        "Przełożeni": "Felettesek",
        "Przełożony": "Felettes",
        "Przeniesienie wybranych elementów": "Kiválasztott elemek áthelyezése",
        "przeniesiony do kosza": "kukába helyezve",
        "Przenieś": "Áthelyezés",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "Áthelyezés${selected.length > 1 ? ' kijelöltek' : ''}",
        "przeniósł do kosza": "kukába helyezte",
        "Przepisz aktualne stawki za 1000 tokenów z cennika OpenAI.": "Írja át az aktuális OpenAI árakat 1000 tokenre.",
        "Przepisz limit konta OpenAI.": "Írja át az OpenAI fiók limitjét.",
        "Przepnij alias": "Alias átkapcsolása",
        "Przesuń do góry": "Mozgatás felfelé",
        "Przesuń na dół": "Mozgatás lefelé",
        "Przesuń widok diagramu": "",
        "Przesuń zaznaczony element o mały krok": "",
        "Przesuń zaznaczony element o większy krok": "",
        "Przesyłanie plików powiodło się.": "A fájlok feltöltése sikeres volt.",
        "Przetestuj": "Tesztelés",
        "Przetestuj poprawność zapisanych kluczy": "Ellenőrizze a mentett kulcsok helyességét",
        "Przetestuj ustawienia poczty": "Ellenőrizze az e-mail beállításait",
        "Przetestuj ustawienia Sms": "Tesztelje SMS-beállításait",
        "Przetłumacz moduł": "Fordító modul",
        "Przetłumacz słownik": "Szótár fordítása",
        "Przetwarzam Twój dokument...": "A dokumentum feldolgozása folyamatban...",
        "Przetwarzane": "Feldolgozás alatt",
        "Przetwórz z AI": "Feldolgozás AI-val",
        "Przybliżenie diagramu": "",
        "Przybornik": "Eszköztár",
        "Przygotowanie kontrolek": "Vezérlők előkészítése",
        "Przykład": "Példa",
        "Przykład listy elementów pola typu tablica:": "Tömb típusú mező elemeinek listájának példája:",
        "Przykład odwołania do pola \"Stawka\" ze słownika Stawki VAT": "Példa a \"Stawka\" mező hivatkozására az ÁFA kulcsok szótárából",
        "Przykład skryptu, który odnosi się do danych przekazanych przez przycisk dynamiczny": "Példa egy szkriptre, amely a dinamikus gomb által átadott adatokra hivatkozik",
        "Przykład skryptu, który pobiera dane z bazowego formularza i zwraca nowe dane dla formularza docelowego": "Példa egy szkriptre, amely az alap űrlapból adatokat vesz, és új adatokat ad vissza a cél űrlaphoz",
        "Przykład skryptu, który zwraca słownik z dodatkowymi danymi, które można użyć w szablonie:": "Példa egy szkriptre, amely egy szótárt ad vissza további adatokkal, amelyeket a sablonban lehet használni:",
        "Przykład tabelki z powtarzanymi elementami:": "Ismétlődő elemeket tartalmazó táblázat példája:",
        "Przykład użycia historii w formie tabeli": "Példa a történet táblázatos megjelenítésére",
        "Przykład:": "Példa:",
        "Przykład: domena\\użytkownik": "Példa: domain\\felhasználó",
        "Przykład: użytkownik@domena": "Példa: felhasználó@domain",
        "Przykładowa struktura danych": "Példa adatstruktúra",
        "Przykładowy JSON": "Példa JSON",
        "Przykładowy JSON:": "Példa JSON:",
        "Przykładowy skrypt wyświetlający terminy zależne od wbranego terminu w tym samym wierszu tabeli.": "Példa szkript, amely a kiválasztott kifejezéstől függő kifejezéseket jeleníti meg ugyanabban a táblázatsorban.",
        "Przykładowy skrypt wyświetlający terminy, które w polu \"company\" mają nazwę spółki z pola Company1": "Példa szkript, amely azokat a kifejezéseket jeleníti meg, amelyek a \"company\" mezőben a Company1 mező vállalat nevét tartalmazzák.",
        "Przykładowy skrypt wyświetlający terminy, które w polu \"unit\" mają id działu wybranego w polu UserGroup1": "Példa szkript, amely azokat a kifejezéseket jeleníti meg, amelyek a \"unit\" mezőben a UserGroup1 mezőben kiválasztott osztály azonosítóját tartalmazzák.",
        "Przykładowy skrypt wyświetlający tylko terminy z zaznaczonym checkboxem \"exampleBool\", gdy użytkownik z pola User1 znajduje się w zespole o id 5": "Példa szkript, amely csak azokat a kifejezéseket jeleníti meg, ahol az \"exampleBool\" jelölőnégyzet be van jelölve, és a User1 mezőben lévő felhasználó az 5-ös azonosítójú csapatban van.",
        "Przykładowy skrypt wywołujący akcję systemową o nazwie \"End\"": "Példa szkript, amely a \"End\" nevű rendszer műveletet hívja meg.",
        "Przykładowy skrypt, który szuka wartości w polu oznaczonym jako tablica elementów do wyboru. Jeśli wpiszemy kilka wartości, to wszystkie muszą być znalezione w tablicy.": "Példa szkript, amely egy tömb mezőben keres értékeket. Ha több értéket adunk meg, mindegyiknek szerepelnie kell a tömbben.",
        "Przykładowy skrypt:": "Példa szkript:",
        "Przykłady": "Példák",
        "Przykłady konfiguracji": "Konfigurációs példák",
        "Przykłady odwołania się do pierwszego elementu w tablicy:": "Példák a tömb első elemére való hivatkozásra:",
        "Przykłady skryptów warunkowych": "Feltételes szkriptek példái",
        "Przypisanie do roli": "Szerepkörhöz rendelés",
        "Przypisanie do zespołu": "Csapathoz rendelés",
        "Przypisanie ról": "Szerepkörök hozzárendelése",
        "Przypominamy, że dostęp do aukcji jest aktywny tylko po akceptacji regulaminu. Jeśli już zaakceptowałeś - możesz licytować!": "Felhívjuk figyelmét, hogy az aukcióhoz való hozzáférés csak a feltételek elfogadása után aktív. Ha már elfogadta azokat, licitálhat!",
        "Przypomnienie": "Emlékeztető",
        "Przypomnienie hasła": "Jelszó emlékeztető",
        "Przyrostek": "Utótag",
        "Przywrócenie": "Visszaállítás",
        "przywrócił z kosza": "visszaállította a kukából",
        "przywrócony z kosza": "kukából visszaállítva",
        "Przywróć": "Visszaállítás",
        "Przywróć domyślną listę kolumn": "Alapértelmezett oszloplista visszaállítása",
        "Przywróć domyślne": "Alapértelmezett visszaállítása",
        "Przywróć filtr": "Szűrő visszaállítása",
        "Przywróć ustawienia domyślne reguł i celów": "Szabályok és célok alapértelmezett beállításainak visszaállítása",
        "Przyznaj dostęp": "Hozzáférés engedélyezése",
        "public (cache przeglądarki i proxy)": "nyilvános (böngésző és proxy cache)",
        "Public Id": "Nyilvános azonosító",
        "Publiczne": "Nyilvános",
        "Publikuj": "Közzététel",
        "PUT: Aktualizacja wpisu": "PUT: Bejegyzés frissítése",
        "Pytania": "Kérdések",
        "Q1": "Q1",
        "Q2": "Q2",
        "Q3": "Q3",
        "Q4": "Q4",
        "Query string": "Lekérdezési karakterlánc",
        "Radio": "Rádiógomb",
        "Ranga": "Rang",
        "Raport spójności": "Konzisztencia jelentés",
        "Raport wierszy:": "Sorok jelentése:",
        "Raport zadań": "Feladatjelentés",
        "Raporty": "Jelentések",
        "Rączka – przesuwanie diagramu": "",
        "Realizuje obecnie zadanie w obiegu dokumentu": "Jelenleg feladatot végez a dokumentum körforgásában",
        "ReCaptcha": "ReCaptcha",
        "Regex walidujący poprawność wartości w polu (tylko dla typu String)": "Regex, amely ellenőrzi a mező értékének helyességét (csak String típushoz)",
        "Region": "Régió",
        "Regon": "Regon",
        "REGON": "REGON",
        "REGON: ": "REGON: ",
        "Reguła": "Szabály",
        "Reguła filtracyjna": "Szűrési szabály",
        "Reguła końcowa": "Végső szabály",
        "Reguła został dodana.": "A szabály hozzáadva.",
        "reguła została usunięta.": "A szabály törölve lett.",
        "Reguła została zaktualizowana.": "A szabály frissítve lett.",
        "Reguły": "Szabályok",
        "Rejestr": "Regisztráció",
        "Rejestr w pełni elektroniczny": "Teljesen elektronikus regisztráció",
        "Rejestr zmian": "Változások naplója",
        "Rejestr został dodany.": "A regisztráció hozzáadva.",
        "Rejestr zostały zapisany.": "A regisztráció mentve lett.",
        "Rejestry": "Regisztrációk",
        "reklamacje": "reklamációk",
        "Relacyjne": "Relációs",
        "Repozytorium plików": "Fájltár",
        "Request body": "Kérés törzse",
        "Resetuj": "Visszaállítás",
        "Resetuj układ": "Elrendezés visszaállítása",
        "RESTful API": "RESTful API",
        "Rezygnacja": "Lemondás",
        "Roczny": "Éves",
        "Rodzaj akcji": "Művelet típusa",
        "Rodzaj odpowiedzi": "Válasz típusa",
        "Rodzaj źródła": "Forrás típusa",
        "rok": "év",
        "Rok": "Év",
        "Rola": "Szerep",
        "Rola aktywna": "Aktív szerep",
        "Rola domyślna": "Alapértelmezett szerepkör",
        "Rola skryptu": "Szkript szerepe",
        "Rola została dodana.": "A szerep hozzáadva.",
        "Rola została usunięta.": "A szerep törölve lett.",
        "Rola została zaktualizowana.": "A szerep frissítve lett.",
        "Role i uprawnienia": "Feladatok és hatáskörök",
        "Role użytkownika": "Felhasználó szerepkörei",
        "Role zespołu": "Csapat szerepek",
        "Role zostały przypisane": "A szerepkörök hozzárendelve",
        "Root": "Gyökér",
        "Roszerzenia plików": "Fájlkiterjesztések",
        "Roszerzenia plików rozdzielone przecinkami": "Fájlkiterjesztések vesszővel elválasztva",
        "Rozdzielczość": "Felbontás",
        "Rozdzielczość wygnerowanego obrazu.": "A generált kép felbontása.",
        "Rozgrupuj": "Csoportbontás",
        "Rozgrupuj pola": "Mezők csoportbontása",
        "Rozmiar": "Méret",
        "Rozmiar czcionki": "Betűméret",
        "Rozmiar minitur": "Miniatűr méret",
        "Rozmiar okna modalnego": "Modális ablak mérete",
        "Rozmiar okna popup": "Felugró ablak mérete",
        "Rozmiar pliku": "Fájlméret",
        "Rozmiar wydruku": "Nyomtatási méret",
        "Rozmiar zdjęcia": "Kép mérete",
        "Rozmiar zdjęcia głównego": "Fő kép mérete",
        "Rozmiar zdjęcia został zmieniony.": "A kép mérete megváltozott.",
        "Rozmieść równomiernie": "Egyenletes elosztás",
        "Rozpoczęto tłumaczenie modułu. Może to potrwać do kilku minut.": "A modul fordítása elindult. Ez néhány percet vehet igénybe.",
        "Rozpoznaj tekst wprowadzonego dokumentu (OCR) dla wskazanych pól modułu": "A feltöltött dokumentum szövegének felismerése (OCR) a megadott mezőknél",
        "Rozszerzenia": "Kiterjesztések",
        "Rozszerzony - błedy ważne": "Kiterjesztett - fontos hibák",
        "Rozwiń": "Kibontás",
        "Równość": "Egyenlőség",
        "SAP ID S4": "SAP ID S4",
        "Satysfakcja": "Elégedettség",
        "secondary": "másodlagos",
        "Sekcja": "Szekció",
        "Sentry": "Sentry",
        "Seria danych": "Adatsor",
        "Serie danych": "Adatsorok",
        "Server Side Cache": "Szerver oldali cache",
        "Serwer bazy danych": "Adatbázis szerver",
        "Serwer dostępny": "Szerver elérhető",
        "Serwer plików": "Fájlszerver",
        "Serwer został dodany.": "A szerver hozzáadva.",
        "Serwer został usunięty.": "A szerver törölve lett.",
        "Serwer został zaktualizowany.": "A szerver frissítve lett.",
        "Serwery plików": "Fájlszerverek",
        "Sesja": "Munkamenet",
        "Sesja nr %0": "Munkamenet száma: %0",
        "Sesja przetwarzania nie została znaleziona lub wygasła.": "A feldolgozási munkamenet nem található vagy lejárt.",
        "Sesja użytkownika": "Felhasználói munkamenet",
        "Sheduler": "Ütemező",
        "Sierpień": "Augusztus",
        "Silnik skryptowy": "Szkriptmotor",
        "Site name": "Webhely neve",
        "Site URL": "Webhely URL",
        "Sitemap": "Oldaltérkép",
        "Skala 1-5": "Skála 1-5",
        "Skan został dodany.": "A szkennelés hozzáadva.",
        "Skopiowano do schowka": "Vágólapra másolva",
        "Skopiuj kod": "Kód másolása",
        "Skopiuj link": "Link másolása",
        "Skrócona nazwa": "Rövid név",
        "Skrypt": "Szkript",
        "Skrypt archiwalny": "Archivált szkript",
        "Skrypt dla dynamicznego modala": "Szkript dinamikus modálhoz",
        "Skrypt dla szablonu dokumentu": "Szkript dokumentum sablonhoz",
        "Skrypt dla wartości domyślnych": "Szkript alapértelmezett értékekhez",
        "Skrypt filtrujący": "Szűrő szkript",
        "Skrypt może modyfikować dane całego obiektu @Model, dzięki temu wykona się on tylko raz, a nie dla każdego dokumentu osobno": "A szkript módosíthatja a teljes @Model objektum adatait, így csak egyszer fut le, nem minden dokumentumhoz külön-külön.",
        "Skrypt musi być napisany w JS i musi definiować obiekt o nazwie filter, który powinien składać się z pól o nazwach zgodnych z kluczami pól formularza i wartościami wg. których nastąpi filtrowanie.": "A szkriptet JS-ben kell írni, és egy filter nevű objektumot kell definiálnia, amelynek mezői a űrlap mezőinek kulcsaival egyeznek, és értékei alapján történik a szűrés.",
        "Skrypt po eksporcie": "Szkript export után",
        "Skrypt po eksporcie nie zwraca żadnych danych. Jest on wykonywany w tle po zakończeniu eksportu wszystkich dokumentów.": "Az export utáni szkript nem ad vissza adatokat. Az összes dokumentum exportálása után a háttérben fut le.",
        "Skrypt po przetworzeniu dokumentu": "Szkript dokumentum feldolgozása után",
        "Skrypt powinien kończyć się wyrażeniem zwracającym wartość logiczną (true/false)": "A szkriptnek logikai értéket (true/false) visszaadó kifejezéssel kell végződnie",
        "Skrypt powinien zwrócić obiekt składający się z klucza kolumny oraz wyrażenia zwracającego wartość logiczną, określający czy dana kolumna powinna być widoczna czy nie.": "A szkriptnek egy objektumot kell visszaadnia, amely tartalmazza az oszlop kulcsát és egy logikai értéket visszaadó kifejezést, amely meghatározza, hogy az adott oszlop látható-e vagy sem.",
        "Skrypt powinien zwrócić wartość typu bool, określającą czy dane pole powinno być widoczne czy nie.": "A szkriptnek logikai értéket kell visszaadnia, amely meghatározza, hogy az adott mező látható-e vagy sem.",
        "Skrypt pozwala na wykonywanie dowolnych akcji po stronie backendu na podstawie danych z formularza.": "A szkript lehetővé teszi bármilyen művelet végrehajtását a backend oldalon az űrlap adatai alapján.",
        "Skrypt przed eksportem": "Szkript export előtt",
        "Skrypt sprawdzający, czy data w polu jest w przeszłości i czy kwota jest większa niż 1000": "Szkript, amely ellenőrzi, hogy a mezőben lévő dátum múltbeli-e, és az összeg nagyobb-e mint 1000",
        "Skrypt sprawdzający, czy kwota dokumentu przekroczyła 10000": "Szkript, amely ellenőrzi, hogy a dokumentum összege meghaladja-e a 10000-et",
        "Skrypt sprawdzający, czy upłynął termin dokumentu w polu 1_Date1": "Szkript, amely ellenőrzi, hogy lejárt-e a dokumentum határideje az 1_Date1 mezőben",
        "Skrypt sprawdzający, czy występuje słowo kluczowe \"ważne\" w tytule": "Szkript, amely ellenőrzi, hogy a címben szerepel-e a \"fontos\" kulcsszó",
        "Skrypt systemowy można modyfikować tylko poprzez migracje": "A rendszer szkript csak migrációval módosítható",
        "Skrypt walidacyjny": "Validációs szkript",
        "Skrypt współdzielony": "Megosztott szkript",
        "Skrypt zliczający sumą wartości z pola numerycznego": "Szkript, amely összeadja a numerikus mező értékeit",
        "Skrypt został dodany.": "A szkript hozzáadva.",
        "Skrypt został zaktualizowany.": "A szkript frissítve lett.",
        "Skrypt zosta� zaktualizowany.": "A szkript frissítve lett.",
        "Skrypt zwracający string jako błąd walidacji": "Szkript, amely szöveget ad vissza validációs hibaként",
        "Skrypty": "Szkriptek",
        "Skrypty integracyjne": "Integrációs szkriptek",
        "Skrypty współdzielone": "Megosztott szkriptek",
        "słowa": "szavak",
        "Słowa wykluczone": "Kizárt szavak",
        "Słownik": "Szótár",
        "Słownik dowolny": "Tetszőleges szótár",
        "Słownik Logito": "Logito szótár",
        "Słownik systemowy": "Rendszer szótár",
        "Słownik został dodany.": "A szótár hozzáadva.",
        "Słownik został zaktualizowany.": "A szótár frissítve lett.",
        "Słowniki": "Szótárak",
        "Słowo": "Szó",
        "Słowo bazowe": "Alapszó",
        "Słowo wykluczone": "Kizárt szó",
        "Słowo zostało dodane.": "A szó hozzáadva.",
        "Słowo zostało usunięte.": "A szó törölve lett.",
        "Słowo zostało zaktualizowane.": "A szó frissítve lett.",
        "Sobota": "Szombat",
        "Sortowanie": "Rendezés",
        "Sortowanie malejąco": "Csökkenő sorrend",
        "Sortowanie rosnąco": "Növekvő sorrend",
        "Space Tool – zwiększanie przestrzeni między elementami": "",
        "Specjalizowane": "Specializált",
        "Specyfikacja": "Specifikáció",
        "Sposób liczenia czasu": "Időszámítás módja",
        "Sposób prezentacji zakładek": "Fülek megjelenítési módja",
        "Sposób wykonania": "",
        "Sposób wyświetlania": "Megjelenítési módszer",
        "Spólka": "A vállalat",
        "Spółka": "A vállalat",
        "Spółka została dezaktywowana.": "A vállalat deaktiválva lett.",
        "Spółka została dodana.": "A vállalat hozzáadva.",
        "Spółka została zaktualizowana.": "A vállalat frissítve lett.",
        "Spółki": "Vállalatok",
        "Spółki użytkownika": "Felhasználó vállalatai",
        "Sprawdzenie czy pusty": "Üres-e ellenőrzése",
        "Sprawdzenie, czy pole dokumentu ma wartość": "Ellenőrzés, hogy a dokumentum mezőnek van-e értéke",
        "Sprawdzenie, czy wybrano konkretną opcję w polu wyboru": "Ellenőrzés, hogy a választómezőben konkrét opció van-e kiválasztva",
        "Sprawdź czy ustawienia kontrolki są poprawne.": "Ellenőrizze, hogy a vezérlő beállításai helyesek-e.",
        "Sprawdź poprawność task listy": "Ellenőrizze a feladatlista helyességét",
        "Stack trace": "Verem nyomvonal",
        "Stała wartość": "Állandó érték",
        "Stan powiadomienia": "Értesítési állapot",
        "Standardowa szczegółowość": "Alapértelmezett részletesség",
        "Standardowe uprawnienia": "Alapértelmezett jogosultságok",
        "Stanowiska pracy": "Munkaállomások",
        "Stanowisko": "Pozíció",
        "Stanowisko pracy": "Munkaállomás",
        "Start": "Kezdés",
        "status": "állapot",
        "Status": "Állapot",
        "Status dokumentu został zmieniony.": "A dokumentum állapota megváltozott.",
        "Status edytowanej wersji dokumentu": "A dokumentum szerkesztett változatának állapota",
        "Status formularza został zmieniony.": "Az űrlap állapota megváltozott.",
        "Status modułu": "Modul állapota",
        "Status webhooka": "Webhook állapota",
        "Status został zapisany": "Az állapot mentve lett",
        "Statusy": "Állapotok",
        "Stawka VAT": "ÁFA kulcs",
        "Stopka": "Lábléc",
        "Strona": "Oldal",
        "Strona %0": "%0. oldal",
        "Strona główna": "Otthon",
        "Strona www": "Weboldal",
        "Strona została usunięta.": "Az oldal törölve lett.",
        "Struktura organizacyjna": "Szervezeti felépítés",
        "Struktura zwracanego obiektu:": "A visszaadott objektum szerkezete:",
        "Studio": "Stúdió",
        "Stwierdzenie": "Állítás",
        "Styczeń": "Január",
        "Styl obrazu": "Kép stílusa",
        "Styl przycisku": "Gomb stílusa",
        "success": "siker",
        "Sukces": "Siker",
        "Suma": "Összeg",
        "Suma danych wejściowych i wyjściowych podana w tokenach.": "A bemeneti és kimeneti adatok összege tokenekben megadva.",
        "Suma tokenów": "Tokenek összege",
        "Sygnatura": "Hivatkozási szám",
        "Sygnatura skopiowana": "Hivatkozási szám másolva",
        "Symbol": "Szimbólum",
        "Symbol ISO waluty domyślnej": "Alapértelmezett valuta ISO kódja",
        "Symbol jest wymagany": "A szimbólum kötelező",
        "Symbol jest zajęty": "A szimbólum foglalt",
        "Symbol klienta": "Ügyfél szimbóluma",
        "Symbol musi mieć co najmniej 3 znaki": "A szimbólumnak legalább 3 karakterből kell állnia",
        "Symbol musi mieć co najmniej 5 znaków": "A szimbólumnak legalább 5 karakterből kell állnia",
        "Symbol nie może być dłuższy niż 10 znaków": "A szimbólum nem lehet hosszabb 10 karakternél",
        "Symbol nie może być dłuższy niż 20 znaków": "A szimbólum nem lehet hosszabb 20 karakternél",
        "Symbol w adresie URL": "Szimbólum az URL-ben",
        "Synchronizowane z bazą AD": "AD adatbázissal szinkronizálva",
        "Synonimy": "Szinonimák",
        "Synonimy zostały dodane.": "A szinonimák hozzáadva.",
        "Synonimy zostały usunięte.": "A szinonimák törölve lettek.",
        "Synonimy zostały zaktualizowane.": "A szinonimák frissítve lettek.",
        "System": "Rendszer",
        "System.Członkowie grupy.System.Dział.{Nazwa działu}": "Rendszer.Csoport tagjai.Rendszer.Osztály.{Osztály neve}",
        "System.Data bieżaca.{operator}.Dokument.Pola dokumentu.{Nazwa pola}": "Rendszer.Aktuális dátum.{operátor}.Dokumentum.Dokumentum mezők.{Mező neve}",
        "System.Data bieżąca.{operator}.Proces.Pola formularza.{Nazwa pola}": "Rendszer.Aktuális dátum.{operátor}.Folyamat.Űrlap mezők.{Mező neve}",
        "System.Dział.{Nazwa działu}": "Rendszer.Osztály.{Osztály neve}",
        "System.Kierownicy działu.System.Dział.{Nazwa działu}": "Rendszer.Osztályvezetők.Rendszer.Osztály.{Osztály neve}",
        "System.Osoba wykonująca akcję": "Rendszer.Műveletet végrehajtó személy",
        "System.Osoba wykonująca akcję.Operator.+.(Proces.Krok.{Nazwa akcji}.Proces.Pola formularza.{Nazwa pola})": "Rendszer.Műveletet végrehajtó személy.Operátor.+.(Folyamat.Lépés.{Akció neve}.Folyamat.Űrlap mezők.{Mező neve})",
        "System.Przełożony.Proces.Osoba wykonująca krok.{Nazwa akcji}": "Rendszer.Felettes.Folyamat.Lépést végrehajtó személy.{Akció neve}",
        "System.Uzytkownik.{Nazwa użytkownika}": "Rendszer.Felhasználó.{Felhasználó neve}",
        "System.Użytkownik.{Nazwa użytkownika}": "Rendszer.Felhasználó.{Felhasználó neve}",
        "System.Użytkownik.{Użytkownik}": "Rendszer.Felhasználó.{Felhasználó}",
        "System.Użytkownik.{Użytkownik}.Operator.+.System.Dział.{Nazwa działu}": "Rendszer.Felhasználó.{Felhasználó}.Operátor.+.Rendszer.Osztály.{Osztály neve}",
        "System.Zespół.{Nazwa zespołu}": "Rendszer.Csapat.{Csapat neve}",
        "System.Zespół.{Nazwa zespołu}.System.Osoba z najmniejszą ilością zadań": "Rendszer.Csapat.{Csapat neve}.Rendszer.Legkevesebb feladattal rendelkező személy",
        "Szablon": "Sablon",
        "Szablon CSV": "CSV sablon",
        "Szablon HTML": "",
        "Szablon modułu": "Modul sablon",
        "Szablon numeracji": "Számozási sablon",
        "Szablon powiadomienia": "Értesítési sablon",
        "Szablon Razor": "",
        "Szablon tabeli został dodany": "A táblázat sablon hozzáadva",
        "Szablon tabeli został usunięty": "A táblázat sablon törölve lett",
        "Szablon tabeli został zaktualizowany": "A táblázat sablon frissítve lett",
        "Szablon word": "Word sablon",
        "Szablon XML": "XML sablon",
        "Szablon został dodany.": "A sablon hozzáadva.",
        "Szablon został edytowany.": "A sablon szerkesztve lett.",
        "Szablon został usunięty": "A sablon törölve lett",
        "Szablon został usunięty.": "A sablon törölve lett.",
        "Szablon został zaktualizowany.": "A sablon frissítve lett.",
        "Szablony": "Sablonok",
        "Szablony dokumentów": "Dokumentumsablonok",
        "Szablony tabeli": "Táblázat sablonok",
        "Szacowana kwota:": "Becsült összeg:",
        "Szafir Host": "Szafir Host",
        "Szafir Host dla Linux/Mac OS": "Szafir Host Linux/Mac OS-hez",
        "Szafir Host dla Windows": "Szafir Host Windows-hoz",
        "Szafir SDK ": "Szafir SDK",
        "Szczególy importu": "Import részletei",
        "Szczegółowość obrazu": "Kép részletessége",
        "Szczegółowy - błedy krytyczne": "Részletes - kritikus hibák",
        "Szczegóły": "Részletek",
        "Szczegóły akcji systemowej": "Rendszer művelet részletei",
        "Szczegóły asystenta": "Asszisztens részletei",
        "Szczegóły dokumentu": "Dokumentum részletei",
        "Szczegóły elementu": "Elem részletei",
        "Szczegóły formularza": "Űrlap részletei",
        "Szczegóły kontrahenta": "Partner részletei",
        "Szczegóły logu procesu": "Folyamat napló részletei",
        "Szczegóły pliku": "Fájl részletei",
        "Szczegóły spółki": "Vállalat részletei",
        "Szczegóły terminu": "Határidő részletei",
        "Szczegóły zadania": "Feladat részletei",
        "Szczegóły zapytania": "Lekérdezés részletei",
        "Szczegóły zdarzenia": "Esemény részletei",
        "Szczegóły zdarzenia nr %0": "%0. esemény részletei",
        "Szerokość": "Szélesség",
        "Szerokość (w calach)": "Szélesség (hüvelykben)",
        "Szerokość dla etykiety": "Címke szélessége",
        "Szerokość kolumn (px)": "Oszlop szélessége (px)",
        "Szerokość kolumny (px)": "Oszlop szélessége (px)",
        "Szerokość kolumny nie może być mniejsza niż %0 pikseli.": "Az oszlop szélessége nem lehet kevesebb, mint %0 pixel.",
        "Szerokość kolumny nie może być większa niż %0 pikseli.": "Az oszlop szélessége nem lehet nagyobb, mint %0 pixel.",
        "Szerokość niestandardowa etykiety": "Egyedi címke szélesség",
        "Szkic": "Vázlat",
        "Szkic można usunąć, tylko i wyłącznie wtedy gdy posiadamy chociaż 1 aktywną wersję. Czy chcesz kontynuować?": "A vázlat csak akkor törölhető, ha van legalább egy aktív verzió. Folytatja?",
        "Szukaj": "Keresés",
        "Szukaj pełnotekstowo w plikach:": "Teljes szöveges keresés fájlokban:",
        "Szukaj pełnotekstowo w polach modułu:": "Teljes szöveges keresés a modul mezőiben:",
        "Szukaj ponownie": "Keresés újra",
        "Szukaj we wszystkich wersjach": "Keresés minden verzióban",
        "Szukana fraza": "Keresési kifejezés",
        "Szukane słowo": "Keresett szó",
        "Szybkie zaznaczanie elementów": "",
        "Śnieżka": "Śnieżka",
        "Średni": "Közepes",
        "Średni czas dodania:": "Átlagos hozzáadási idő:",
        "Średnia": "Átlag",
        "Średnia artymetyczna": "Aritmetikai átlag",
        "Środa": "Szerda",
        "Środowisko": "Környezet",
        "Ta operacja nie jest odwracalna i spowoduje utratę danych kontrahenta.": "Ez a művelet nem visszafordítható, és a partner adatok elvesztését okozza.",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "Ez az oldal reCAPTCHA és Google által védett.",
        "Tabela": "Táblázat",
        "Tabela VAT": "ÁFA táblázat",
        "Tabele wektorowe": "Vektortáblák",
        "Tablica elementów do wyboru, uzupełnienie tej właściwości spowoduje, że pole będzie traktowane jako select zamiast input": "Választható elemek tömbje, ennek a tulajdonságnak a kitöltése esetén a mező select-ként lesz kezelve input helyett",
        "Tagi": "Címkék",
        "Tak": "Igen",
        "Tak/Nie": "Igen/Nem",
        "Takie błędy można zwrócić w prosty sposób korzystając z serwisu IExceptionService": "Az ilyen hibákat egyszerűen vissza lehet adni az IExceptionService használatával",
        "Tekst": "Szöveg",
        "Tekst alternatywny": "Alternatív szöveg",
        "Tekst potwierdzający wymuszenie dodania dokumentu": "A dokumentum hozzáadásának kényszerítését megerősítő szöveg",
        "Tekst zastępczy": "Helyettesítő szöveg",
        "Tel": "Tel",
        "Tel.": "Tel.",
        "Telefon": "Telefon",
        "Telefon komórkowy": "Mobiltelefon",
        "Telefon wewnętrzny": "Belső telefon",
        "Ten dashboard nie zawiera jeszcze żadnych widgetów": "Ez a dashboard még nem tartalmaz widgeteket",
        "Ten element nie zawiera menu kontekstowego.": "Ez az elem nem tartalmaz helyi menüt.",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "Ez a csatorna támogatja a formázott szöveg küldését.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "Ez a csatorna nem támogatja a formázott szöveg küldését.",
        "Ten prompt pomoże AI w określeniu, czy wprowadzany dokument należy do tego modułu.": "Ez a prompt segít az AI-nak eldönteni, hogy a feltöltött dokumentum ehhez a modulhoz tartozik-e.",
        "Tenant ID": "Bérlő azonosító",
        "Teraz": "Most",
        "Termin": "Határidő",
        "Termin cykliczny": "Ismétlődő határidő",
        "Termin jednorazowy": "Egyszeri határidő",
        "Termin prywatny": "Privát határidő",
        "Termin publiczny": "Nyilvános határidő",
        "Termin został dodany pomyślnie.": "A határidő sikeresen hozzáadva.",
        "Termin został dodany.": "A határidő hozzáadva.",
        "Termin został usunięty.": "A határidő törölve lett.",
        "Termin został zaktualizowany.": "A határidő frissítve lett.",
        "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "A szótárhoz csak az adatforrás mentése után lehet kifejezéseket hozzáadni.",
        "Terminy słowników": "Szótár kifejezések",
        "Test konfiguracji": "Konfiguráció tesztelése",
        "Test konfiguracji AI": "AI konfiguráció tesztelése",
        "Test ustawień pomyślnie zakończony.": "A beállítások tesztje sikeresen befejeződött.",
        "Testowy adres email": "Teszt e-mail cím",
        "Testowy numer telefonu": "Teszt telefonszám",
        "Testuj": "Tesztelés",
        "Testuj konfiguracje": "Konfigurációk tesztelése",
        "Testuj zapytanie": "Lekérdezés tesztelése",
        "Tłumacz": "Fordító",
        "Tłumaczenia": "Fordítások",
        "Tłumaczenie słownika rozpoczęte. Ta operacja może potrwać do kilku minut.": "A szótár fordítása elindult. Ez a művelet néhány percet vehet igénybe.",
        "To pole jest wymagane": "Ez a mező kötelező",
        "Token": "Token",
        "Token został usunięty.": "A token törölve lett.",
        "Tokeny": "Tokenek",
        "Tokeny dostępu": "Hozzáférési tokenek",
        "Tokeny wejściowe": "Bemeneti tokenek",
        "Tokeny wyjściowe": "Kimeneti tokenek",
        "Tooltip": "Tooltip",
        "Trace - najwięcej szczegółów": "Trace - a legtöbb részlet",
        "Tracing": "Nyomkövetés",
        "Treści odpowiedzi są wymagane": "A válaszok tartalma kötelező",
        "Treści pytań są wymagane": "A kérdések tartalma kötelező",
        "Treść": "Tartalom",
        "Treść szablonu": "Sablon tartalom",
        "Trigger": "Trigger",
        "Trwa autentykacja z SimplySign...": "Folyamatban van a hitelesítés a SimplySign-nal...",
        "Trwa generowanie obrazów": "Képek generálása folyamatban...",
        "Trwa generowanie obrazu": "Kép generálása folyamatban...",
        "Trwa generowanie opisu dla wybranego obrazu": "A kiválasztott kép leírásának generálása folyamatban...",
        "Trwa przekierowanie...": "Átirányítás folyamatban...",
        "Trwa przetwarzanie dokumentu, przyciski akcji będą dostępne po zakończeniu": "A dokumentum feldolgozása folyamatban van, az akciógombok a befejezés után lesznek elérhetők.",
        "Tryb": "Mód",
        "Tryb edycji": "Szerkesztési mód",
        "Tryb konserwacji systemu": "Rendszer karbantartási mód",
        "Tryb pracy": "Működési mód",
        "Tryb walidacji": "Validációs mód",
        "Tryb wysyłki": "Küldési mód",
        "Tryb wyświetlania": "Megjelenítési mód",
        "Tryb wyświetlania formularza": "Űrlap megjelenítési módja",
        "Tryb zapisu dokumentu": "Dokumentum mentési módja",
        "Trzy kolumny": "Három oszlop",
        "Twoja odpowiedź została pomyślnie zapisana.": "A válaszod sikeresen elmentve.",
        "Twoje hasło wygasło. Zmień je na nowe.": "A jelszavad lejárt. Kérjük, változtasd meg újra.",
        "Tworzenie dokumentów": "Dokumentumok létrehozása",
        "Twój token": "A te tokened",
        "tydzień": "Hét",
        "Tydzień": "Hét",
        "tydzień (tygodnie) w następującym dniu": "hét (hetek) a következő napon",
        "Tygodniowy": "Heti",
        "tylko do nowo zaproszonych": "csak az újonnan meghívottaknak",
        "Tylko do odczytu": "Csak olvasható",
        "tylko dokumenty wersjonowane": "csak verziózott dokumentumok",
        "Tylko liderzy": "Csak vezetők",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Csak fejlesztői szerver. Ne használja éles módban.",
        "Typ": "Típus",
        "Typ agregacji": "Aggregáció típusa",
        "Typ danych": "Adattípus",
        "Typ dokumentu": "Dokumentum típusa",
        "Typ formularza": "Űrlap típusa",
        "Typ konta": "Számlatípus",
        "Typ kontrahenta": "Partner típusa",
        "Typ licznika": "Számláló típusa",
        "Typ listy": "Lista típusa",
        "Typ logiczny": "Logikai típus",
        "Typ logowania": "Bejelentkezés típusa",
        "Typ mime": "Mime típus",
        "Typ modułu": "Modul típusa",
        "Typ obiektu": "Objektum típusa",
        "Typ odbiorcy": "Címzett típusa",
        "Typ pliku": "Fájltípus",
        "Typ pola": "Mező típusa",
        "Typ powiadomienia": "Értesítés típusa",
        "Typ rejestru": "Nyilvántartás típusa",
        "Typ serwera": "Szerver típusa",
        "Typ skryptu": "Szkript típus",
        "Typ słownika": "Szótár típus",
        "Typ szablonu": "Sablon típus",
        "Typ właściwy": "Megfelelő típus",
        "Typ wykresu": "Diagram típusa",
        "Typ wyszukiwania": "Keresés típusa",
        "Typ zawartości": "Tartalom típusa",
        "Typ zmiennej": "Változó típusa",
        "Typ źródła": "Forrás típusa",
        "Typ źródła danych": "Adatforrás típusa",
        "typu \"%0\" o ID \"%1\"": "\"%0\" típus, \"%1\" azonosítóval",
        "Typy grup": "Csoporttípusok",
        "Typy użytkowników": "Felhasználótípusok",
        "Tytuł": "Cím",
        "Tytuł formularza": "Űrlap címe",
        "Tytuł formularza jest wymagany": "Az űrlap címe kötelező",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "Az űrlap címe nem lehet hosszabb, mint %0 karakter",
        "Tytuł sekcji": "Szekció címe",
        "Uczestnicy": "Résztvevők",
        "uczestnika": "résztvevő",
        "Udostępnianie zostało zatrzymane": "A megosztás leállítva",
        "Udostępnij": "Megosztás",
        "Udostępnij dla": "Megosztás számára",
        "Udostępnij do": "Megosztás ide",
        "Udostępnij dokument w OneDrive do": "Dokumentum megosztása OneDrive-ban ide",
        "Udostępnij w OneDrive": "Megosztás OneDrive-ban",
        "Udostępnił": "Megosztotta",
        "Udostępnione": "Megosztva",
        "udostępnionej przez Eclipse Foundation.": "az Eclipse Foundation által megosztva.",
        "Udostępniono dla": "Megosztva számára",
        "Udostępniono dokument w OneDrive": "Dokumentum megosztva OneDrive-ban",
        "Układ": "Elrendezés",
        "Układ domyślny": "Alapértelmezett elrendezés",
        "Układ listy": "Lista elrendezése",
        "Ukraiński": "Ukrán",
        "Ukryj": "Elrejtés",
        "Ukryj etykietę": "Címke elrejtése",
        "Ukryj widok": "Nézet elrejtése",
        "Ukryta": "Rejtett",
        "Ukryty": "Rejtett",
        "Ulica": "Utca",
        "umowę": "szerződés",
        "umożliwiającej składanie podpisu elektronicznego.": "amely lehetővé teszi az elektronikus aláírást.",
        "Upload": "Feltöltés",
        "Upload plików": "Fájlok feltöltése",
        "Upłynęła data": "Lejárt dátum",
        "Uprawnieni użytkownicy": "Jogosult felhasználók",
        "Uprawnienia": "Engedélyek",
        "Uprawnienia do dokumentów": "Dokumentum jogosultságok",
        "Uprawnienia działów": "Osztály jogosultságok",
        "Uprawnienia indywidualne": "Egyéni jogosultságok",
        "Uprawnienia zespołów": "Csapat jogosultságok",
        "Uprawnienie indywidualne na koncie użytkownika": "Egyéni jogosultság a felhasználói fiókon",
        "Uprawnienie: ": "Jogosultság: ",
        "Uprawnione działy": "Jogosult osztályok",
        "Uprawnione zespoły": "Jogosult csapatok",
        "Url": "Url",
        "Uruchom zadanie": "Feladat indítása",
        "Uruchom źródło danych": "Adatforrás indítása",
        "Uruchomić gdy": "Indítás, ha",
        "Uruchomienie procesu reindeksacji spowoduje czasową niedostępność danych dla użytkowników zależną od ilości dokumentów. Czy na pewno chcesz kontynuowac?": "A reindexálási folyamat ideiglenes adat-hozzáférési szünetet okoz a felhasználók számára, a dokumentumok számától függően. Biztosan folytatni szeretné?",
        "Urządzenie zostało usunięte.": "Az eszköz törölve lett.",
        "Usługi": "Szolgáltatások",
        "Ustaw szerokości proporcjonalnie": "Szélességek arányos beállítása",
        "Ustawienia": "Beállítások",
        "Ustawienia asystenta AI zostały zapisane.": "Az AI asszisztens beállításai elmentve.",
        "Ustawienia domyślne": "Alapértelmezett beállítások",
        "Ustawienia domyślne na filtrach": "Alapértelmezett beállítások a szűrőkön",
        "Ustawienia domyślne na listach": "Alapértelmezett beállítások a listákon",
        "Ustawienia domyślne zostały zaktualizowane": "Az alapértelmezett beállítások frissítve lettek",
        "Ustawienia domyślne zostały zmienione": "Az alapértelmezett beállítások megváltoztak",
        "Ustawienia grida": "Rácsbeállítások",
        "Ustawienia konta": "Fiókbeállítások",
        "Ustawienia modułu": "Modul beállítások",
        "Ustawienia ogólne": "Általános beállítások",
        "Ustawienia podstawowe": "Alapvető beállítások",
        "Ustawienia powiadomień zostały zaktualizowane.": "Az értesítési beállítások frissítve lettek.",
        "Ustawienia sesji": "Munkamenet beállítások",
        "Ustawienia uprawnień zostały zapisane.": "A jogosultsági beállítások elmentve.",
        "Ustawienia widgetów zostały zapisane": "A widget beállítások elmentve.",
        "ustawienia widgetu": "Widget beállítások",
        "Ustawienia widgetu": "Widget beállítások",
        "Ustawienia wyszukiwania i OCR zostały zapisane.": "A keresési és OCR beállítások elmentve.",
        "Ustawienia zaawansowane": "Speciális beállítások",
        "Ustawienia zostały przywrócone.": "A beállítások visszaállítva.",
        "Ustawienia zostały zapisane.": "A beállítások elmentve.",
        "Ustawiono dokument jako prywatny": "A dokumentum privátra lett állítva",
        "Ustwienia szczegółów": "Részletes beállítások",
        "usunął": "törölte",
        "Usunął": "Törölte",
        "Usunięcie": "Törlés",
        "Usunięcie dokumentu": "Dokumentum törlése",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nnCzy na pewno chcesz usunąć wybrany formularz?": "Űrlap törlése\\nA művelet visszafordíthatatlan. Minden kapcsolódó dokumentum elvész!\\nBiztosan törölni szeretné a kiválasztott űrlapot?",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "Index törlése\\nA művelet visszafordíthatatlan. Biztosan törölni szeretné a kiválasztott indexet?",
        "Usunięcie pola spowoduje usunięcie go z konfiguracji pól wspólnych na wszystkich modułach oraz ze wszystkich wielo-modułowych list dokumentów.": "Egy mező törlése eltávolítja azt az összes modul közös mező konfigurációjából, valamint minden többmodulos dokumentumlistából.",
        "Usunięcie wybranych elementów": "A kiválasztott elemek törlése",
        "Usunięte": "Törölve",
        "Usunięto z ulubionych": "",
        "usunięty": "törölve",
        "Usunięty": "Törölve",
        "Usuń": "Törlés",
        "Usuń datę": "Dátum törlése",
        "Usuń dział": "Osztály törlése",
        "Usuń filtr": "Szűrő törlése",
        "Usuń grupę": "Csoport törlése",
        "Usuń indeks": "Index törlése",
        "Usuń komentarze z pliku": "Megjegyzések törlése a fájlból",
        "Usuń kontrahenta": "Partner törlése",
        "Usuń obiekt": "Objektum törlése",
        "Usuń plik": "Fájl törlése",
        "Usuń plik z listy": "Fájl törlése a listáról",
        "Usuń pozycję": "Elem törlése",
        "Usuń sekcję": "Szekció törlése",
        "Usuń spacje": "Szóközök törlése",
        "Usuń urządzenie": "Eszköz eltávolítása ",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "Távolítsa el az eszközt, hogy törölje a fiókjához mentett automatikus bejelentkezést.",
        "Usuń z ulubionych": "",
        "Usuń z zespołu": "Eltávolítás a csapatból",
        "Usuń zaznaczony element": "",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "Törlés${selected.length > 1 ? ' kijelöltek' : ''}",
        "Usuwanie dokumentów": "Dokumentumok törlése",
        "Usuwanie użytkowników": "Felhasználók törlése",
        "Usuwanie własnych dokumentów": "Saját dokumentumok törlése",
        "Usuwanie wszystkich dokumentów": "Minden dokumentum törlése",
        "Utworzenie": "",
        "Utworzono danę wyktorową": "Vektordátum létrehozva",
        "Utworzono kolekcję": "Gyűjtemény létrehozva",
        "Utworzono powiadomienie weryfikacyjne": "Ellenőrző értesítés létrehozva",
        "Utworzony przez": "Létrehozta",
        "Utworzył": "Létrehozta",
        "Utwórz grupy": "Csoportok létrehozása",
        "Utwórz katalog": "Mappa létrehozása",
        "Utwórz kopię formularza": "Űrlap másolatának létrehozása",
        "Utwórz kopię z": "Másolat készítése innen",
        "Utwórz nową wersję": "Új verzió létrehozása",
        "Utwórz nowy": "Új létrehozása",
        "Utwórz nowy wątek": "Új szál létrehozása",
        "Uwaga": "Figyelem",
        "Uwaga brak konto do przydzielenia": "Figyelem: nincs hozzárendelhető fiók",
        "Uwaga:": "Figyelem:",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "FIGYELEM: Nincs TypeScript támogatás, és a metódus kódban nem lehet importokat használni.",
        "UWAGA! Funkcja umożliwia natychmiastowe wykonanie skryptu webhook bez dodawania go do kolejki. Pomijanie kolejkowania może prowadzić do przeciążeń systemu i timeoutów, zalecane jest używanie tej opcji tylko w sytuacjach, gdy natychmiastowe wykonanie jest absolutnie konieczne.": "FIGYELEM! Ez a funkció lehetővé teszi a webhook szkript azonnali futtatását sorba állítás nélkül. A sorba állítás kihagyása rendszer túlterheléshez és időtúllépéshez vezethet, ezért csak akkor használja, ha az azonnali futtatás feltétlenül szükséges.",
        "Uwaga! Zmiana sposobu liczenia dokumentów na miesięczny jest nieodwracalna.": "Figyelem! A dokumentumok havi számolására való átállás visszafordíthatatlan.",
        "Uwagi": "Megjegyzések",
        "Uwzględnij wydziały podrzędne": "Alsóbb osztályok figyelembevétele",
        "Uzupełnij jeśli zdjęcie główne znajduje się w osobym polu": "Töltse ki, ha a fő kép külön mezőben található",
        "Uzupełnij konfigurację": "Konfiguráció kiegészítése",
        "Użycie historii dokumentu w szablonie": "Dokumentum előzmények használata a sablonban",
        "Użycie pól dokumentu:": "Dokumentum mezők használata:",
        "Użycie w szablonie:": "Használat a sablonban:",
        "Użyte narzędzie": "Használt eszköz",
        "Użytkownicy": "Felhasználók",
        "Użytkownicy w tej roli": "Ebben a szerepkörben lévő felhasználók",
        "Użytkownik": "Felhasználó",
        "Użytkownik \"%0\" %1 obiekt %2": "Felhasználó \"%0\" %1 objektum %2",
        "Użytkownik jest liderem zespołu": "A felhasználó a csapat vezetője",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "A felhasználó nem tud bejelentkezni, amíg a fiók nincs aktiválva.",
        "Użytkownik nie należy do żadnego zespołu.": "A felhasználó nem tartozik egyetlen csapathoz sem.",
        "Użytkownik posiada pełne uprawnienia": "A felhasználónak teljes jogosultsága van",
        "Użytkownik został dodany do zespołu.": "A felhasználó hozzáadva a csapathoz.",
        "Użytkownik został dodany.": "A felhasználó hozzáadva.",
        "Użytkownik został usunięty.": "A felhasználó törölve lett.",
        "Użytkownik został wylogowany.": "A felhasználó kijelentkezett.",
        "Użytkownik został zaktualizowany.": "A felhasználó frissítve lett.",
        "Użyty Model": "Használt modell",
        "VAT": "ÁFA",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "Az ellenőrző metódusban az alábbi változók érhetők el:",
        "W każdy dzień tygodnia": "A hét minden napján",
        "W kontekście użycia kontrolki w tabeli dynamicznej dostępna jest zmienna: \"data.TableRowIndex\", która zawiera indeks wiersza tabeli w którym znajduje się kontrolka.": "A dinamikus táblázatban használt vezérlő esetén elérhető a \"data.TableRowIndex\" változó, amely tartalmazza a vezérlő sorának indexét.",
        "W następującym dniu:": "A következő napon:",
        "W obiekcie data dostępne są propki isEdit (bool, czy dokument jest w edycji) i processId": "A data objektumban elérhető az isEdit (logikai, hogy szerkesztésben van-e a dokumentum) és a processId.",
        "W obrębie skryptu dostępne są następujące obiekty:": "A szkriptben az alábbi objektumok érhetők el:",
        "W obrębie skryptu możliwe jest korzystanie ze wszystkich serwisów dostępnych w skryptach np. w źródłach danych": "A szkriptben minden elérhető szolgáltatás használható, mint az adatforrásokban.",
        "W organizacji nie ma jeszcze żadnych działów.": "A szervezetben még nincsenek osztályok.",
        "W przypadku zwracania stringa, będzie on wyświetlany jako błąd walidacji.": "Ha szöveget ad vissza, az hibaként jelenik meg.",
        "W przypadku zwracania wartości boolean, true oznacza, że walidacja przeszła poprawnie, a false że wystąpił błąd.": "Ha logikai értéket ad vissza, a true azt jelenti, hogy a validáció sikeres, a false pedig hibát jelent.",
        "W przyszłości": "A jövőben",
        "W skrupcie dostępny jest obiekt Model z następującymi właściwościami:": "A szkriptben elérhető a Model objektum a következő tulajdonságokkal:",
        "W skrypcie dostępne są serwisy identycznie jak w skryptach uruchamianych w źródłach danych i na procesie": "A szkriptben ugyanazok a szolgáltatások érhetők el, mint az adatforrásokban és a folyamatban futó szkriptekben.",
        "W skrypcie dostępny jest obiekt \"document\", który zawiera dane dokumentu (tylko w przypadku edycji), obiekt \"rowIndex\", który w propce \"value\" zawiera index dodawanego wiersza oraz obiekt \"formId\", który w propce \"value\" zawiera id formularza:": "A szkriptben elérhető a \"document\" objektum (csak szerkesztéskor), a \"rowIndex\" objektum, amelynek \"value\" tulajdonsága a hozzáadott sor indexét tartalmazza, valamint a \"formId\" objektum, amelynek \"value\" tulajdonsága az űrlap azonosítóját tartalmazza:",
        "W skrypcie korzystać można ze wszystkich serwisów zgodnie z dokumentacją w źródłach danych.": "A szkriptben minden szolgáltatás használható az adatforrások dokumentációja szerint.",
        "W skryptach procesowych dostępne są następujące obiekty:": "A folyamat szkriptekben az alábbi objektumok érhetők el:",
        "W skryptach procesowych dostępny jest obiekt Model z następującymi właściwościami:": "A folyamat szkriptekben elérhető a Model objektum a következő tulajdonságokkal:",
        "W tym trybie skrypt wywołuje się po załadowaniu formularza": "",
        "W wersji dla przeglądarek": "Böngésző verzióban",
        "w wersji odpowiedniej dla używanego systemu operacyjnego, klikając na jeden z poniższych odnośników": "a használt operációs rendszernek megfelelő verzióban, az alábbi hivatkozások egyikére kattintva",
        "W zespole od %0": "A csapatban %0 óta",
        "W zespole od %0 do %1": "A csapatban %0-tól %1-ig",
        "Walidacja": "Validáció",
        "Walidacja błędów obejmuje tylko najczęściej występujące przypadki. Aby sprawdzić poprawność procesu należy go przetestować.": "A hibák validációja csak a leggyakoribb eseteket fedi le. A folyamat helyességének ellenőrzéséhez tesztelni kell azt.",
        "Walidacja certyfikatu SSL": "SSL tanúsítvány érvényesítése",
        "Walidacja danych": "Adatok validációja",
        "Walidacja po stronie API": "API oldali validáció",
        "Walidator": "Validátor",
        "Warn - ostrzeżenia": "Warn - figyelmeztetések",
        "warning": "figyelmeztetés",
        "Wartości": "Értékek",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "Értékek 0-tól 1.0-ig (0 = 0%, 1 = 100%)",
        "Wartości poszczególnych komórek tabeli są w formacie zgodnym z tym, co dana kontrolka zwraca na front.": "A táblázat egyes celláinak értékei olyan formátumban vannak, amit az adott vezérlő visszaad a frontendnek.",
        "Wartość": "Érték",
        "Wartość brutto": "Bruttó érték",
        "Wartość domyślna": "Alapértelmezett érték",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "Alapértelmezett érték: (&(objectClass=organizationalUnit))",
        "Wartość domyślna: (&(objectClass=user)": "Alapértelmezett érték: (&(objectClass=user)",
        "Wartość musi być liczbą całkowitą": "Az értéknek egész számnak kell lennie",
        "Wartość musi być liczbą dodatnią": "Az értéknek pozitív számnak kell lennie",
        "Wartość musi być liczbą ujemną": "Az értéknek negatív számnak kell lennie",
        "Wartość netto": "Nettó érték",
        "Wartość skopiowana do schowka.": "Az érték a vágólapra másolva.",
        "Warunek": "Feltétel",
        "Warunek porównania do daty bieżącej pola w wybranym kroku na wskazanym formularzu": "Feltétel összehasonlítása az aktuális dátummal a kiválasztott lépésben, a megadott űrlapon",
        "Warunek porównania do daty bieżącej pola z dokumentu": "Feltétel összehasonlítása az aktuális dátummal a dokumentumban",
        "Warunek sprawdzający, czy kwota powiązanego zamówienia jest większa niż 1000": "",
        "Warunek sprawdzający, czy pole typu 'Tak/Nie' ma wartość Nie": "Feltétel, amely ellenőrzi, hogy a 'Igen/Nem' típusú mező értéke 'Nem'",
        "Warunek sprawdzający, czy pole typu 'Tak/Nie' ma wartość Tak": "Feltétel, amely ellenőrzi, hogy a 'Igen/Nem' típusú mező értéke 'Igen'",
        "Warunek uruchomienia zadania": "Feladat indításának feltétele",
        "Warunek zmienne porównane do pola dokumentu": "Feltétel: változók összehasonlítása a dokumentum mezőjével",
        "Warunek zmienne porównane do pola w wybranym kroku na wskazanym fomrularzu": "Feltétel: változók összehasonlítása a kiválasztott lépés mezőjével a megadott űrlapon",
        "Warunki korzystania z usług Google": "Google szolgáltatások használati feltételei",
        "Warunki logiczne": "Logikai feltételek",
        "Warunkowe wyświetlanie kolumn tabeli": "Táblázat oszlopainak feltételes megjelenítése",
        "Warunkowe wyświetlanie pól": "Mezők feltételes megjelenítése",
        "Warunkowo": "Feltételesen",
        "Ważne informacje": "Fontos információk",
        "Ważność": "Fontosság",
        "Wątek": "Szál",
        "Wątek główny": "Fő szál",
        "Wątek główny jest kontynuowany automatycznie przez asystenta.": "A fő szálat az asszisztens automatikusan folytatja.",
        "Webhook": "Webhook",
        "Webhook obsługuje argument JSON i XML": "A webhook támogatja a JSON és XML argumentumokat",
        "Webhook został dodany.": "A webhook hozzáadva.",
        "Webhook został usunięty.": "A webhook törölve lett.",
        "Webhook został zaktualizowany.": "A webhook frissítve lett.",
        "Webhooki": "Webhookok",
        "Weekend": "Hétvége",
        "Wersja": "Verzió ",
        "Wersja API": "API verzió",
        "Wersja językowa": "Nyelvi változat",
        "Wersja modułu": "Modul verzió",
        "Wersja robocza": "Vázlatos változat",
        "Wersja utowrzona przez": "Verzió létrehozta",
        "Wersje": "Verziók",
        "Wersje dokumentu": "Dokumentum verziók",
        "wersji zaakceptowanej": "elfogadott verzió",
        "Wersjonowanie": "Verziókezelés",
        "Wersjonowanie dokumentów włączone": "Dokumentum verziókezelés engedélyezve",
        "Wersjonowanie dokumentów wyłączone": "Dokumentum verziókezelés letiltva",
        "Wersjonowanie można zmienić tylko podczas dodawania nowego formularza.": "A verziókezelés csak új űrlap hozzáadásakor módosítható.",
        "Wewnętrznie": "Belsőleg",
        "Węgierski": "Magyar",
        "Wg dat": "Dátum szerint",
        "Wiadomość testowa została wysłana.": "Teszt üzenet elküldve.",
        "Widget został dodany": "Widget hozzáadva",
        "Widget został usunięty": "Widget törölve",
        "Widget został zapisany": "Widget elmentve",
        "Widgety": "Widgetek",
        "Widoczne w listach": "Listákban látható",
        "Widoczność": "Láthatóság",
        "Widoczność formatowania": "Formázás láthatósága",
        "Widoczność kolumn": "Oszlopok láthatósága",
        "Widoczność modułu w menu": "Modul láthatósága a menüben",
        "Widoczność sekcji w menu modułu": "Szekció láthatósága a modul menüjében",
        "Widok nieobsługiwany": "Nem támogatott nézet",
        "Widok ustawień": "Beállítások nézet",
        "Widzi wszystkie dokumenty w rejestrze i ich szczegóły": "Látja az összes dokumentumot a nyilvántartásban és azok részleteit",
        "Widzi wszystkie faktury w rejestrze i ich szczegóły.": "Látja az összes számlát a nyilvántartásban és azok részleteit.",
        "Widzi wszystkie nieobecności w rejestrze i ich szczegóły": "Látja az összes távollétet a nyilvántartásban és azok részleteit",
        "Widzi wszystkie pisma w rejestrze i ich szczegóły": "Látja az összes levelet a nyilvántartásban és azok részleteit",
        "Widzi wszystkie reklamacje w rejestrze i ich szczegóły": "Látja az összes reklamációt a nyilvántartásban és azok részleteit",
        "Widzi wszystkie umowy w rejestrze i ich szczegóły": "Látja az összes szerződést a nyilvántartásban és azok részleteit",
        "Widzi wszystkie wnioski w rejestrze i ich szczegóły": "Látja az összes kérelmet a nyilvántartásban és azok részleteit",
        "Widżety": "Widgetek",
        "Wielkość kroku": "Lépés mérete",
        "Wielokrotny wybór": "Többszörös választás",
        "Wiersz": "Sor",
        "Wiersze": "Sorok",
        "Więcej": "Több",
        "więcej...": "tovább...",
        "Więcej...": "Tovább...",
        "Wizualizacja": "Vizualizáció",
        "Wklej komponent": "Komponens beillesztése",
        "Wklej skopiowany element": "",
        "Właściwości": "Tulajdonságok",
        "Właściwości opisujące pole:": "A mezőt leíró tulajdonságok:",
        "Właściwości szablonu": "Sablon tulajdonságai",
        "Włącz": "Engedélyezés",
        "Włącz obsługę wprowadzania dokumentów w module biuro": "Dokumentumok bevitelének engedélyezése az irodai modulban",
        "Włącz podsumowanie kolumn": "Oszlop összegzés engedélyezése",
        "Włącz podsumowanie wierszy": "Sor összegzés engedélyezése",
        "Włącz system powiadomień": "Értesítési rendszer engedélyezése",
        "Włącz walidację po stronie API": "API oldali validáció engedélyezése",
        "Włącz wsparcie AI przy wprowadzaniu dokumentów w module biuro": "AI támogatás engedélyezése dokumentum bevitelénél az irodai modulban",
        "Włącz wyszukiwanie pełnotekstowe w plikach": "Teljes szövegű keresés engedélyezése a fájlokban",
        "Włączenie moderacji danych wejściowych jest zalecane.": "A bemeneti adatok moderálásának engedélyezése ajánlott.",
        "Włączone": "Engedélyezve",
        "Włączony": "Engedélyezve",
        "Województwo": "Megye",
        "Wpis domyślny": "Alapértelmezett bejegyzés",
        "Wpis nadrzędny": "Szülő bejegyzés",
        "Wpis w sitemap": "Bejegyzés a sitemapban",
        "Wpis został dodany.": "Bejegyzés hozzáadva.",
        "Wpis został usunięty.": "Bejegyzés törölve.",
        "Wpis został zaakceptowany.": "Bejegyzés elfogadva.",
        "Wpis został zaktualizowany.": "Bejegyzés frissítve.",
        "Wpisz kod ikony Font Awesome, aby zobaczyć podgląd": "Írja be a Font Awesome ikon kódját az előnézethez",
        "Wpisz komentarz...": "Írjon megjegyzést...",
        "Wpisz wiadomość": "Írjon üzenetet",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "Adja meg azokat az URL-eket, amelyeket ki szeretne zárni. Az adatok vesszővel vagy új sorral elválaszthatók.",
        "Wprowadzenie  zmian może spowodować utratę spójności jeśli dane z tego dokumentu lub dokumentów powiązanych są przeliczane w trakcie procesowania. Czy na pewno wprowadzić zmiany?": "A módosítások bevezetése adatkonzisztencia elvesztését okozhatja, ha a dokumentum vagy a kapcsolódó dokumentumok adatai feldolgozás alatt vannak. Biztosan végrehajtja a módosításokat?",
        "Wprowadzona wartość jest nieprawidłowa": "A megadott érték érvénytelen",
        "Wprowadzona wartość jest za długa": "A megadott érték túl hosszú",
        "Wprowadzona wartość jest za krótka": "A megadott érték túl rövid",
        "Wprowadzona wartość jest za niska": "A megadott érték túl alacsony",
        "Wprowadzona wartość jest za wysoka": "A megadott érték túl magas",
        "Wprowadzona wartość nie jest poprawna": "A megadott érték nem megfelelő",
        "Wprowadź dokument z Asystentem AI": "Adjon meg dokumentumot AI asszisztenssel",
        "Wprowadź prompt, który pomoże AI w klasyfikacji dokumentów do tego modułu...": "Adjon meg egy promptot, amely segít az AI-nak a dokumentumok osztályozásában ebben a modulban...",
        "Wróć do logowania": "Vissza a bejelentkezéshez",
        "Wróć do strony głównej": "Vissza a főoldalra",
        "Wrzesień": "Szeptember",
        "Wskazówka:": "Tipp:",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Meghatározza, meddig marad érvényes a válasz a Redis szerver memóriájában.",
        "Wskaż pole z argumentem": "Adja meg az argumentum mezőt",
        "Wstaw cztery kolumny 1/4": "Négy oszlop beszúrása 1/4 arányban",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Két oszlop beszúrása 1/3 és 2/3 arányban",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Két oszlop beszúrása 2/3 és 1/3 arányban",
        "Wstaw dwie równe kolumny": "Két egyenlő oszlop beszúrása",
        "Wstaw kontrolkę": "Vezérlő beszúrása",
        "Wstaw stronę": "Oldal beszúrása",
        "Wstaw szablon informacyjny ze zdjęciem": "Információs sablon beszúrása képpel",
        "Wstaw trzy kolumny 1/3": "Három oszlop beszúrása 1/3 arányban",
        "Wstaw z dołu": "Beszúrás alulról",
        "Wstaw z góry": "Beszúrás felülről",
        "Wstaw z lewej strony": "Beszúrás balról",
        "Wstaw z prawej strony": "Beszúrás jobbról",
        "Wstecz": "Vissza",
        "Wstępne filtrowanie danych": "Adatok előzetes szűrése",
        "Wszyscy": "Mindenki",
        "Wszyscy pracownicy mogą dodawać nieobecność.": "Minden dolgozó hozzáadhat távollétet.",
        "Wszyscy pracownicy mogą dodawać wniosek.": "Minden dolgozó hozzáadhat kérelmet.",
        "Wszystkie": "Minden",
        "Wszystkie działy": "Minden osztály",
        "Wszystkie niezapisane zmiany zostaną utracone.": "Minden nem mentett módosítás elvész.",
        "Wszystkie próby": "Minden próbálkozás",
        "Wszystko": "Minden",
        "Wtorek": "Kedd",
        "wybierz": "Válassza ki",
        "Wybierz": "Válasszon",
        "wybierz długość": "Válassza ki a hosszúságot",
        "Wybierz dokument": "Dokumentum kiválasztása",
        "Wybierz dokument do podglądu": "Válasszon dokumentumot a megtekintéshez",
        "Wybierz dokumenty aby zobaczyć dostępne akcje": "Válasszon dokumentumokat az elérhető műveletek megtekintéséhez",
        "Wybierz działy": "Válasszon osztályokat",
        "Wybierz filtr": "Szűrő kiválasztása",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "Válasszon űrlapot, amely további mezőket tartalmaz a felhasználói fiókokhoz",
        "Wybierz grupę": "Válasszon csoportot",
        "Wybierz grupy użytkowników": "Válasszon felhasználói csoportokat",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "Válassza ki a mappát, ahová át szeretné helyezni a kiválasztott elemeket.",
        "wybierz model": "Válasszon modellt",
        "Wybierz moduł aby ograniczyć wiązanie do wybranego typu dokumentu": "Válasszon modult, hogy a kapcsolódás csak a kiválasztott dokumentumtípusra korlátozódjon",
        "Wybierz odpowiadające sobie procesy, aby je zaktualizować": "Válassza ki a megfelelő folyamatokat a frissítéshez",
        "Wybierz plik": "Fájl kiválasztása",
        "Wybierz plik do udostępnienia": "Válasszon fájlt a megosztáshoz",
        "Wybierz plik lub katalog": "Válasszon fájlt vagy mappát",
        "Wybierz plik.": "Válasszon fájlt.",
        "Wybierz pliki": "Fájlok kiválasztása",
        "Wybierz pliki (do {0})": "Fájlok kiválasztása (max. {0})",
        "Wybierz pole": "Mező kiválasztása",
        "Wybierz pole do filtrowania": "Válasszon mezőt a szűréshez",
        "Wybierz pole dokumentu": "Dokumentum mező kiválasztása",
        "Wybierz pole tekstowe z dokumentu powiązanego": "Válasszon szöveges mezőt a kapcsolódó dokumentumból",
        "Wybierz serwer": "Szerver kiválasztása",
        "Wybierz shortcode": "Shortcode kiválasztása",
        "Wybierz skrypt": "Válasszon egy szkriptet",
        "Wybierz tryb kolekcje": "Válassza ki a gyűjtemény módot",
        "Wybierz tryb pracy": "Válassza ki a működési módot",
        "Wybierz typ": "Válassza ki a típust",
        "Wybierz typ odbiorcy": "Válassza ki a címzett típusát",
        "Wybierz typ podpisu": "Válassza ki az aláírás típusát",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Válassza ki az értesítés típusát, hogy megtekinthesse az elérhető kulcsokat.",
        "Wybierz użytkownika": "Felhasználó kiválasztása",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Válassza ki a felhasználókat, akikre műveletet szeretne végrehajtani",
        "Wybierz wątek w którym chcesz prowadzić konwersację.": "Válassza ki a szálat, amelyben beszélgetni szeretne.",
        "Wybierz wersję": "Verzió kiválasztása",
        "Wybierz zaznaczone": "Kijelöltek kiválasztása",
        "Wybierz zespoły": "Válasszon csapatokat",
        "wybierz...": "válasszon...",
        "Wybierz...": "Válasszon...",
        "Wybór": "Választás",
        "Wybór języka": "Nyelvválasztás",
        "Wybór wersji": "Verzió választás",
        "Wybór załączników": "Mellékletek kiválasztása",
        "Wybór+": "Választás+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "A kiválasztott dátum kisebb, mint a megengedett %0.",
        "Wybrana data jest większa niż dozwolona %0.": "A kiválasztott dátum nagyobb, mint a megengedett %0.",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "A kiválasztott szám kisebb, mint a megengedett %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "A kiválasztott szám nagyobb, mint a megengedett %0.",
        "Wybrana spółka jest automatycznie przypisywana do importowanego dokumentu, więc mapowanie pola nie jest wymagane. Jeśli mapowanie pola jest zdefiniowane oraz wartość jest wpisana w excel, spółka zostanie nadpisana.": "A kiválasztott vállalat automatikusan hozzárendelődik az importált dokumentumhoz, ezért a mező leképezése nem szükséges. Ha a mező leképezése meg van adva és az érték szerepel az excelben, a vállalat felülíródik.",
        "Wybrane": "Kiválasztva",
        "Wybrane %0 na %1": "%0 kiválasztva a(z) %1-ből",
        "Wybrane dokumenty": "Kiválasztott dokumentumok",
        "Wybrane elementy zostały przeniesione.": "A kiválasztott elemek áthelyezve.",
        "Wybrane elementy zostały usunięte.": "A kiválasztott elemek törölve.",
        "Wybrane pliki": "Kiválasztott fájlok",
        "Wybrane pliki: {0}": "Kiválasztott fájlok: {0}",
        "Wybrane pole zastąpi pole zgrupowane w konfiguracjach modułu": "A kiválasztott mező felülírja a csoportosított mezőt a modul konfigurációiban",
        "Wybrane: %0": "Kiválasztva: %0",
        "Wybranie pola spowoduje, że klucz tego pola będzie wykorzystany jako klucz pola zgrupowanego.": "Egy mező kiválasztása esetén annak kulcsa lesz felhasználva a csoportosított mező kulcsaként.",
        "Wybrano %0 użytkowników.": "%0 felhasználó kiválasztva.",
        "Wybrano dostawcę Azure AI.": "Azure AI szolgáltató kiválasztva.",
        "Wybrano dostawcę Azure OpenAI.": "Azure OpenAI szolgáltató kiválasztva.",
        "Wybrano dostawcę OpenAI.": "OpenAI szolgáltató kiválasztva.",
        "Wybrano jednego użytkownika.": "Egy felhasználó kiválasztva.",
        "Wybrany język": "Kiválasztott nyelv",
        "Wybrany rejestr jest automatycznie przypisywany do importowanego dokumentu, więc mapowanie pola nie jest wymagane. Jeśli mapowanie pola jest zdefiniowane oraz wartość jest wpisana w excel, rejestr zostanie nadpisany.": "A kiválasztott nyilvántartás automatikusan hozzárendelődik az importált dokumentumhoz, ezért a mező leképezése nem szükséges. Ha a mező leképezése meg van adva és az érték szerepel az excelben, a nyilvántartás felülíródik.",
        "Wybrany użytkownik": "Kiválasztott felhasználó",
        "Wybróbuj możliwości AI": "Próbálja ki az AI lehetőségeit",
        "Wyciągam dane": "Adatok kinyerése",
        "Wyczyść": "Törlés",
        "Wydarzenie": "Esemény",
        "Wydarzenie cykliczne": "Ismétlődő esemény",
        "Wydział": "Kar",
        "Wygenerowana odpowiedź przez model AI.": "AI modell által generált válasz.",
        "Wygenerowane obrazy": "Generált képek",
        "Wygeneruj dokumentację": "Dokumentáció létrehozása",
        "Wygeneruj metadane dla przesyłanych obrazów": "Generálj metaadatokat a feltöltött képekhez",
        "Wyklucz logowanie zależności": "Kizárja a függőségek naplózását",
        "Wykonaj": "Végrehajtás",
        "Wykonawca": "Kivitelező",
        "Wykonywana przez skrypt robotyzujący niedostępna dla użytkownika": "Robotizált szkript által végrehajtva, felhasználó számára nem elérhető",
        "Wykonywanie akcji": "",
        "Wykonywanie...": "",
        "Wykorzystaj maksymalną dostępną wysokość": "Használd a maximális elérhető magasságot",
        "Wykorzystane": "Felhasznált",
        "Wykorzystanie": "Felhasználás",
        "Wykresy": "Diagramok",
        "Wykryto zmiany w argumencie. Zapis usunie istniejący wektor w bazie. Kontynuować?": "Változások észlelve az argumentumban. A mentés törli a meglévő vektort az adatbázisból. Folytatja?",
        "Wyliczone daty": "Kiszámított dátumok",
        "Wyloguj się": "Kijelentkezés",
        "Wyloguj zalogowanego obecnie użytkownika": "Jelenleg bejelentkezett felhasználó kijelentkeztetése",
        "Wyłaczone": "Kikapcsolva",
        "Wyłącz funkcję zbierania danych o zapoznaniu się z dokumentem": "",
        "Wyłączenie tej funkcji spowoduje, że nie będzie działo pogrubianie nieodczytanych dokumentów oraz funkcja “oko” na historii i dane potrzebne do jej działania nie będą zapisywane. Czy na pewno chcesz kontynuowac?": "",
        "Wymagaj znaków specjalnych w hasłach": "Különleges karakterek használata a jelszavakban",
        "Wymagalność pola (true, false)": "Mező kötelező (igaz, hamis)",
        "wymagana jest instalacja dedykowanego rozszerzenia": "Szükséges a dedikált bővítmény telepítése",
        "Wymagane": "Szükséges",
        "Wymagane jest ustawienie minimalnej długości hasła": "A jelszó minimális hosszának beállítása szükséges",
        "Wymagane jest wybranie formularza": "Űrlap kiválasztása szükséges",
        "Wymagane jest wybranie kategorii": "Kategória kiválasztása szükséges",
        "Wymagane jest wybranie komponentu": "Komponens kiválasztása szükséges",
        "Wymagane jest wybranie modułu": "Modul kiválasztása szükséges",
        "Wymagane jest wybranie powiązania": "Kapcsolat kiválasztása szükséges",
        "Wymagane jest wybranie sekcji": "Szekció kiválasztása szükséges",
        "Wymagane jest wybranie skryptu": "Szkript kiválasztása szükséges",
        "Wymagane jest wybranie trybu": "Mód kiválasztása szükséges",
        "Wymagane jest wybranie źródła danych": "Adatforrás kiválasztása szükséges",
        "Wymiary": "Méretek",
        "Wymuś zmianę hasła": "Jelszóváltás kényszerítése",
        "Wynik testu": "Teszt eredménye",
        "Wyniki": "Eredmények",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "A teszt eredményei legfeljebb 10 elemre korlátozódnak.",
        "Wypełniam formularz": "Űrlapot töltök ki",
        "Wypełnij formularz ostatnio zapisaną wersją": "Töltsd ki az űrlapot a legutóbb mentett verzióval",
        "Wyrażenia do pól wyliczanych": "Számított mezők kifejezései",
        "Wyrażenia warunkowe": "Feltételes kifejezések",
        "Wyrażenie (wymagane)": "Kifejezés (kötelező)",
        "Wyrażenie regularne": "Reguláris kifejezés",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "A \"/pattern/flag\" formátumú kifejezés nem támogatott, csak a mintát használd",
        "Wysłane": "Elküldött",
        "Wysoka szczegółowość": "Magas részletesség",
        "Wysokość": "Magasság",
        "Wysokość (w calach)": "Magasság (hüvelykben)",
        "Wysokość wiersza": "Sor magasság",
        "wystąpieniach": "előfordulásokban",
        "Wystąpił błąd podczas aktualizacji ulubionych": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "Hiba történt a kép betöltésekor. Próbáld újra.",
        "Wystąpił błąd podczas pobierania akcji": "Hiba történt az akciók lekérésekor",
        "Wystąpił błąd podczas pobierania danych": "Hiba történt az adatok lekérésekor",
        "Wystąpił błąd podczas pobierania konfiguracji": "Hiba történt a konfiguráció lekérésekor",
        "Wystąpił błąd podczas pobierania konfiguracji kontrolki.": "Hiba történt a vezérlő konfigurációjának lekérésekor.",
        "Wystąpił błąd podczas pobierania task listy.": "Hiba történt a feladatlista lekérésekor.",
        "Wystąpił błąd podczas pobierania ustawień.": "Hiba történt a beállítások lekérésekor.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "Hiba történt a felhasználók exportálása közben.",
        "Wystąpił błąd podczas próby importu definicji modułu.": "Hiba történt a modul definíciójának importálása közben.",
        "Wystąpił błąd podczas próby importu użytkowników.": "Hiba történt a felhasználók importálása közben.",
        "Wystąpił błąd podczas przetwarzania dokumentu": "Hiba történt a dokumentum feldolgozása közben",
        "Wystąpił błąd podczas przetwarzania dokumentu.": "Hiba történt a dokumentum feldolgozása közben.",
        "Wystąpił błąd podczas usuwania dokumentu.": "Hiba történt a dokumentum törlésekor.",
        "Wystąpił błąd podczas usuwania rekordu": "Hiba történt a rekord törlésekor",
        "Wystąpił błąd podczas wysyłki podpisanego dokumentu.": "Hiba történt az aláírt dokumentum elküldésekor.",
        "Wystąpił błąd podczas zwektoryzowania": "Hiba történt a vektorizálás során",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Kapcsolati hiba történt. Győződj meg róla, hogy van internetkapcsolatod, és próbáld újra.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Szerverhiba történt a kiválasztott művelet végrehajtása közben. Próbáld újra.",
        "Wystąpił problem podczas pobierania szablonu": "Hiba történt a sablon lekérésekor",
        "Wystąpił problem podczas przesyłania obrazu.": "Hiba történt a kép feltöltésekor.",
        "Wystąpił problem podczas przetwarzania": "Hiba történt a feldolgozás során",
        "Wystąpił problem w komunikacji z Api dostawcy podpisów. Kliknij ponownie Podpisz.": "Hiba történt az aláírás szolgáltató API-jával való kommunikációban. Kattints újra az Aláírás gombra.",
        "Wystąpiły błędy podczas importu procesu": "Hibák történtek a folyamat importálása során",
        "Wyst�pi� b��d podczas importu skryptu.": "Hiba történt a szkript importálása során.",
        "Wysyłaj dane o użytkowniku": "Felhasználói adatokat küld",
        "Wysyłaj do każdego osobno": "Küldés mindenkinek külön-külön",
        "Wysyłaj tym kanałem": "Küldés ezen a csatornán",
        "Wysyłka dokumentu": "Dokumentum küldése",
        "Wyszukaj": "Keresés",
        "Wyszukaj (Ctrl+Q)": "Keresés (Ctrl+Q)",
        "Wyszukaj aplikacje": "Alkalmazások keresése",
        "Wyszukaj w działach podrzędnych": "Keresés aloldalakban",
        "Wyszukaj widget": "Widget keresése",
        "Wyszukaj wszędzie": "Keresés mindenhol",
        "Wyszukaj...": "Keresés...",
        "Wyszukiwanie": "Keresés",
        "Wyszukiwanie pełnotekstowe": "Teljes szöveges keresés",
        "Wyszukiwanie plików": "Fájlok keresése",
        "Wyszukiwanie plików umożliwia asystentowi korzystanie z wiedzy z plików. Po przesłaniu pliku asystent automatycznie decyduje, kiedy pobrać treść, na podstawie żądań użytkownika.": "A fájlkeresés lehetővé teszi az asszisztens számára, hogy fájlokból származó tudást használjon. Fájl feltöltése után az asszisztens automatikusan eldönti, mikor töltse le a tartalmat a felhasználói kérések alapján.",
        "Wyszukiwanie w diagramie": "",
        "Wyszukiwany ciąg znaków": "Keresett karakterlánc",
        "Wyszukiwarka adresów ADE": "ADE címkereső",
        "Wyszukiwarka dokumentów": "Dokumentumkereső motor",
        "Wyślij": "Küldés",
        "Wyślij do": "Küldés neki",
        "Wyślij DW": "Küldés CC",
        "Wyślij kod": "Küldj kódot",
        "Wyślij link": "Küldj linket",
        "Wyślij powiadomienie": "Értesítés küldése",
        "Wyślij wiadomość Microsoft Teams": "Microsoft Teams üzenet küldése",
        "Wyświetl filtry": "Szűrők megjelenítése",
        "Wyświetl wszystko": "Összes megjelenítése",
        "Wyświetlaj osobny formularz dla każdego dokumentu": "",
        "Wyświetlaj tylko dokumenty których użytkownik:": "Csak azokat a dokumentumokat jelenítse meg, amelyeknél a felhasználó:",
        "Wyświetlam": "Megjelenítem",
        "Wyświetlamy pierwsze znalezione 10 tyś rekordów, wyników może być więcej, zawęź kryteria wyszukiwania": "Az első 10 ezer találatot jelenítjük meg, lehet, hogy több eredmény van, szűkítse a keresési feltételeket",
        "Wyświetlanie dokumentów": "Dokumentumok megjelenítése",
        "Wyświetlany układ / dane": "Megjelenített elrendezés / adatok",
        "Wyświetlone zostaną 2 pierwsze znaki z wybranego pola": "A kiválasztott mező első 2 karaktere lesz megjelenítve",
        "Wytnij": "Kivágás",
        "Wywołanie funkcji": "Függvényhívás",
        "Wyzeruj licznik": "Számláló nullázása",
        "Wzorzec": "Minta",
        "Wzorzec cyklu": "Ciklus minta",
        "z": "ból/ből",
        "Z uprawnieniami": "Jogosultságokkal",
        "Z uprawnieniami do modułu": "Modul jogosultságokkal",
        "Zaakceptowane": "Elfogadott",
        "Zaakceptowano": "Elfogadva",
        "Zaakceptowany": "Elfogadott",
        "Zaawansowane uprawnienia": "Speciális jogosultságok",
        "Zabierz dostęp": "Hozzáférés visszavonása",
        "Zablokowany": "Letiltva",
        "Zablokuj": "Letiltás",
        "Zachowaj oryginalny format obrazów": "Eredeti képformátum megtartása",
        "zacznij pisać aby wyszukać użytkownika...": "kezdjen el gépelni a felhasználó kereséséhez...",
        "Zacznij pisać Form, Entry lub Document aby uruchomić podpowiadanie.": "",
        "Zaczyna sie od": "Kezdődik ezzel",
        "Zadanie": "Feladat",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "Az indexek újraépítése elindult.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "Az adatok újraindexelése elindult.",
        "Zadanie zostało uruchomione.": "A feladat elindult.",
        "Zadanie zostało włączone": "A feladat engedélyezve lett",
        "Zadanie zostało wyłączone": "A feladat letiltva lett",
        "Zagrożenie": "Veszély",
        "Zaimportowane dane nadpiszą istniejące dane w module": "Az importált adatok felülírják a modulban lévő adatokat",
        "Zaimportowane dane zostaną dopisane do istniejących danych w module": "Az importált adatok hozzáadódnak a modulban lévő adatokhoz",
        "Zaimportowano definicję modułu.": "A modul definíciója importálva lett.",
        "Zaimportowano listę użytkowników.": "A felhasználók listája importálva lett.",
        "Zaimportowano:": "Importálva:",
        "Zakładka": "Fül",
        "Zakładki": "Fülek",
        "Zakolejkowane": "Sorba állítva",
        "Zakończ edycję": "Szerkesztés befejezése",
        "Zakończ sesję": "Munkamenet befejezése",
        "Zakończ sesję aby wylogować użytkownika": "A munkamenet befejezése a felhasználó kijelentkezéséhez",
        "Zakończone": "Befejezett",
        "Zakończono": "",
        "Zakończono import": "Az importálás befejeződött",
        "Zakres": "Hatókör",
        "Zakres cyklu": "Ciklus tartománya",
        "Zakres czasu": "Időtartomány",
        "Zakres dat": "Dátumtartomány",
        "Zaktualizuj formularz": "Űrlap frissítése",
        "Zależna od kontrolki": "Vezérlőtől függő",
        "Zalogowany": "Bejelentkezett",
        "Zalogowany użytkownik": "Bejelentkezett felhasználó",
        "Zaloguj do SimplySign": "Jelentkezzen be a SimplySign-ba",
        "Zaloguj się": "Bejelentkezés",
        "Zaloguj się na swoje konto": "Jelentkezzen be a fiókjába",
        "Załączniki": "Mellékletek",
        "Zamiany zostały zapisane.": "A módosítások elmentve.",
        "Zamień akceptanta": "Elfogadót cserélje",
        "Zamknij": "Bezárás",
        "Zamknij edycje": "Szerkesztés bezárása",
        "Zamknij linię": "Sor bezárása",
        "Zaokrąglenie": "Kerekítés",
        "Zapamiętaj logowanie": "Bejelentkezés megjegyzése",
        "Zapamiętane urządzenia": "Mentett eszközök",
        "Zapisano formularz": "Űrlap elmentve",
        "Zapisuj do celu": "Mentés célba",
        "Zapisuję dokument w systemie...": "Dokumentum mentése a rendszerben...",
        "Zapisywanie obrazów zakończone.": "Képek mentése befejeződött.",
        "Zapisz": "Mentés",
        "Zapisz diagram": "Diagram mentése",
        "Zapisz diagram w celu wyświetlenia błędów oraz przetestuj dokument": "Mentse a diagramot a hibák megjelenítéséhez és tesztelje a dokumentumot",
        "Zapisz dokument jako nowy w PDF": "Dokumentum mentése új PDF-ként",
        "Zapisz filtr": "Szűrők mentése",
        "Zapisz filtry": "Szűrők mentése",
        "Zapisz i wróć": "Mentés és visszatérés",
        "Zapisz i zamknij": "Mentés és bezárás",
        "Zapisz importowany plik do pola": "Importált fájl mentése a mezőbe",
        "Zapisz jako": "Mentés másként",
        "Zapisz jako nowy filtr": "Mentés új szűrőként",
        "Zapisz nową wersję": "Új verzió mentése",
        "Zapisz treść OCR do pola": "OCR tartalom mentése a mezőbe",
        "Zapisz układ": "Elrendezés mentése",
        "Zapisz ustawienia": "Beállítások mentése",
        "Zapisz ustawienia widgetów": "Widget beállítások mentése",
        "Zapisz uwagi do pola": "Megjegyzések mentése a mezőbe",
        "Zapisz widget": "Widget mentése",
        "Zapisz wybrane": "Kiválasztottak mentése",
        "Zapisz wynik do pola": "Eredmény mentése a mezőbe",
        "Zapisz wynik we wskazanym polu": "Eredmény mentése a megadott mezőbe",
        "Zapisz wynik wysyłki e-maila (powodzenie/niepowodzenie) we wskazanym polu": "Az e-mail küldés eredményének (siker/hiba) mentése a megadott mezőbe",
        "Zapisz zmiany": "Változások mentése",
        "Zaplanowane": "Tervezett",
        "Zapomniałeś hasła?": "Elfelejtette a jelszavát?",
        "Zapoznał się": "Megismerte",
        "Zaproszenia do akceptacji": "Elfogadásra váró meghívások",
        "Zaproszenia usunięte/odrzucone": "Meghívások törölve/elutasítva",
        "Zaproszenie zostało odrzucone": "A meghívás elutasítva lett",
        "Zaproszenie zostało zaakceptowane": "A meghívás elfogadva lett",
        "Zaproś uczestników": "Résztvevők meghívása",
        "Zapytanie SQL do pobrania po ID": "SQL lekérdezés az ID alapján történő lekéréshez",
        "Zapytanie SQL do wyszukiwania": "SQL lekérdezés kereséshez",
        "Zarchiwizowane": "Archivált",
        "Zarządzaj filtrami": "Szűrők kezelése",
        "Zarządzaj kolumnami": "Oszlopok kezelése",
        "Zasięg": "Tartomány",
        "Zastępował": "Helyettesített",
        "zastępował: ": "helyettesített: ",
        "Zastępstwa": "Cserejátékosok",
        "Zastępstwo": "Helyettesítés",
        "Zastępstwo wygasło.": "A helyettesítés lejárt.",
        "Zastępstwo wygaśnie za 10 minut.": "A helyettesítés 10 perc múlva lejár.",
        "Zastępstwo wygaśnie za 5 minut.": "A helyettesítés 5 perc múlva lejár.",
        "Zastępstwo wygaśnie za minutę.": "A helyettesítés 1 perc múlva lejár.",
        "Zastępstwo zostało dodane.": "A helyettesítés hozzáadva.",
        "Zastępstwo zostało usunięte.": "A helyettesítés törölve lett.",
        "Zastępstwo zostało zaktualizowane.": "A helyettesítés frissítve lett.",
        "Zastępuje osobę": "Egy személyt helyettesít",
        "Zastosuj zmiany w aplikacji": "Alkalmazza a változtatásokat az alkalmazásban",
        "Zatrzymaj": "Leállítás",
        "Zatrzymaj udostępnianie": "Megosztás leállítása",
        "Zatwierdź": "Jóváhagyás",
        "Zawęź filtr do dokumentów powiązanych z pola": "Szűrje a dokumentumokat a mezőhöz kapcsolódóakra",
        "Zawęź listę dokumentów do dokumentów powiązanych": "Szűkítse a dokumentumok listáját a kapcsolódó dokumentumokra",
        "Zawęż listę dokumentów na podstawie kontrahenta": "Szűkítse a dokumentumok listáját a partner alapján",
        "Zawiera": "Tartalmazza",
        "Zawsze": "Mindig",
        "Zaznacz": "Jelölés",
        "Zaznacz wszystkie": "Összes kijelölése",
        "Zaznacz wszystkie elementy": "",
        "Zbieracz kosztów": "Költséggyűjtő",
        "Zdarzenie": "Esemény",
        "Zdjęcie": "Fénykép",
        "Zdjęcie użytkownika": "Felhasználói fotó",
        "Ze skryptu dynamicznego modala/przycisku możemy zwrócić błąd w taki sposób, by wyświetlił się on pod odpowiednim polem formularza nadrzędnego i w popupie.": "A dinamikus modal/szkriptből hibát adhatunk vissza úgy, hogy az a fő űrlap megfelelő mezője alatt és a felugró ablakban jelenjen meg.",
        "Zespoły": "Csapatok",
        "Zespól": "Csapat",
        "Zespół": "Csapat",
        "Zespół aktywny": "Aktív csapat",
        "Zespół został dodany.": "A csapat hozzáadva.",
        "Zespół został usunięty.": "A csapat törölve lett.",
        "Zespół został zaktualizowany.": "A csapat frissítve lett.",
        "Zgoda": "Hozzájárulás",
        "Zgrupuj pola": "Mezők csoportosítása",
        "Złożenie podpisu zostało zakończone sukcesem": "Az aláírás sikeresen befejeződött",
        "Zmiana akceptantów": "Elfogadók módosítása",
        "Zmiana elementu": "",
        "Zmiana hasła": "Jelszó megváltoztatása",
        "Zmiana prywatności": "Adatvédelem módosítása",
        "Zmiana rozmiaru obrazu": "Kép méretének módosítása",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "A monitorozási beállítások módosítása alkalmazás újraindítását igényli.",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "A változások csak az indexek újraépítése után lépnek életbe.",
        "Zmiany zostały zapisane.": "A változások elmentve.",
        "Zmiany zostaną zastosowane w aplikacji w przeciągu kikunastu sekund": "A változások néhány másodpercen belül alkalmazásra kerülnek",
        "Zmieniono aktywną wersję": "Az aktív verzió módosítva lett",
        "Zmieniono danę wyktorową": "A vektoradat módosítva lett",
        "Zmieniono kolekcję": "A gyűjtemény módosítva lett",
        "Zmieniono konfigurację list": "A lista konfigurációja módosítva lett",
        "Zmieniono nazwę wersji": "A verzió neve módosítva lett",
        "Zmieniono pola wspólne": "A közös mezők módosítva lettek",
        "Zmieniono powiadomienie weryfikacyjne": "Az ellenőrző értesítés módosítva lett",
        "Zmieniono ustawienia widgetu": "A widget beállításai módosítva lettek",
        "Zmienna środowiskowa została usunięta": "A környezeti változó törölve lett",
        "Zmienna została dodana.": "A változó hozzáadva.",
        "Zmienna została zaktualizowana.": "A változó frissítve lett.",
        "Zmienna została zapisana": "A változó elmentve",
        "zmienną": "változó",
        "Zmienne": "Változók",
        "Zmienne środowiskowe": "Környezeti változók",
        "Zmień hasło": "Jelszó megváltoztatása",
        "Zmień moduł": "Modul módosítása",
        "Zmień nazwę": "Név módosítása",
        "Zmień nazwę katalogu": "Könyvtár nevének módosítása",
        "Zmień nazwę pliku": "Fájl nevének módosítása",
        "Zmień proces dla tego dokumentu": "Folyamat módosítása ehhez a dokumentumhoz",
        "Zmień rozmiar": "Méret módosítása",
        "Zmień status edytowanej wersji": "A szerkesztett verzió státuszának módosítása",
        "Zmień wersję procesu": "Folyamat verziójának módosítása",
        "Zmień widok": "Nézet módosítása",
        "Zmniejsz": "Kicsinyítés",
        "zmodyfikował": "módosította",
        "Zmodyfikował": "Módosította",
        "zmodyfikowany": "módosított",
        "Znajdując odpowiedni formularz...": "Megfelelő űrlap keresése...",
        "znaki": "karakterek",
        "Znaleziono kontrahentów o podanym NIPie.": "A megadott adószámmal rendelkező partnerek megtalálva.",
        "Zobacz sesję użytkownika": "Felhasználó munkamenetének megtekintése",
        "Zobacz szczegóły sesji użytkownika": "Felhasználó munkamenetének részletei",
        "Zobacz szczegóły zdarzenia": "Esemény részleteinek megtekintése",
        "Zobacz wszystkie": "Összes megtekintése",
        "Zobacz wszystkie aktualności": "Összes hír megtekintése",
        "Zobacz wszystkie zastępstwa": "Összes helyettesítés megtekintése",
        "zobaczył/a": "megnézte",
        "Został przywrócony oryginalny harmonogram": "Az eredeti ütemezés visszaállítva",
        "Zresetuj hasło": "Jelszó visszaállítása",
        "Zrestartuj aplikacje": "Alkalmazás újraindítása",
        "Zwektoryzowane": "Vektorizált",
        "Zwektoryzowano": "Vektorizálva",
        "Zwektoryzuj": "Vektorizálás",
        "Zwiń": "Összecsukás",
        "Zwracanie błędów ze skryptów dynamicznego modala": "Dinamikus modal szkriptek hibáinak visszaadása",
        "Zwrócono": "Visszaadva",
        "Zwrócony": "Visszaadott",
        "Zwróć do edycji": "Vissza szerkesztéshez",
        "Zwróć do opisu": "Vissza leíráshoz",
        "Źródła danych": "Adatforrások",
        "Źródła LDAP": "LDAP források",
        "Źródło": "Forrás",
        "Źródło aktywne": "Aktív forrás",
        "Źródło błędu": "Hiba forrása",
        "Źródło danych": "Adatforrás",
        "Źródło danych jest wymagane": "Adatforrás szükséges",
        "źródło danych zostało dodane.": "Az adatforrás hozzáadva.",
        "Źródło danych zostało dodane.": "Az adatforrás hozzáadva.",
        "Źródło danych zostało uruchomione": "Az adatforrás elindítva",
        "Źródło danych zostało zaktualizowane.": "Az adatforrás frissítve lett.",
        "Źródło danych zostało zapisane.": "Az adatforrás elmentve.",
        "Źródło LDAP zostało dodane.": "LDAP forrás hozzáadva.",
        "Źródło LDAP zostało zaktualizowane.": "LDAP forrás frissítve lett.",
        "źródło zostało usunięte.": "A forrás törölve lett.",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "Egyetlen kommunikációs csatorna sem lett engedélyezve az értesítési beállításokban.",
        "Żródło danych": "Adatforrás"
    }
};
